export const unAuthorizedDomain = [
  // "gmail.com",
  // "yahoo.com",
  // "hotmail.com",
  // "outlook.com",
  'proton.me',
  'protonmail.com',
];
export const totalCountry = 149;

export const totalPilots = 11000;

export const globheEmail = 'globhe@globhe.com';

export const uploadInstructions = [
  'You can drag or click on browse files in the green box to upload your data.',
  'The base data should only contain your individual jpg images',
  'To upload the processed data, click on processed data above, and select the product type to upload',
  'It is recommended to upload very large files individually.',
  'Once finished, click on submit data',
];

export const feedbackScreen = {
  all: 'all',
  individual: 'individual',
};

export const baseFilters = {
  'Name/Email': '',
  Country: '',
  Drone: [],
  'Available Locations': [],
  'Sensors/Cameras': [],
  'Minimum Megapixels': 0,
  City: '',
  Insurance: 'all',
  'Overall Rating': 0,
  'Project Management': 0,
  'Data Quality': 0,
  Pricing: 0,
  Communication: 0,
  License: 'all',
  'Registered Company': 'all',
};

export const feedbackLabels = {
  overAllExperience: 'How happy are you with your overall experience for this order?',
  qualityOfService: 'How would you rate the quality of the service you received?',
  qualityOfData: 'How would you rate the quality of the data you received?',
  valueForMoney: 'Do you feel the price you paid for this order was a good value for money?',
  returningLikelihood: 'How likely are you to return to Globhe next time you need such services?',
};

export const feedBackTitle = {
  all: 'Kindly rate your experience for the following orders based on your satisfaction.',
  individual: 'Kindly rate your experience for the following order based on your satisfaction.',
};

export const labels = {
  0.5: 'Very Bad',
  1: 'Bad',
  1.5: 'Poor',
  2: 'Not Good',
  2.5: 'Okay',
  3: 'Good',
  3.5: 'Very Good',
  4: 'Great',
  4.5: 'Amazing',
  5: 'Perfect',
};

export const sideMenuItemsForPilot = {
  Overview: {
    hasSubMenu: false,
    link: '/app/dashboard/info',
  },
  Missions: {
    hasSubMenu: true,
    link: '/app/missions',
    subMenus: {
      'Invited Missions': '/app/missions/invites',
      'Confirmed Missions': '/app/missions/confirmed',
      'Active Missions': '/app/missions/active',
      'Completed Missions': '/app/missions/completed',
      'Missed Missions': '/app/missions/missed',
      'Rejected Missions': '/app/missions/rejected',
    },
  },
  Projects: {
    hasSubMenu: true,
    link: '/app/projects',
    subMenus: {
      'Invited Projects': '/app/pilots/invited/projects',
      'Active Projects': '/app/pilots/all/projects',
      'Completed Projects': '/app/pilots/completed/projects',
    },
  },
  'Sell your data': {
    hasSubMenu: false,
    link: '/app/missions/mission-globhe',
  },
  'Data library': {
    hasSubMenu: true,
    link: '/app/my-profile',
    subMenus: {
      'Map View': '/app/pilot/data-library',
      'My Contributions': '/app/pilot/mylisted-data',
    },
  },
  'My resources': {
    hasSubMenu: true,
    link: '/app/my-profile',
    subMenus: {
      Invoices: '/app/my-profile/invoices',
      Contracts: '/app/my-profile/contracts',
      'Bank Details': '/app/my-profile/bank-details',
    },
  },
  //unmark this code below whenever you want to show promotions and benefits to pilots
  // 'My benefits': {
  //   hasSubMenu: false,
  //   link: '/app/pilots/my-benefits',
  // },
};

export const quoteStatus = {
  accepted: 'Accepted',
  declined: 'Declined',
  quoteSent: 'QuoteSent',
  expired: 'Expired',
  deleted: 'Deleted',
  sendAQuote: 'Send a Quote',
  cancelled: 'Cancelled', // When accepted quote is cancelled by admin
};

export const statusQuote = {
  received: 'RECEIVED',
  notReceived: 'NOT RECEIVED',
};

export const sideMenuItemsForClient = {
  Overview: {
    hasSubMenu: false,
    link: '/app/client/my-account',
  },
  'Single location orders': {
    hasSubMenu: true,
    link: '/app/client/my-orders',
    subMenus: {
      Unconfirmed: '/app/client/orders/reviewing',
      Confirmed: '/app/client/orders/confirm',
      Active: '/app/client/orders/inProgress',
      Completed: '/app/client/orders/completed',
      Cancelled: '/app/client/orders/cancelled',
      Rejected: '/app/client/orders/rejected',
    },
  },
  'Multi-location and recurrent orders': {
    hasSubMenu: true,
    link: '/app/projects',
    subMenus: {
      // 'Pending submission': '/app/client/projects/draft-project',
      Unconfirmed: '/app/client/projects/initial-project',
      Confirmed: '/app/client/projects/confirmed',
      Active: '/app/client/projects/active',
      Completed: '/app/client/projects/completed',
      Cancelled: '/app/client/projects/cancelled',
      // "Create": "/app/order/create-order",
    },
  },
  // 'Grouped Order': {
  //   hasSubMenu: false,
  //   link: '/app/client/group-orders',
  //   anotherWindow: false,
  // },
  'Shared data': {
    hasSubMenu: false,
    link: '/app/client/shared-data',
    anotherWindow: false,
  },
  // Plans: {
  //   hasSubMenu: true,
  //   link: "/subscription",
  //   anotherWindow: false,
  //   subMenus: {
  //     "My plans": "/app/client/plans/my-plans",
  //   },
  // },
  'Data library': {
    hasSubMenu: true,
    link: '/app/client/showDataLibrary',
    anotherWindow: false,
    subMenus: {
      'Browse data': '/app/client/data-library',
      'My purchases': '/app/client/data-library/purchased',
    },
  },
};

export const contractWaiverLabels = {
  accepted: 'Accepted',
  notAccepted: 'Not Accepted',
};

export const sideMenuItemsForProcessingAdmins = {
  Missions: {
    hasSubMenu: false,
    link: '/app/processing/admin/missions/assigned',
  },
  Projects: {
    hasSubMenu: false,
    link: '/app/processing/admin/projects/assigned',
  },
};
export const sideMenuItemsForAdmin = {
  Dashboard: {
    hasSubMenu: true,
    link: '/app/admin/dashboard',
    subMenus: {
      Invoices: '/app/admin/dashboard/invoices',
      Contracts: '/app/admin/dashboard/contracts',
      Analytics: '/app/admin/dashboard/analytics',
    },
  },
  'Drone Operators': {
    hasSubMenu: true,
    link: '/app/pilots',
    subMenus: {
      'Drone Operator Table': '/app/pilots/table',
      'Drone Operator Dashboard': '/app/pilots/dashboard',
    },
  },
  // Mission: {
  //   hasSubMenu: true,
  //   link: "/app/missions",
  //   subMenus: {
  //     initialClientOrder: "/app/missions/initial-client-order",
  //     Unassigned: "/app/missions/unassigned",
  //     Active: "/app/missions/active",
  //     Completed: "/app/missions/completed",
  //     Archive: "/app/missions/archive",
  //     Cancelled: "/app/missions/cancelled",
  //     Rejected: "/app/missions/rejected",
  //     "Create Test Mission": "/app/missions/test-mission",
  //     "Create Challenge Mission": "/app/missions/join-challenge",
  //   },
  // },
  'Client Orders': {
    hasSubMenu: true,
    link: '/app/missions',
    subMenus: {
      initialClientOrder: '/app/missions/client-order/initial-client-order',
      Unassigned: '/app/missions/client-order/unassigned',
      Active: '/app/missions/client-order/active',
      Completed: '/app/missions/client-order/completed',
      Archive: '/app/missions/client-order/archive',
      Cancelled: '/app/missions/client-order/cancelled',
      Rejected: '/app/missions/client-order/rejected',
    },
  },
  Projects: {
    hasSubMenu: true,
    link: '/app/projects',
    subMenus: {
      // 'Pending sub.(Client)': '/app/admin/projects/draft-client-project',
      // 'Pending submission': '/app/admin/projects/draft-project',
      'Unconfirmed Project': '/app/admin/projects/initial-project',
      'Confirmed Project': '/app/admin/projects/confirmed',
      'Active Project': '/app/admin/projects/active',
      'Completed Project': '/app/admin/projects/completed',
      'Archive Project': '/app/admin/projects/archive',
      'Project Site List': '/app/admin/projects/sites-list',
    },
  },
  'Operator Submissions': {
    hasSubMenu: true,
    link: '/app/missions',
    subMenus: {
      Active: '/app/missions/operator-submission/active',
      Completed: '/app/missions/operator-submission/completed',
    },
  },
  'Other Missions': {
    hasSubMenu: true,
    link: '/app/missions',
    subMenus: {
      'Test Missions': '/app/missions/test-missions',
      Challenges: '/app/missions/challenge-missions',
      GWR: '/app/missions/gwr-missions',
      Archive: '/app/missions/archive',
    },
  },
  'Admin Pages': {
    hasSubMenu: true,
    link: '/app/admin',
    subMenus: {
      Admins: '/app/admin/admin-table',
      Clients: '/app/admin/client-enterprise',
      News: '/app/admin/news',
      Inspirations: '/app/admin/inspirations',
      'API Keys': '/app/admin/api-keys',
      'Daily Operation Report': '/app/admin/daily-reports',
      Feedbacks: '/app/admin/feedbacks',
      'DroneDeploy Plans': '/app/admin/dronedeploy-plans',
      'DroneDeploy Exports': '/app/admin/dronedeploy-exports',
    },
  },
  'Tools and resources': {
    hasSubMenu: false,
    link: '/app/admin/tools',
  },
};

export const checkMissionIdUrl = {
  missionUrl: '/app/missions/',
};

export const achivements = ['Globhe Signup', 'Completed First mission', 'First Mission Approved'];

export const admintype = {
  superAdmin: 'Super Admin',
  dataAdmin: 'Data Admin',
  financeAdmin: 'Finance Admin',
  regularAdmin: 'Regular Admin',
  processingAdmin: 'Processing Admin',
};
export const adminTypesInput = ['Super Admin', 'Data Admin', 'Finance Admin', 'Regular Admin', 'Processing Admin'];

export const socialProfileFieldsForPilots = ['Instagram', 'Twitter', 'LinkedIn'];

export const dataLibraryPaymentStatus = {
  pending: 'pending',
  success: 'success',
  fail: 'fail',
  cancel: 'cancel',
};

export const paginationAction = {
  next: 'next',
  prev: 'prev',
};

export const functionStatus = {
  success: 'Success',
  error: 'Error',
};

export const countryProfileStatus = ['Not Allowed', 'Complicated', 'Allowed'];
export const warningCountryStatus = ['Not Allowed', 'Complicated'];

export const missionStatusLabels = {
  initialOrder: 'Initial order', // Also unknown as the un-confirmed order.
  initialClientOrder: 'Initial Client Order',

  // Confirmed Order status
  // Old statuses
  unassigned: 'Unassigned',
  sentToPilots: 'Sent to Pilots',
  declined: 'Declined',
  //new statuses
  confirmedMission: 'Confirmed Order',
  biddingWithQuote: 'Bidding with Quote',
  pilotInvitedForBidding: 'Bidding Started',
  biddingOngoing: 'Bidding Ongoing',
  biddingWithQuote: 'Bidding with Quote',
  biddingEnded: 'Bidding Ended',
  pilotSelected: 'Pilot Selected',
  quoteSentToClient: 'Quote Issued - Client',
  quoteDeclinedByClient: 'Quote Declined',
  quoteReissuedToClient: 'Quote Reissued',
  quoteAcceptedByClient: 'Quote Accepted',

  // Active Order statuses
  // old statuses
  inProgress: 'In Progress',
  delayed: 'Delayed',
  readyToReview: 'Ready to Review',
  correction: 'Correction',
  // new statuses
  pilotAssigned: 'Pilot Assigned',
  feasibleNotCompleted: 'Feasible But not Completed',
  missionNotFeasible: 'Mission Not Feasible',
  flyingDateSet: 'Flying Date Set',
  rescheduled: 'Rescheduled',
  dataProcessing: 'Data Processing',
  dataUploading: 'Data Uploading',
  sentForReviewToGlobhe: 'Sent For Review To Globhe',
  pilotPackageRejected: 'Pilot Package Rejected',
  sentForReviewToClient: 'Sent For Review To Client',
  dataRejectedByClient: 'Data Rejected By Client',
  dataAcceptedByClient: 'Data Accepted By Client',
  //Completed Order stasuses
  completed: 'Completed',
  deleted: 'Deleted',
  archived: 'Archived',
  archive: 'Archived',
  cancelled: 'Cancelled',
  rejected: 'Rejected',
  active: 'Active',
  // missed:"Missed"
  // Just for the admin mission types
  dataAcceptedByGlobhe: 'Data Accepted By Globhe',
};
export const orderCollectionData = {
  missions: 'missions',
  projects: 'projects',
};

export const filterFiledForTeam = [
  {
    label: 'Name/Email',
    value: 'nameEmail',
    type: 'array',
    fieldType: 'input',
  },
];

export const filterFiledForDocuments = [
  {
    label: 'Document name',
    value: 'docName',
    type: 'normalQuery',
    fieldType: 'input',
  },
];

export const filterFieldsForPilotList = [
  //Label dataBaseField typeofFieldinDataBase
  {
    label: 'Name/Email',
    value: 'nameEmail',
    type: 'array',
    fieldType: 'input',
  },
  {
    label: 'Drone',
    value: 'equipment',
    type: 'array',
    fieldType: 'input',
  },
  {
    label: 'Sensors/Cameras',
    value: 'sensorsCameras',
    type: 'array',
    fieldType: 'autoComplete',
    filterFields: ['Thermal', 'Laser (LIDAR)', 'RGB image', 'Multispectral', 'Hyperspectral', 'Ground Data Capture'],
  },
  {
    label: 'Minimum Megapixels',
    value: 'megapixels',
    type: 'normalQuery',
    fieldType: 'input',
  },
  {
    label: 'Insurance',
    value: 'insurance',
    type: 'normalQuery',
    fieldType: 'autoComplete',
    filterFields: ['Yes', 'No'],
  },
  {
    label: 'License',
    value: 'insurance',
    type: 'normalQuery',
    fieldType: 'autoComplete',
    filterFields: ['Yes', 'No'],
  },
  {
    label: 'Registered Company',
    value: 'registeredBusiness',
    type: 'normalQuery',
    fieldType: 'autoComplete',
    filterFields: ['Yes', 'No'],
  },
];

export const filterFieldsForProjectSites = [
  //Label dataBaseField typeofFieldinDataBase
  {
    label: 'Mission Name',
    value: 'searchMissionName',
    type: 'array',
    fieldType: 'input',
  },
  {
    label: 'Project Name',
    value: 'projectNameSearch',
    type: 'array',
    fieldType: 'input',
  },
  {
    label: 'Project Id',
    value: 'projectId',
    type: 'normalQuery',
    fieldType: 'input',
  },
  { label: 'Mission Id', value: 'missionId', type: 'id', fieldType: 'input' },
  {
    label: 'Mission Status',
    value: 'status',
    type: 'normalQuery',
    fieldType: 'autoComplete',
    filterFields: ['draft', 'confirmedMission', 'active', 'archive', 'completed'],
  },
];

export const filterFieldsForPilotProjects = [
  {
    label: 'Project Name',
    value: 'projectNameSearch',
    type: 'normalQuery',
    fieldType: 'input',
  },
  {
    label: 'Project Id',
    value: 'projectId',
    type: 'normalQuery',
    fieldType: 'input',
  },
  {
    label: 'Project Status',
    value: 'status',
    type: 'normalQuery',
    fieldType: 'autoComplete',
    filterFields: ['Active Project', 'Archived Project', 'Deleted Project', 'Bidding Ongoing'],
    valueMapping: {
      'Bidding Ongoing': 'Bidding with Quote',
    },
  },
];
export const filterFieldsForCompletedPilotProjects = [
  {
    label: 'Project Name',
    value: 'projectNameSearch',
    type: 'normalQuery',
    fieldType: 'input',
  },
  {
    label: 'Project Id',
    value: 'projectId',
    type: 'normalQuery',
    fieldType: 'input',
  },
  {
    label: 'Project Status',
    value: 'status',
    type: 'normalQuery',
    fieldType: 'autoComplete',
    filterFields: ['Completed Project'],
    valueMapping: {
      'Bidding Ongoing': 'Bidding with Quote',
    },
  },
];

export const pilotUnConfirmedMissionStatuses = {
  pilotInvitedForBidding: 'Pilot Invited For Bidding',
  biddingOngoing: 'Bidding Ongoing',
  biddingWithQuote: 'Bidding with Quote',
  biddingEnded: 'Bidding Ended',
  pilotSelected: 'Pilot Selected',
};

export const pilotActiveMissionStatuses = {
  pilotAssigned: 'Pilot Assigned',
  missionNotFeasible: 'Mission Not Feasible',
  feasibleNotCompleted: 'Feasible But Not Completed',
  flyingDateSet: 'Flying Date Set',
  rescheduled: 'Rescheduled',
  dataProcessing: 'Data Processing',
  dataUploading: 'Data Uploading',
  sentForReviewToGlobhe: 'Sent For Review To Globhe',
  pilotPackageRejected: 'Pilot Package Rejected',
  sentForReviewToClient: 'Sent For Review To Client',
  dataRejectedByClient: 'Data Rejected By Client',
  dataAcceptedByClient: 'Data Accepted By Client',
};

export const otherMissionStatus = {
  pilotInvitedForBidding: 'Pilot Invited For Bidding',
  biddingOngoing: 'Bidding Ongoing',
  biddingWithQuote: 'Bidding with Quote',
  biddingEnded: 'Bidding Ended',
  pilotSelected: 'Pilot Selected',
  pilotAssigned: 'Pilot Assigned',
  feasibleNotCompleted: 'Feasible But Not Completed',
  missionNotFeasible: 'Mission Not Feasible',
  flyingDateSet: 'Flying Date Set',
  rescheduled: 'Rescheduled',
  dataProcessing: 'Data Processing',
  dataUploading: 'Data Uploading',
  sentForReviewToGlobhe: 'Sent For Review To Globhe',
  pilotPackageRejected: 'Pilot Package Rejected',
  completed: 'Completed',
};
export const operatorSubmissionStatus = {
  dataUploading: 'Data Uploading',
  sentForReviewToGlobhe: 'Sent For Review To Globhe',
  pilotPackageRejected: 'Pilot Package Rejected',
};

export const adminConfirmedMissionStatus = {
  biddingOngoing: 'Bidding Ongoing',
  biddingWithQuote: 'Bidding with Quote',
  biddingEnded: 'Bidding Ended',
  pilotSelected: 'Pilot Selected',
  quoteSentToClient: 'Quote Sent To Client',
  quoteDeclinedByClient: 'Quote Declined By Client',
  quoteReissuedToClient: 'Quote Reissued To Client',
  quoteAcceptedByClient: 'Quote Accepted By Client',
};

export const clientConfirmedMissionStatus = {
  biddingOngoing: 'Bidding Ongoing',
  biddingWithQuote: 'Bidding with Quote',
  quoteSentToClient: 'Quote Received',
  quoteDeclinedByClient: 'Quote Declined',
  quoteReissuedToClient: 'Quote Reissued',
  quoteAcceptedByClient: 'Quote Accepted',
};

export const adminActiveMissionStatus = {
  pilotAssigned: 'Pilot Assigned',
  feasibleNotCompleted: 'Feasible But Not Completed',
  missionNotFeasible: 'Mission Not Feasible',
  flyingDateSet: 'Flying Date Set',
  rescheduled: 'Rescheduled',
  dataProcessing: 'Data Processing',
  dataUploading: 'Data Uploading',
  sentForReviewToGlobhe: 'Sent For Review To Globhe',
  pilotPackageRejected: 'Pilot Package Rejected',
  sentForReviewToClient: 'Sent For Review To Client',
  dataRejectedByClient: 'Data Rejected By Client',
  dataAcceptedByClient: 'Data Accepted By Client',
};

export const clientActiveMissionStatus = {
  pilotAssigned: 'Pilot Assigned',
  missionNotFeasible: 'Mission Not Feasible',
  flyingDateSet: 'Flying Date Set',
  rescheduled: 'Rescheduled',
  feasibleNotCompleted: 'Feasible But Not Completed',
  dataProcessing: 'Data Processing',
  // dataUploading: "Data Uploading",
  sentForReviewToGlobhe: 'Sent For Review To Globhe',
  sentForReviewToClient: 'Sent For Review To Client',
  dataRejectedByClient: 'Data Rejected By Client',
  dataAcceptedByClient: 'Data Accepted By Client',
};

export const testMissionStatus = ['Waiting for Upload', 'Waiting for Approval', 'Unassigned', 'Completed'];
export const expireQuoteDays = 7;
export const missionTypes = [
  'Client Order',
  'Operator Submission',
  'Guinness World Records',
  'Challenge Mission',
  'Test Mission',
];
export const missionTypesCreatedByAdmin = [
  'Guinness World Records',
  'Challenge Mission',
  'Test Mission',
  'Client Order',
];
export const projectTypes = [
  'Client Order',
  'Operator Submission',
  'Guinness World Records',
  'Challenge Mission',
  'Test Mission',
];

export const archiveMissionTypes = [
  'Initial Client Order',
  'Confirmed Client Order',
  'Active Missions',
  'Operator Submission',
  'Guinness World Records',
  'Challenge Mission',
  'Test Mission',
];
export const termAcceptStatus = {
  locked: 'LOCKED',
  registered: 'REGISTERED',
};

export const weekDayNumber = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

export const fileProcessedStatus = {
  completed: 'completed',
  uploaded: 'uploaded',
  failed: 'failed',
};

export const ModelCSVUrl =
  'https://firebasestorage.googleapis.com/v0/b/globhe-app.appspot.com/o/modelCSV%2Fmodel%20CSVFormat.csv?alt=media&token=ee6a1364-9245-4759-9ef6-ceeebad9712a';

export const adminMissionType = ['Guinness World Records', 'Challenge Mission', 'Test Mission', 'Operator Submission'];

export const missionTypeConstant = {
  clientOrder: 'Client Order',
  operatorSubmission: 'Operator Submission',
  guinnessWorldRecord: 'Guinness World Records',
  challengeMission: 'Challenge Mission',
  testMission: 'Test Mission',
  projectMission: 'Project Mission',
};

export const groupOrderMissionTypeConstant = {
  singleOrder: 'Single Order',
  multiOrder: 'Multi Order',
  recurrentOrder: 'Recurrent Order',
};

export const subscriptionStatus = {
  subscribed: 'Subscribed',
  notSubscribed: 'Not Subcribed',
};

export const clientFeedbackFieldsSL = [
  {
    id: 'missionName',
    label: 'Name/Id',
    field: 'capital',
  },
  {
    id: 'locationLabel',
    label: 'Location',
    field: 'normal',
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    field: 'date',
  },
  {
    id: 'mapTypes',
    label: 'Deliverables',
    field: 'array',
  },
  {
    id: 'overAllExperience',
    label: 'Overall Experience',
    custom: true,
    field: 'actionRatingSL',
  },
];

export const clientFeedbackFieldsML = [
  {
    id: 'projectName',
    label: 'Name/Id',
    field: 'capital',
  },
  {
    id: 'description',
    label: 'Description',
    field: 'normal',
  },
  {
    id: 'createdAt',
    label: 'Date Created',
    field: 'date',
  },
  {
    id: 'mapTypes',
    label: 'Deliverables',
    field: 'array',
  },
  {
    id: 'overAllExperience',
    label: 'Overall Experience',
    custom: true,
    field: 'actionRatingSL',
  },
];

export const sampleOperatorCsvFile =
  'https://firebasestorage.googleapis.com/v0/b/globhe-app.appspot.com/o/Drone_operator_CSV%20_format.csv?alt=media&token=b68ef649-b664-443d-ac60-8e6e37e07984';

export const allCountries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas (the)',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia (Plurinational State of)',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory (the)',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cayman Islands (the)',
  'Central African Republic (the)',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands (the)',
  'Colombia',
  'Comoros (the)',
  'Congo (the Democratic Republic of the)',
  'Congo (the)',
  'Cook Islands (the)',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czechia',
  "Côte d'Ivoire",
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic (the)',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Falkland Islands (the) [Malvinas]',
  'Faroe Islands (the)',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories (the)',
  'Gabon',
  'Gambia (the)',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (the)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran (Islamic Republic of)',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea (the Democratic People's Republic of)",
  'Korea (the Republic of)',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic Republic (the)",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands (the)',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia (Federated States of)',
  'Moldova (the Republic of)',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands (the)',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger (the)',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands (the)',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine, State of',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines (the)',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Republic of North Macedonia',
  'Romania',
  'Russian Federation (the)',
  'Rwanda',
  'Réunion',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan (the)',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan (Province of China)',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands (the)',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates (the)',
  'United Kingdom of Great Britain and Northern Ireland (the)',
  'United States Minor Outlying Islands (the)',
  'United States of America (the)',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela (Bolivarian Republic of)',
  'Viet Nam',
  'Virgin Islands (British)',
  'Virgin Islands (U.S.)',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
  'Åland Islands',
];

export const filterFiledForEnterprises = [
  {
    label: 'Enterprise name/Email',
    value: 'name',
    type: 'normalQuery',
    fieldType: 'input',
  },
  {
    label: 'Country',
    value: 'location',
    type: 'string',
    fieldType: 'autoComplete',
    filterFields: [...allCountries],
  },
];

export const columnForListingAllClients = [
  { id: 'name', label: 'Name', align: 'left', field: 'capital', sort: false },
  {
    id: 'companyName',
    label: 'Organization',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'location',
    label: 'Country',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'statusClient',
    custom: true,
    sort: false,
  },
  {
    id: 'docUrl',
    label: '',
    align: 'center',
    field: 'viewInNew',
    newPage: true,
    sort: false,
  },
];

export const columnForListingClientsAllProjects = [
  {
    id: 'projectName',
    label: 'Name/ID',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'country',
    label: 'Country',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'createdAt',
    label: 'Created on',
    align: 'left',
    field: 'date',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'projectStatus',
    sort: false,
  },
];

export const columnForListingClientsAllSingleOrders = [
  {
    id: 'missionName',
    label: 'Name/ID',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'assignedPilotName',
    label: 'Operator',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Created on',
    align: 'left',
    field: 'date',
    sort: false,
  },
  {
    id: 'deadline',
    label: 'Delivery on',
    align: 'left',
    field: 'date',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'ProjectStatusBadge',
    sort: false,
  },
  {
    id: 'paymentStatusClient',
    label: 'Payment status',
    align: 'left',
    field: 'clientPaymentStatus',
    sort: false,
  },
];

export const columnForCurrentSubscribedMissions = [
  {
    id: 'id',
    label: 'Order ID #',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Order Date',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
  },
];
export const columnForClientReviewingMission = [
  {
    id: 'id',
    label: 'Order ID #',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'missionName',
    label: 'Order Name',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  // {
  //   id: "xyz",
  //   label: "Quote",
  //   align: "left",
  //   field: "quote",
  //   sort: false,
  // },
];
export const columnForClientInProcessMission = [
  {
    id: 'id',
    label: 'Order ID #',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'missionName',
    label: 'Order Name',
    align: 'left',
    field: 'capital',
    sort: true,
  },
  {
    id: 'dateCreated',
    label: 'Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
    custom: true,
  },
];
export const columnForClientCompletedMission = [
  {
    id: 'id',
    label: 'Order ID #',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'missionName',
    label: 'Order Name',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'dateCompleted',
    label: 'Date Completed',
    align: 'left',
    field: 'seconds',
    sort: true,
  },
];
export const columnForClientCancelledMission = [
  {
    id: 'id',
    label: 'Order ID #',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'missionName',
    label: 'Order Name',
    align: 'left',
    field: 'capital',
    sort: true,
  },
  {
    id: 'dateCreated',
    label: 'Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  // Not needed in the new view.
  // {
  //   id: "xyz",
  //   label: "Quote",
  //   align: "left",
  //   field: "quote",
  //   sort: false,
  // },
];
export const columnForClientRejectedMission = [
  {
    id: 'id',
    label: 'Order ID #',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'missionName',
    label: 'Order Name',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'rejectionNote',
    label: 'Reason',
    align: 'left',
    field: 'reject',
    sort: false,
  },
];

export const columnForClientGroupOrder = [
  {
    id: 'missionName',
    label: 'Mission Name',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['missionName', 'id'],
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Created',
    align: 'left',
    field: 'date',
    custom: true,
    sort: false,
  },
  {
    id: 'deadline',
    label: 'Deadline',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
    custom: true,
  },
];
export const columnsForProjectMissions = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'missionName',
  },
  {
    id: 'assignedPilotName',
    label: 'Operator',
    align: 'left',
    field: 'Avatar',
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
  },
];

export const columnsForProjectAddedMissions = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'missionName',
  },
  {
    id: 'assignedPilotName',
    label: 'Operator',
    align: 'left',
    field: 'Avatar',
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
  },
  {
    id: 'paymentStatusPilot',
    label: 'Payment Status',
    align: 'left',
    field: 'paymentStatus',
  },
];

export const columnForContractAdmin = [
  {
    id: 'mission',
    label: 'Mission / Project Name',
    align: 'left',
    field: 'mission_project_mixed',
    mixedColumns: ['missionName', 'projectName', 'id'],
    sort: false,
  },
  {
    id: 'pilotName',
    label: 'Pilot',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'pilotDeadline',
    label: 'Pilot Deadline',
    align: 'left',
    field: 'dateTwo',
    sort: false,
  },
  {
    id: 'missionDeadline',
    label: 'Mission Deadline',
    align: 'left',
    field: 'date',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    custom: true,
    sort: false,
  },
];

export const columnForContractPilot = [
  {
    id: 'mission',
    label: 'Mission / Project Name',
    align: 'left',
    field: 'mission_project_mixed',
    mixedColumns: ['missionName', 'projectName', 'id'],
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: false,
  },
  {
    id: 'pilotDeadline',
    label: 'Pilot Deadline',
    align: 'left',
    field: 'dateTwo',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    custom: true,
    sort: false,
  },
];

export const columnForInvoice = [
  {
    id: 'mission',
    label: 'Mission / Project Name',
    align: 'left',
    field: 'mission_project_mixed',
    mixedColumns: ['mission_name', 'projectName', 'id'],
    sort: false,
  },
  {
    id: 'amount',
    label: 'Amount',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Issue Date',
    align: 'left',
    field: 'date',
    sort: false,
  },
  {
    id: 'due_date',
    label: 'Due Date',
    align: 'left',
    field: 'dateTwo',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
    custom: true,
  },
];

export const columnForInvoiceAdmin = [
  {
    id: 'mission',
    label: 'Mission / Project',
    align: 'left',
    field: 'mission_project_mixed',
    mixedColumns: ['mission_name', 'projectName', 'id'],
    sort: false,
  },
  {
    id: 'pilotName',
    label: 'Pilot',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'amount',
    label: 'Amount',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Issue Date',
    align: 'left',
    field: 'date',
    sort: false,
  },
  {
    id: 'due_date',
    label: 'Due Date',
    align: 'left',
    field: 'dateTwo',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
    custom: true,
  },
];

export const assignPilotForMissionColumn = [
  {
    id: 'name',
    label: 'Name/ID',
    align: 'left',
    field: 'profileIdentifierWithId',
    mixedColumns: ['name', 'profileImageURL', 'id'],
    sort: false,
  },
  {
    id: 'email',
    label: 'Email',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'location',
    label: 'Country',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'status',
    label: 'Action',
    align: 'left',
    field: 'button',
    sort: false,
    custom: true,
  },
];

export const draftMissionForPilotColumn = [
  {
    id: 'viewUrl',
    label: 'Name/ID',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['missionName', 'id'],
  },
  {
    id: 'assignedPilotName',
    label: 'Operator',
    align: 'left',
    field: 'profileIdentifier',
    mixedColumns: ['assignedPilotName', 'assignedPilotProfileUrl'],
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'ProjectStatusBadge',
    sort: false,
  },
  {
    id: 'status',
    label: 'Action',
    align: 'left',
    field: 'action',
    sort: false,
    custom: true,
  },
];

export const siteEvaluationTableForAdmin = [
  {
    id: 'viewUrl',
    label: 'Site Id',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['missionName', 'id'],
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'ProjectStatusBadge',
    sort: false,
  },
  {
    id: 'assignedPilotName',
    label: 'Operator',
    align: 'left',
    field: 'profileIdentifier',
    mixedColumns: ['assignedPilotName', 'assignedPilotProfileUrl'],
    sort: false,
  },
  {
    id: 'siteFeasibility',
    label: 'Site feasibility',
    align: 'left',
    field: 'siteFeasibility',
    sort: false,
    custom: true,
  },
  {
    id: 'flightDate',
    label: 'Flying Date',
    align: 'left',
    field: 'flightDate',
    sort: false,
    custom: true,
  },
  {
    id: 'isVisited',
    label: 'Is Visited',
    align: 'left',
    field: 'isVisited',
    sort: false,
    custom: true,
  },
];
export const siteEvaluationTableForPilot = [
  {
    id: 'viewUrl',
    label: 'Site Id',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['missionName', 'id'],
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'ProjectStatusBadge',
    sort: false,
  },
  {
    id: 'siteFeasibility',
    label: 'Site feasibility',
    align: 'left',
    field: 'siteFeasibility',
    sort: false,
    custom: true,
  },
  {
    id: 'flightDate',
    label: 'Flying Date',
    align: 'left',
    field: 'flightDate',
    sort: false,
    custom: true,
  },
  {
    id: 'isVisited',
    label: 'Is Visited',
    align: 'left',
    field: 'isVisited',
    sort: false,
    custom: true,
  },
];

export const siteEvaluationCSVTableForAdmin = [
  {
    id: 'viewUrl',
    label: 'Site Name/Id',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['name', 'id'],
  },
  {
    id: 'latitude',
    label: 'Site Latitude',
    align: 'left',
    field: 'siteLatitude',
    sort: false,
    custom: true,
  },
  {
    id: 'longitude',
    label: 'Site Longitude',
    align: 'left',
    field: 'siteLongitude',
    sort: false,
    custom: true,
  },
  {
    id: 'assignedPilotName',
    label: 'Operator',
    align: 'left',
    field: 'operator',
    sort: false,
    custom: true,
  },
  {
    id: 'siteFeasibility',
    label: 'Site feasibility',
    align: 'left',
    field: 'siteFeasibility',
    sort: false,
    custom: true,
  },
  {
    id: 'flightDate',
    label: 'Flying Date',
    align: 'left',
    field: 'flightDate',
    sort: false,
    custom: true,
  },
  {
    id: 'isVisited',
    label: 'Is Visited',
    align: 'left',
    field: 'isVisited',
    sort: false,
    custom: true,
  },
];

export const siteEvaluationCSVTableForPilot = [
  {
    id: 'viewUrl',
    label: 'Site Name/Id',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['name', 'id'],
  },
  {
    id: 'latitude',
    label: 'Site Latitude',
    align: 'left',
    field: 'siteLatitude',
    sort: false,
    custom: true,
  },
  {
    id: 'longitude',
    label: 'Site Longitude',
    align: 'left',
    field: 'siteLongitude',
    sort: false,
    custom: true,
  },
  {
    id: 'assignedPilotName',
    label: 'Operator',
    align: 'left',
    field: 'operator',
    sort: false,
    custom: true,
  },
  {
    id: 'siteFeasibility',
    label: 'Site feasibility',
    align: 'left',
    field: 'siteFeasibility',
    sort: false,
    custom: true,
  },
  {
    id: 'flightDate',
    label: 'Flying Date',
    align: 'left',
    field: 'flightDate',
    sort: false,
    custom: true,
  },
  {
    id: 'isVisited',
    label: 'Is Visited',
    align: 'left',
    field: 'isVisited',
    sort: false,
    custom: true,
  },
];

export const teamsTableClient = [
  {
    id: 'name',
    label: 'Member',
    align: 'left',
    sort: false,
    field: 'profileIdentifierWithId',
    mixedColumns: ['name', 'profileImageURL', 'location'],
  },
  {
    id: 'email',
    label: 'Email address',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'type',
    label: 'Team',
    align: 'left',
    field: 'arrayBox',
    sort: false,
  },
  {
    id: 'selector',
    label: 'Permission',
    align: 'left',
    field: 'selector',
    custom: 'true',
    sort: false,
  },
  {
    id: 'viewUrl',
    label: '',
    align: 'center',
    field: 'view',
    sort: false,
  },
  {
    id: 'menu',
    label: '',
    align: 'left',
    field: 'menuBar',
    custom: true,
    sort: false,
  },
];

export const teamsTableAdmin = [
  {
    id: 'name',
    label: 'Member',
    align: 'left',
    sort: false,
    field: 'profileIdentifierWithId',
    mixedColumns: ['name', 'profileImageURL', 'location'],
  },
  {
    id: 'email',
    label: 'Email address',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'type',
    label: 'Team',
    align: 'left',
    field: 'arrayBox',
    sort: false,
  },
  {
    id: 'selector',
    label: 'Permission',
    align: 'left',
    field: 'selector',
    custom: 'true',
    sort: false,
  },
  {
    id: 'viewUrl',
    label: '',
    align: 'center',
    field: 'view',
    sort: false,
  },
];

export const documentTable = [
  {
    id: 'docName',
    label: 'Document name',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'lastUpdated',
    label: 'Updated date',
    align: 'left',
    field: 'date',
    sort: false,
  },
  {
    id: 'docUrl',
    label: '',
    align: 'center',
    field: 'viewInNew',
    newPage: true,
    sort: false,
  },
  {
    id: 'menu',
    label: '',
    align: 'left',
    field: 'menuBar',
    custom: true,
    sort: false,
  },
];

export const enterpriseTable = [
  {
    id: 'companyName',
    label: 'Company name',
    align: 'left',
    sort: false,
    field: 'profileIdentifierWithId',
    mixedColumns: ['name', 'companyImageUrl', 'location'],
  },
  {
    id: 'email',
    label: 'Email',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'noOfMembers',
    label: 'Members',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'viewUrl',
    label: '',
    align: 'center',
    field: 'viewInNew',
    newPage: true,
    sort: false,
  },
  // {
  //   id: "menu",
  //   label: "",
  //   align: "left",
  //   field: "menuBar",
  //   custom: true,
  //   sort: false,
  // },
];

export const missionForPilotColumn = [
  {
    id: 'viewUrl',
    label: 'Name/ID',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['missionName', 'id'],
  },
  {
    id: 'assignedPilotName',
    label: 'Operator',
    align: 'left',
    field: 'profileIdentifier',
    mixedColumns: ['assignedPilotName', 'assignedPilotProfileUrl'],
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'ProjectStatusBadge',
    sort: false,
  },
];

export const columnForDroneOperators = [
  { id: 'name', label: 'Name', align: 'left', field: 'capital', sort: true },
  { id: 'email', label: 'Email', align: 'left', field: 'normal', sort: false },
  {
    id: 'location',
    label: 'Country',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  { id: 'city', label: 'City', align: 'left', field: 'normal', sort: false },
  {
    id: 'equipment',
    label: 'Drones',
    align: 'left',
    field: 'array',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Signed Up',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'rating',
    label: 'Rating',
    align: 'left',
    field: 'rating',
    custom: true,
    sort: false,
  },
];

export const columnForDroneOperatorsInviteCountry = [
  ...columnForDroneOperators.filter((column) => column.id !== 'dateCreated'),
  {
    id: 'inviteButton',
    label: 'Invite',
    align: 'left',
    field: 'invite',
    custom: true,
  },
];
export const columnForAdminUnassignedMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'companyName',
    label: 'Client',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
    custom: true,
  },
];

export const columnForPilotInquiriesMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'missionType',
    label: 'Mission Type',
    align: 'left',
    field: 'normal',
    sort: false,
  },
];
export const columnForPilotMissedMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: false,
  },
  {
    id: 'missionType',
    label: 'Mission Type',
    align: 'left',
    field: 'normal',
    sort: false,
  },
];

export const columnForAdminActiveMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'companyName',
    label: 'Client',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'dateThree',
    sort: true,
  },
  {
    id: 'assignedPilotName',
    label: 'Drone Operator',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
    custom: true,
  },
];

export const columnForAdminClientActiveMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'companyName',
    label: 'Client',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'assignedPilotName',
    label: 'Drone Operator',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'clientOrderStatus',
    sort: false,
    custom: true,
  },
];

export const columnForAdminTestMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: true,
  },
  {
    id: 'companyName',
    label: 'Client',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'assignedPilotName',
    label: 'Drone Operator',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
    custom: true,
  },
];

export const columnForAdminGwrMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: false,
  },
  {
    id: 'assignedPilotName',
    label: 'Drone Operator',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
    custom: true,
  },
];

export const columnForAdminOperatorSubActiveMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'assignedPilotName',
    label: 'Drone Operator',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
    custom: true,
  },
];

export const columnForPilotActiveMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'missionType',
    label: 'Mission Type',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
    custom: true,
  },
];

export const columnForAdminCompletedMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'companyName',
    label: 'Client',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'assignedPilotName',
    label: 'Drone Operator',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'status',
    label: 'Payment Status',
    align: 'left',
    field: 'paymentStatus',
    sort: false,
    custom: true,
  },
];

export const columnForAdminOperatoeSubCompletedMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'assignedPilotName',
    label: 'Drone Operator',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'status',
    label: 'Payment Status',
    align: 'left',
    field: 'paymentStatus',
    sort: false,
    custom: true,
  },
];

export const columnForPilotCompletedMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'missionType',
    label: 'Mission Type',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateUpdated',
    label: 'Submitted On',
    align: 'left',
    field: 'date',
    sort: false,
  },
  {
    id: 'paymentStatusClient',
    label: 'Invoice Status',
    align: 'left',
    field: 'clientPaymentStatus',
    sort: false,
    custom: true,
  },
];
export const columnForPilotRejectedMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'missionType',
    label: 'Mission Type',
    align: 'left',
    field: 'normal',
    sort: false,
  },
];
export const columnForAdminRejectedMission = [
  {
    id: 'missionName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'missionType',
    label: 'Mission Type',
    align: 'left',
    field: 'normal',
    sort: false,
  },
];

export const columnForAdminDraftProjects = [
  {
    id: 'projectName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: true,
  },
  {
    id: 'country',
    label: 'Country',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  // {
  //   id: "clientName",
  //   label: "Client",
  //   align: "left",
  //   field: "normal",
  //   sort: false,
  // },
  {
    id: 'clientCompanyName',
    label: 'Company Name',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'createdAt',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
    custom: true,
  },
];

export const columnForClientProjects = [
  {
    id: 'projectName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: true,
  },
  {
    id: 'country',
    label: 'Country',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'createdAt',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'projectStatus',
    sort: false,
    // custom: true,
  },
];

export const columnForProjectSites = [
  {
    id: 'missionName',
    label: 'Site Name',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['missionName', 'id'],
  },
  {
    id: 'projectName',
    label: 'Project Name',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'deadline',
    label: 'Deadline',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'statusBadge',
    sort: false,
  },
  {
    id: 'assignedPilotName',
    label: 'Drone Operator',
    field: 'profileIdentifier',
    align: 'left',
    mixedColumns: ['userName', 'profileImageURL'],
    sort: false,
  },
];
export const columnForClientCollaberatedOrders = [
  {
    id: 'missionName',
    label: 'Mission Name',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
];
export const AdminMissionsColumns = [
  { id: 'missionName', label: 'Name/Id', align: 'left', sort: false },
  { id: 'companyName', label: 'Client', align: 'left', sort: false },
  { id: 'locationLabel', label: 'Location', align: 'left', sort: false },
  { id: 'deadline', label: 'Deadline', align: 'left', sort: false },
  {
    id: 'assignedPilotName',
    label: 'Drone Operator',
    align: 'left',
    sort: false,
  },
  { id: 'missionType', label: 'Mission Type', align: 'left', sort: false },
  { id: 'status', label: 'Status', align: 'left', sort: false },
];
export const columnsForApiKeys = [
  {
    id: 'company',
    label: 'Company',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'documentId',
    label: 'API Key',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Requested',
    align: 'left',
    field: 'date',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'statusBadge',
    sort: false,
  },
];

export const columnsForDailyReport = [
  {
    id: 'missionDate',
    label: 'Mission Date',
    align: 'left',
    field: 'dateTimeStamp',
    sort: false,
  },
  {
    id: 'province',
    label: 'Province',
    align: 'left',
    field: 'array',
    sort: false,
    bold: true,
  },
  {
    id: 'reportType',
    label: 'Type',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  { id: 'name', label: 'Name', align: 'left', field: 'normal', sort: false },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
    custom: true,
  },
];
export const columnForInvitedPilot = [
  {
    id: 'name',
    label: 'Name',
    align: 'left',
    field: 'pilotWithRating',
    sort: false,
  },
  {
    id: 'location',
    label: 'Country',
    align: 'left',
    field: 'flag',
    sort: false,
  },
  {
    id: 'dateInvited',
    label: 'Date Invited',
    align: 'left',
    field: 'dateInvited',
    sort: true,
  },
  { id: 'state', label: 'Status', align: 'left', field: 'status', sort: false },
  {
    id: 'state',
    label: 'Reason for Rejection',
    align: 'left',
    field: 'reasonForRejection',
    sort: false,
  },
  {
    id: '',
    label: '',
    align: 'left',
    field: 'reject',
    sort: false,
  },
];
export const columnForAssignedPilot = [
  {
    id: 'name',
    label: 'Name',
    align: 'left',
    field: 'avtar',
    sort: false,
  },
  {
    id: 'location',
    label: 'Country',
    align: 'left',
    field: 'flag',
    sort: false,
  },
  // {
  //   id: "price",
  //   label: "Price in USD",
  //   align: "left",
  //   field: "price",
  //   sort: true,
  // },
  {
    id: 'state',
    label: 'Waive Contract',
    align: 'left',
    field: 'waiveButton',
    sort: false,
  },
  {
    id: 'state',
    label: 'May Edit Invoice',
    align: 'left',
    field: 'editInvoicebutton',
    sort: false,
  },
  {
    id: '',
    label: '',
    align: 'left',
    field: 'unassign',
    sort: false,
  },
];

export const columnForProjectMissionAssignedPilot = [
  {
    id: 'name',
    label: 'Name',
    align: 'left',
    field: 'avtar',
    sort: false,
  },
  {
    id: 'location',
    label: 'Country',
    align: 'left',
    field: 'flag',
    sort: false,
  },
  // {
  //   id: "price",
  //   label: "Price in USD",
  //   align: "left",
  //   field: "price",
  //   sort: true,
  // },
  {
    id: 'state',
    label: 'May Edit Invoice',
    align: 'left',
    field: 'editInvoicebutton',
    sort: false,
  },
  {
    id: '',
    label: '',
    align: 'left',
    field: 'unassign',
    sort: false,
  },
];
export const columnForIntrestedPilot = [
  {
    id: 'pilotName',
    label: 'Name',
    align: 'left',
    field: 'pilotWithRating',
    sort: false,
  },
  {
    id: 'location',
    label: 'Country',
    align: 'left',
    field: 'flag',
    sort: false,
  },
  {
    id: 'price',
    label: 'Price in USD',
    align: 'left',
    field: 'price',
    sort: false,
  },
  {
    id: 'state',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
  },
  // {
  //   id: "declinedReasonPilot",
  //   label: "Reason for Rejection",
  //   align: "left",
  //   field: "reasonForRejection",
  //   sort: false,
  // },
  {
    id: '',
    label: 'Approve',
    align: 'left',
    field: 'approve',
    sort: false,
  },
];

export const columnForInterestWithoutPrice = [
  {
    id: 'pilotName',
    label: 'Name',
    align: 'left',
    field: 'avtar',
    sort: false,
  },
  {
    id: 'location',
    label: 'Country',
    align: 'left',
    field: 'flag',
    sort: false,
  },
  {
    id: 'state',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
  },
  {
    id: '',
    label: 'Approve',
    align: 'left',
    field: 'approve',
    sort: false,
  },
];

export const subscriptionPaymentStatus = {
  started: 'started',
  pending: 'pending',
  success: 'success',
  failed: 'failed',
  rejected: 'rejected',
};

export const paymentType = {
  purchased: 'purchased',
  renewed: 'renewed',
  upgrade: 'upgrade',
};

export const columnForAlreadyIntrestedPilot = [
  {
    id: 'pilotName',
    label: 'Name',
    align: 'left',
    field: 'avtar',
    sort: true,
  },
  {
    id: 'location',
    label: 'Country',
    align: 'left',
    field: 'flag',
    sort: false,
  },
  {
    id: 'price',
    label: 'Price in USD',
    align: 'left',
    field: 'price',
    sort: false,
  },
  {
    id: 'state',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
  },
];

export const columnsForFeedbacks = [
  {
    id: 'name',
    label: 'Name',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'company',
    label: 'Company',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date Created',
    align: 'left',
    field: 'date',
    sort: false,
  },
  {
    id: 'ratings',
    label: 'Ratings',
    align: 'left',
    field: 'ratings',
    sort: false,
    custom: true,
  },
];

export const projectColumnForPilots = [
  {
    id: 'projectName',
    label: 'Project Name',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['projectName', 'id'],
  },
  {
    id: 'mapTypes',
    label: 'Map Types',
    align: 'left',
    field: 'array',
    sort: false,
  },
  {
    id: 'deadline',
    label: 'Deadline',
    align: 'left',
    field: 'normal',
    sort: true,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'statusBadge',
    sort: false,
  },
];

export const projectDroneOperatorColumn = [
  {
    id: 'name',
    label: 'Name',
    align: 'left',
    field: 'profileIdentifierWithEmail',
    mixedColumns: ['userName', 'profileImageURL', 'email'],
    sort: false,
  },
  {
    id: 'location',
    label: 'location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'city',
    label: 'City',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dailyCharge',
    label: 'Rate USD',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'missionStatus',
    sort: false,
    custom: true,
  },
  {
    id: 'viewUrl',
    label: 'View details',
    align: 'left',
    field: 'view',
    sort: false,
    // custom: true,
  },
];

export const downloadProjectMissionColumn = [
  {
    id: 'viewUrl',
    label: 'Mission Name',
    align: 'left',
    field: 'mixed_url',
    sort: false,
    mixedColumns: ['missionName', 'id'],
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'ProjectStatusBadge',
    sort: false,
  },
  {
    id: 'orderType',
    label: 'Site type',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'assignedPilotName',
    label: 'Operator',
    align: 'left',
    field: 'profileIdentifier',
    mixedColumns: ['userName', 'profileImageURL'],
    sort: false,
  },
  {
    id: 'deadline',
    label: 'Deadline',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'download',
    label: 'Download',
    align: 'left',
    field: 'download',
    sort: false,
    // custom: true,
  },
];

export const projectMissionColumn = [
  {
    id: 'viewUrl',
    label: 'Site Name',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['missionName', 'id'],
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'ProjectStatusBadge',
    sort: false,
  },
  {
    id: 'deadline',
    label: 'Deadline',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'assignedPilotName',
    label: 'Operator',
    align: 'left',
    field: 'profileIdentifier',
    mixedColumns: ['assignedPilotName', 'profileImageURL'],
    sort: false,
  },
  {
    id: 'bid',
    label: 'View Bids',
    align: 'left',
    field: 'viewBids',
    custom: true,
    sort: false,
  },
  {
    id: 'inviteButton',
    label: 'Invite',
    align: 'left',
    field: 'invite',
    custom: true,
  },
];

export const activeProjectMissionColumn = [
  {
    id: 'viewUrl',
    label: 'Site Name',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['missionName', 'id'],
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'ProjectStatusBadge',
    sort: false,
  },
  {
    id: 'deadline',
    label: 'Deadline',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'assignedPilotName',
    label: 'Operator',
    align: 'left',
    field: 'profileIdentifier',
    mixedColumns: ['assignedPilotName', 'profileImageURL'],
    sort: false,
  },
  {
    id: 'inviteButton',
    label: 'Invite',
    align: 'left',
    field: 'invite',
    custom: true,
  },
];

export const projectMissionColumnForClient = [
  {
    id: 'viewUrl',
    label: 'Site Name',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['missionName', 'id'],
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'ProjectStatusBadge',
    sort: false,
  },
  {
    id: 'deadline',
    label: 'Deadline',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  // {
  //   id: 'assignedPilotName',
  //   label: 'Operator',
  //   align: 'left',
  //   field: 'profileIdentifier',
  //   mixedColumns: ['assignedPilotName', 'profileImageURL'],
  //   sort: false,
  // },
  // {
  //   id: 'bid',
  //   label: 'View Bids',
  //   align: 'left',
  //   field: 'viewBids',
  //   custom: true,
  //   sort: false,
  // },
];
export const activeProjectMissionColumnForClient = [
  {
    id: 'viewUrl',
    label: 'Site Name',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['missionName', 'id'],
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'ProjectStatusBadge',
    sort: false,
  },
  {
    id: 'deadline',
    label: 'Deadline',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  // {
  //   id: 'assignedPilotName',
  //   label: 'Operator',
  //   align: 'left',
  //   field: 'profileIdentifier',
  //   mixedColumns: ['assignedPilotName', 'profileImageURL'],
  //   sort: false,
  // },
];
export const activeProjectMissionColumnForPilots = [
  {
    id: 'viewUrl',
    label: 'Site Name',
    align: 'left',
    field: 'mixed',
    sort: false,
    mixedColumns: ['missionName', 'id'],
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'ProjectStatusBadge',
    sort: false,
  },
  {
    id: 'deliveryDeadline',
    label: 'Deadline',
    align: 'left',
    field: 'normal',
    sort: false,
  },
];

export const multiLocaitonMissionCol = [
  {
    id: 'missionName',
    label: 'Mission name',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'areaSize',
    label: 'Area size',
    align: 'left',
    field: 'areaSize',
    custom: true,
    sort: false,
  },
  {
    id: 'action',
    label: 'Action',
    align: 'left',
    field: 'action',
    custom: true,
    sort: false,
  },
];

export const multiLocaitonSummaryMissionCol = [
  {
    id: 'missionName',
    label: 'Mission name',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'areaSize',
    label: 'Area size',
    align: 'left',
    field: 'areaSize',
    custom: true,
    sort: false,
  },
];

export const columnForUnassignedPilotInterestAdmin = [
  {
    id: 'pilotName',
    label: 'Name/Id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'email',
    label: 'Email',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'location',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'price',
    label: 'Price',
    align: 'left',
    field: 'price',
    sort: false,
  },
];

export const columnForPilotInterestAdmin = [
  {
    id: 'pilotName',
    label: 'Name',
    align: 'left',
    field: 'avtar',
    sort: false,
  },
  {
    id: 'email',
    label: 'Email',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'location',
    label: 'Location',
    align: 'left',
    field: 'flag',
    sort: false,
  },
  {
    id: 'price',
    label: 'Price',
    align: 'left',
    field: 'price',
    sort: false,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
  },
  {
    id: 'Approve',
    label: 'Approve',
    align: 'left',
    field: 'approve',
    sort: false,
  },
];

export const statusAlertSeverity = {
  error: 'error',
  info: 'info',
  success: 'success',
  warning: 'warning',
};

export const statusAlertSeverityColor = {
  error: 'red',
  info: 'blue',
  success: 'green',
  warning: 'orange',
};
export const dataLibraryUnitPrice = 0.05;

export const limits = [5, 10, 30, 50, 100];

export const colorStatus = {
  red: 'red',
  yellow: 'yellow',
  green: 'green',
  grey: 'grey',
  blue: 'blue',
  neutral: 'neutral',
  globheGreen: 'globheGreen',
};
export const noSubscriptionAvailable = {
  noSubscription: 'noSubscrition',
};

export const invoicesStatus = {
  not_sent: ['Not Sent', 'yellow'],
  unpaid: ['Unpaid', 'red'],
  paid: ['Paid', 'green'],
  rejected: ['Rejected', 'red'],
  require_edit: ['Require Editing', 'yellow'],
};

export const invoicesStatusAdmin = {
  not_sent: ['Not Received', 'yellow'],
  unpaid: ['Unpaid', 'red'],
  paid: ['Paid', 'green'],
  rejected: ['Rejected', 'red'],
  require_edit: ['Require Editing', 'yellow'],
};

export const missionListSource = {
  invite: 'invite',
  assign: 'assign',
  interest: 'interest',
};

export const contractStatus = {
  signed: ['Signed', 'green'],
  not_signed: ['Not Signed', 'red'],
};

export const contractStatusLabel = {
  signed: 'signed',
  notSigned: 'not_signed',
};

export const paymentStatus = {
  paid: 'paid',
  unpaid: 'unpaid',
};
export const invoicePaymentStatus = {
  paid: 'paid',
  unpaid: 'unpaid',
  require_edit: 'require_edit',
  not_sent: 'not_sent',
};
export const projectStatus = {
  initial: 'Initial Project',
  biddingOngoing: 'Bidding Ongoing',
  biddingEnded: 'Bidding Ended',
  quoteSent: 'Quote Sent',
  biddingWithQuote: 'Bidding with Quote',
  quoteDeclined: 'Quote Declined',
  active: 'Active Project',
  completed: 'Completed Project',
  archived: 'Archived Project',
  deleted: 'Deleted Project',
  draft: 'Draft Project',
  draftClient: 'Client Draft Project',
  // rejected: "Rejected Project",
};
export const deliveryDataType = {
  raw: 'raw',
  processed: 'processed',
  baseFiles: 'baseFiles',
};
export const url = {
  termsAndConditions: 'https://www.globhe.com/terms-and-conditions',
  privacyAndPolicy: 'https://www.globhe.com/privacy-policy',
  contactUsUrl: 'https://www.globhe.com/contact-us',
};
export const guestUserSignInRoute = '/crowddroning/client/sign-in';
export const projectMissionStatus = {
  unassigned: 'Unassigned',
  invited: 'Pilot Invited',
  archive: 'Archived Mission',
  active: 'Active',
  dataUploaded: 'Data Uploaded',
  packageRejected: 'Package Rejected',
  completed: 'Completed',
  unknown: 'Unknown',
  // rejected: "Rejected Mission",
};
export const projectAdminPrivilege = {
  super: 'Super Admin',
};

export const paymentStatusofInvoice = ['paid', 'unpaid', 'Require Edit', 'Not Received'];
export const clientQuote = {
  received: 'received',
  notReceived: 'notReceived',
  review: 'to review',
  rejected: 'rejected',
};
export const missionStatus = {
  // Un-confirmed order statuses.
  initialClientOrder: 'initialClientOrder',
  // Confirmed order
  //old statuses
  confirmedMission: 'confirmedMission',
  unassigned: 'unassigned',
  //special status
  biddingWithQuote: 'biddingWithQuote',
  // new statuses
  pilotInvitedForBidding: 'pilotInvitedForBidding',
  biddingOngoing: 'biddingOngoing',
  biddingEnded: 'biddingEnded',
  pilotSelected: 'pilotSelected',
  quoteSentToClient: 'quoteSentToClient',
  quoteDeclinedByClient: 'quoteDeclinedByClient',
  quoteReissuedToClient: 'quoteReissuedToClient',
  quoteAcceptedByClient: 'quoteAcceptedByClient',
  //Active orders
  //old statuses
  active: 'active',
  // new statuses
  missionNotFeasible: 'missionNotFeasible',
  pilotAssigned: 'pilotAssigned',
  flyingDateSet: 'flyingDateSet',
  //notAbleToFly:"Not Able to fly",
  rescheduled: 'rescheduled',
  dataProcessing: 'dataProcessing',
  dataUploading: 'dataUploading',
  sentForReviewToGlobhe: 'sentForReviewToGlobhe',
  pilotPackageRejected: 'pilotPackageRejected',
  sentForReviewToClient: 'sentForReviewToClient',
  dataRejectedByClient: 'dataRejectedByClient',
  dataAcceptedByClient: 'dataAcceptedByClient',
  feasibleNotCompleted: 'feasibleNotCompleted',
  //Completed Orders
  completed: 'completed',

  //Other statuses
  deleted: 'deleted',
  missed: 'missed',
  archive: 'archive',
  rejected: 'rejected',
  cancelled: 'cancelled',
  draft: 'draft',
  initialProjectOrder: 'initialProjectOrder',
};
export const projectStatusMap = {
  [missionStatus.initialProjectOrder]: {
    color: colorStatus.blue,
    name: 'Initial Project Order',
  },
  [missionStatus.biddingOngoing]: {
    color: colorStatus.yellow,
    name: 'Bidding Ongoing - Trad',
  },
  [missionStatus.biddingWithQuote]: {
    color: colorStatus.yellow,
    name: 'Bidding Ongoing',
  },
  [missionStatus.biddingEnded]: {
    color: colorStatus.yellow,
    name: 'Bidding Ended',
  },
  [missionStatus.pilotSelected]: {
    color: colorStatus.green,
    name: 'Operator Selected',
  },
  [missionStatus.confirmedMission]: {
    color: colorStatus.grey,
    name: 'Confirmed Order',
  },
  [missionStatus.quoteAcceptedByClient]: {
    color: colorStatus.neutral,
    name: 'Confirmed Order',
  },
  [missionStatus.pilotAssigned]: {
    color: colorStatus.yellow,
    name: 'Operator Assigned',
  },
  [missionStatus.missionNotFeasible]: {
    color: colorStatus.red,
    name: 'Mission Not Feasible',
  },
  [missionStatus.feasibleNotCompleted]: {
    color: colorStatus.red,
    name: 'Feasible But not Completed',
  },
  [missionStatus.flyingDateSet]: {
    color: colorStatus.yellow,
    name: 'Flying Date Set',
  },
  [missionStatus.rescheduled]: {
    color: colorStatus.yellow,
    name: 'Rescheduled',
  },
  [missionStatus.dataProcessing]: {
    color: colorStatus.blue,
    name: 'Data Processing',
  },
  [missionStatus.dataUploading]: {
    color: colorStatus.blue,
    name: 'Data Uploading',
  },
  [missionStatus.pilotPackageRejected]: {
    color: colorStatus.red,
    name: 'Data Rejected - Admin',
  },
  [missionStatus.sentForReviewToGlobhe]: {
    color: colorStatus.neutral,
    name: 'Admin Reviewing',
  },
  [missionStatus.sentForReviewToClient]: {
    color: colorStatus.neutral,
    name: 'Client Reviewing',
  },
  [missionStatus.dataRejectedByClient]: {
    color: colorStatus.red,
    name: 'Data Rejected - Client',
  },
  [missionStatus.dataAcceptedByClient]: {
    color: colorStatus.green,
    name: 'Data Accepted',
  },
  [missionStatus.completed]: {
    color: colorStatus.green,
    name: 'Complete',
  },
  [missionStatus.active]: {
    color: colorStatus.blue,
    name: 'Active',
  },
  [missionStatus.draft]: {
    color: colorStatus.red,
    name: 'Pending submission',
  },
  [missionStatus.deleted]: {
    color: colorStatus.red,
    name: 'Deleted',
  },
};
export const statusMap = {
  [missionStatus.unassigned]: {
    color: colorStatus.red,
    name: 'Pending operator',
  },
  [missionStatus.pilotInvitedForBidding]: {
    color: colorStatus.green,
    name: 'Pilots Invited For Bidding',
  },
  [missionStatus.confirmedMission]: {
    color: colorStatus.green,
    name: 'Mission Confirmed',
  },
  [missionStatus.biddingOngoing]: {
    color: colorStatus.green,
    name: 'Bidding Ongoing ',
  },
  [missionStatus.biddingWithQuote]: {
    color: colorStatus.green,
    name: 'Bidding Ongoing',
  },
  [missionStatus.biddingEnded]: {
    color: colorStatus.yellow,
    name: 'Bidding Ended',
  },
  [missionStatus.pilotSelected]: {
    color: colorStatus.green,
    name: 'Operator Selected',
  },
  [missionStatus.quoteSentToClient]: {
    color: colorStatus.green,
    name: 'Quote Received',
  },
  [missionStatus.quoteReissuedToClient]: {
    color: colorStatus.green,
    name: 'Quote Received',
  },
  [missionStatus.quoteAcceptedByClient]: {
    color: colorStatus.green,
    name: 'Quote Accepted',
  },
  [missionStatus.quoteDeclinedByClient]: {
    color: colorStatus.red,
    name: 'Quote Declined',
  },
  [missionStatus.pilotAssigned]: {
    color: colorStatus.green,
    name: 'Operator Assigned',
  },
  [missionStatus.missionNotFeasible]: {
    color: colorStatus.red,
    name: 'Mission Not Feasible',
  },
  [missionStatus.flyingDateSet]: {
    color: colorStatus.green,
    name: 'Flying Date Set',
  },
  [missionStatus.rescheduled]: {
    color: colorStatus.yellow,
    name: 'Rescheduled',
  },
  [missionStatus.dataProcessing]: {
    color: colorStatus.green,
    name: 'Data Processing',
  },
  [missionStatus.dataUploading]: {
    color: colorStatus.green,
    name: 'Data Uploading',
  },
  [missionStatus.sentForReviewToGlobhe]: {
    color: colorStatus.yellow,
    name: 'Admin Reviewing',
  },
  [missionStatus.sentForReviewToClient]: {
    color: colorStatus.yellow,
    name: 'Review Requested',
  },
  [missionStatus.pilotPackageRejected]: {
    color: colorStatus.yellow,
    name: 'Operator Reuploading the data',
  },
  [missionStatus.dataRejectedByClient]: {
    color: colorStatus.yellow,
    name: 'Admin Reuploading the data',
  },
  [missionStatus.dataAcceptedByClient]: {
    color: colorStatus.green,
    name: 'Data Accepted',
  },
  [missionStatus.active]: { color: colorStatus.green, name: 'Active' },
  [missionStatus.initialClientOrder]: {
    color: colorStatus.yellow,
    name: 'Reviewing',
  },
  [missionStatus.completed]: { color: colorStatus.green, name: 'Completed' },
  [missionStatus.cancelled]: { color: colorStatus.grey, name: 'Cancelled' },
  [missionStatus.rejected]: { color: colorStatus.grey, name: 'Rejected' },
  [missionStatus.archive]: { color: colorStatus.grey, name: 'Archive' },
};

export const unConfirmedMissionStatuses = [
  missionStatus.unassigned,
  missionStatus.confirmedMission,
  missionStatus.pilotInvitedForBidding,
  missionStatus.biddingOngoing,
  missionStatus.biddingEnded,
  missionStatus.pilotSelected,
  missionStatus.quoteSentToClient,
  missionStatus.quoteDeclinedByClient,
  missionStatus.quoteReissuedToClient,
  missionStatus.quoteAcceptedByClient,
  missionStatus.biddingWithQuote,
];

export const unConfirmedMissionStatusesForPilot = [
  missionStatus.unassigned,
  missionStatus.pilotInvitedForBidding,
  missionStatus.biddingOngoing,
  missionStatus.biddingEnded,
  missionStatus.pilotSelected,
  missionStatus.quoteSentToClient,
  missionStatus.quoteDeclinedByClient,
  missionStatus.quoteReissuedToClient,
  missionStatus.quoteAcceptedByClient,
  missionStatus.biddingWithQuote,
];

export const activeMissionStatuses = [
  missionStatus.active,
  missionStatus.pilotAssigned,
  missionStatus.missionNotFeasible,
  missionStatus.feasibleNotCompleted,
  missionStatus.flyingDateSet,
  missionStatus.rescheduled,
  missionStatus.dataProcessing,
  missionStatus.dataUploading,
  missionStatus.sentForReviewToGlobhe,
  missionStatus.pilotPackageRejected,
  missionStatus.sentForReviewToClient,
  missionStatus.dataRejectedByClient,
  missionStatus.dataAcceptedByClient,
  missionStatus.quoteAcceptedByClient,
  missionStatus.quoteDeclinedByClient,
  missionStatus.quoteSentToClient,
  missionStatus.quoteReissuedToClient,
];
export const inProgressMissionStatuses = [
  missionStatus.active,
  missionStatus.pilotAssigned,
  missionStatus.flyingDateSet,
  missionStatus.rescheduled,
  missionStatus.dataProcessing,
  missionStatus.dataUploading,
  missionStatus.sentForReviewToGlobhe,
  missionStatus.pilotPackageRejected,
  missionStatus.sentForReviewToClient,
  missionStatus.dataRejectedByClient,
  missionStatus.dataAcceptedByClient,
];
export const splitActiveMissionStatuses = [
  missionStatus.active,
  missionStatus.pilotAssigned,
  missionStatus.flyingDateSet,
  missionStatus.rescheduled,
];

export const packageStatuses = [
  missionStatus.dataProcessing,
  missionStatus.dataUploading,
  missionStatus.sentForReviewToGlobhe,
  missionStatus.pilotPackageRejected,
  missionStatus.sentForReviewToClient,
  missionStatus.dataRejectedByClient,
  missionStatus.dataAcceptedByClient,
];

export const clientOrderStatus = {
  reviewing: 'reviewing', // Unconfirmed
  confirmedMission: 'confirmedMission', // Confirmed order newly added.
  completed: 'completed', // Completed
  active: 'active', // Active
  inProcess: 'inProcess', // Probably have to remove but check the usages first
  rejected: 'rejected',
  cancelled: 'cancelled',
};

export const projectStatusLabel = {
  draft: 'Pending submission',
  inProgress: 'In progress',
  completed: 'completed',
  deleted: 'deleted',
  notStarted: 'Not started',
  archived: 'archived',
  initialProject: 'Initial Project',
  biddingOngoing: 'Bidding Ongoing',
  biddingEnded: 'Bidding Ended',
  biddingWithQuote: 'Bidding with Quote',
  quoteSent: 'Quote Sent',
  quoteDeclined: 'Quote Declined',
  active: 'Active Project',
};
export const adminClientProgressStatus = [
  'Initial order',
  'Confirmed order',
  'Active order',
  'Uploaded data',
  'Completed order',
];

export const pilotProgressStatus = ['Unassigned mission', 'Active mission', 'Uploaded data', 'Completed mission'];

// Try to remove this variable or the above "clientOrderStatus" variable
// since they looks similar to me add of the variable in one constant and use that.
export const OrderStatus = {
  reviewing: 'reviewing',
  rejected: 'rejected',
  cancelled: 'cancelled',
  pendingPilot: 'pendingPilot',
  active: 'active',
  validating: 'validating',
  completed: 'completed',
  deleted: 'deleted',
};

export const pageSRC = {
  stripe: 'stripe',
  purchaseDataPage: 'Purchased Data Page',
  myPlanPage: 'my plan',
};

export const FilterFieldsMission = ['Id', 'Mission Type', 'Mission Name'];
export const FilterFieldsAdminMissions = ['Id', 'Mission Name', 'Mission Status'];

export const FilterFieldsProject = ['Id', 'Project Name', 'Country', 'Client Name'];

export const ClientFilterFieldsProject = ['Id', 'Project Name', 'Country'];

export const FilterFieldsForListingAllClients = [
  //Label dataBaseField typeofFieldinDataBase
  {
    label: 'Name/Email',
    value: 'nameEmail',
    type: 'array',
    fieldType: 'input',
  },
  {
    label: 'Country',
    value: 'location',
    type: 'string',
    fieldType: 'autoComplete',
    filterFields: [...allCountries],
  },
  {
    label: 'Organization',
    value: 'companyName',
    type: 'string',
    fieldType: 'input',
  },
];

export const FilterFieldsForListingClientsAllProject = [
  //Label dataBaseField typeofFieldinDataBase
  {
    label: 'Project Name',
    value: 'projectName',
    type: 'string',
    fieldType: 'input',
  },
  {
    label: 'Status',
    value: 'status',
    type: 'string',
    fieldType: 'autoComplete',
    filterFields: ['Unconfirmed Project', 'Active Project', 'Completed Project', 'Archived Project'],
  },
  {
    label: 'Project Id',
    value: 'id',
    type: 'string',
    fieldType: 'input',
  },
];

export const FilterFieldsForListingClientsAllSingleOrder = [
  //Label dataBaseField typeofFieldinDataBase
  {
    label: 'Mission Name',
    value: 'missionName',
    type: 'string',
    fieldType: 'input',
  },
  {
    label: 'Status',
    value: 'status',
    type: 'string',
    fieldType: 'autoComplete',
    filterFields: ['active', 'completed', 'initialClientOrder', 'confirmedMission', 'archive', 'rejected', 'cancelled'],
  },
  {
    label: 'Mission Id',
    value: 'id',
    type: 'string',
    fieldType: 'input',
  },
];

export const FilterFieldsClientOrders = ['Order Id', 'Order Name', 'Order Status'];
export const FilterFieldsClientPlans = ['Order Id'];
export const FilterFieldsGroupedOrder = ['Order Name', 'Status', 'Order Type'];

export const FilterFieldsPilotMissions = ['Order Id'];

export const FilterFieldsArchiveMission = ['Id', 'Mission Category', 'Mission Name'];

export const FilterFieldsClientArchiveMission = ['Id', 'Mission Name'];
export const ClientPage = {
  Collaboration: 'collaboration',
  Orders: 'orders',
  Plans: 'plans',
  GroupOrder: 'groupOrder',
};
export const FilterCollaborationsOrderList = ['Id', 'Order Name'];
export const FilterFieldActiveMissionList = ['Id', 'Mission Type', 'Mission Name', 'Mission Status'];

export const FilterFieldClientOrdersActiveList = ['Id', 'Mission Name', 'Status'];

export const FilterFieldCompleteMissionList = ['Id', 'Mission Type', 'Mission Name', 'Payment Status'];

export const FilterFieldCompleteClientOrderList = ['Id', 'Mission Name', 'Payment Status'];

export const FilterFieldRejectedMissions = ['Mission Type', 'Mission Name'];
export const FilterFieldMissedMissions = ['Mission Name'];
export const FilterFieldInquiresMissions = ['Mission Type'];

export const pilotPaymentStatus = ['Paid', 'Unpaid'];

export const PaymentStatus = ['Pilot Paid', 'Pilot Unpaid', 'Client Paid', 'Client Unpaid'];

export const days = [
  {
    key: 'sunday',
    label: 'S',
  },
  {
    key: 'monday',
    label: 'M',
  },
  {
    key: 'tuesday',
    label: 'T',
  },
  {
    key: 'wednesday',
    label: 'W',
  },
  {
    key: 'thursday',
    label: 'T',
  },
  {
    key: 'friday',
    label: 'F',
  },
  {
    key: 'saturday',
    label: 'S',
  },
];

export const DeliveryPackageStatus = {
  open: 'open',
  transferring: 'transferring',
  delivered: 'delivered',
  failed: 'failed',
};

export const DeliveryFileStatus = {
  open: 'open',
  transferring: 'transferring',
  delivered: 'delivered',
  failed: 'failed',
};

export const PilotPackageStatus = {
  open: 'open',
  pendingReview: 'pendingReview',
  rejected: 'rejected',
  approved: 'approved',
};

export const userRoles = {
  admin: 'admin',
  pilot: 'pilot',
  processingAdmin: 'processingAdmin',
  subscriber: 'subscriber',
  downloader: 'downloader',
  client: 'client',
  all: 'all',
};

export const flightSpecification = [
  'Image overlap: 75% frontal, 70% lateral',
  'Spatial resolution / GSD:  2 - 2.5 cm/px',
  'Drone type and model:  Globhe will select what is available, i.e. DJI Mavic or Phantom series for simple mapping, DJI Matrice series for more accurate surveys',
  'Coordinate Reference System  (CRS):  WGS 84 / EPSG: 4326 / Meters',
  'Vertical accuracy: up to 10 cm when GCPs are used',
  'Ground control points: No',
];

export const flightHeight = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120];

export const missionOrderInfo =
  'For area projects, a minimum order of 100 hectares is required. Any orders below this minimum requirement will be charged at the rate of 100 hectares';

export const specifyLocationTooltipInfo = {
  areaInfo:
    'Area orders are delimited by a polygon. Examples are fields, forests, or anything that has a large surface area.',
  linearInfo:
    'Linear orders are different from areas because they are long and straight, like a line. They are not spread out like a surface. Examples of linear orders include roads and electrical lines.',
  assetInfo:
    'Individual sites are assets that are characterised by a single latitude and longitude coordinates. Examples include individual cell towers or wind turbines',
};

export const clientName = {
  client: 'Client',
};

export const users = {
  user: 'user',
  userProfile: 'userProfile',
};

export const clientExist = {
  client: 'client',
  noClient: 'non-client',
};

export const interestInviteStatus = {
  pilotRequested: 'pilotRequested',
  invited: 'invited',
  adminApproved: 'adminApproved',
  adminRejected: 'adminRejected',
  pilotRejected: 'pilotRejected',
  requested: 'requested',
  approved: 'approved',
  rejected: 'rejected',
  assignedToAnother: 'assignedToAnother',
};

export const apiKeyStatus = {
  requested: 'requested',
  granted: 'granted',
  revoked: 'revoked',
};

export const notificationType = {
  individualNotification: 'Individual Notification',
  clientNotification: 'Client Notification',
  adminNotification: 'Admin Notification',
  pilotNotification: 'pilot Notification',
  processingAdminNotification: 'Processing Admin Notification',
};

export const submissionRole = {
  pilotSubmission: 'pilot submission',
  clientSubmission: 'client submission',
  adminSubmission: 'admin submission',
};

export const declineMissionReason = [
  'Price it too low',
  'The location is too far',
  'I don’t have time',
  'It’s too complicated',
  'I don’t have the right equipment',
  'I don’t have permissions',
  'Security issues',
  'Other',
];

export const rejectPackageReason = [
  'Didn’t upload the requested data type.',
  'The data is not geotagged.',
  'The data is low quality.',
  'Same data uploaded elsewhere.',
  'Data was rejected by the client.',
  'Other',
];

export const sdgGoalsInfo = [
  {
    id: 'goal1',
    description: 'End poverty in all its forms everywhere',
  },
  {
    id: 'goal2',
    description: 'End hunger, achieve food security and improved nutrition and promote sustainable agriculture',
  },
  {
    id: 'goal3',
    description: 'Ensure healthy lives and promote well-being for all at all ages',
  },
  {
    id: 'goal4',
    description: 'Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all',
  },
  {
    id: 'goal5',
    description: 'Achieve gender equality and empower all women and girls',
  },
  {
    id: 'goal6',
    description: 'Ensure availability and sustainable management of water and sanitation for all',
  },
  {
    id: 'goal7',
    description: 'Ensure access to affordable, reliable, sustainable and modern energy for all',
  },
  {
    id: 'goal8',
    description:
      'Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all',
  },
  {
    id: 'goal9',
    description:
      'Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation',
  },
  {
    id: 'goal10',
    description: 'Reduce inequality within and among countries',
  },
  {
    id: 'goal11',
    description: 'Make cities and human settlements inclusive, safe, resilient and sustainable',
  },
  {
    id: 'goal12',
    description: 'Ensure sustainable consumption and production patterns',
  },
  {
    id: 'goal13',
    description: 'Take urgent action to combat climate change and its impacts',
  },
  {
    id: 'goal14',
    description: 'Conserve and sustainably use the oceans, seas and marine resources for sustainable development',
  },
  {
    id: 'goal15',
    description:
      'Protect, restore and promote sustainable use of terrestrial ecosystems, sustainably manage forests, combat desertification, and halt and reverse land degradation and halt biodiversity loss',
  },
  {
    id: 'goal16',
    description:
      'Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels',
  },
  {
    id: 'goal17',
    description:
      'Strengthen the means of implementation and revitalize the Global Partnership for Sustainable Development',
  },
];
export const rejectMissionReason = [
  'the order is breaching our terms and conditions',
  'the order lies in a restricted fly zone',
  'the order lies in war zone',
  'the deadline is too tight to finish this on time',
  'we have no nearby operators to fulfil that order',
];
export const higherPriceValue = 0.25;
export const higherPriceMapTypes = ['Thermal Map', 'LiDAR', 'Multispectral', 'Hyperspectral'];

export const packageTypeConstant = {
  pilotPackage: 'pilotPackage',
  deliveryPackage: 'deliveryPackage',
};

export const communicationViewer = {
  client: 'client',
  admin: 'admin',
  pilot: 'pilot',
  adminClient: 'adminClient',
  adminPilot: 'adminPilot',
  pilotClient: 'pilotClient',
};

export const messageType = {
  text: 'text',
  image: 'image',
  document: 'document',
  textWithImage: 'textWithImage',
  textWithDocument: 'textWithDocument',
  reaction: 'reaction',
};

export const returnMsg =
  'We are diligently processing your order, and you can anticipate receiving your personalized quote shortly after placing it...';

export const baseFileFormat = ['.jpg', '.jpeg', '.zip', '.png', 'image/jpeg', '.gif', '.pdf', '.rar'];

export const fileDataTypes = {
  panaromas: 'panoramas',
  _2dMap: '_2dMap',
  _3dMap: '_3dMap',
  digitalTerrainModel: 'digitalTerrainModel',
  digitalSurfaceModel: 'digitalSurfaceModel',
  topographicMap: 'topographicMap',
  thermalMap: 'thermalMap',
  ndvi: 'ndvi',
  multispectral: 'multispectral',
  streamedData: 'streamedData',
  raw: 'raw',
  LiDAR: 'LiDAR',
  hyperspectral: 'hyperspectral',
};

export const mapWordContain = {
  twoDorthomosaic: '2D Orthomosaic Map',
  threeDmodelPointCloud: '3D model or point cloud',
};

export const jpgFileInfo = {
  label: 'JPG files',
  value: 'baseFiles',
  description:
    'The single JPG images captured by the drones. You will always receive that as part of your order as long as the deliverable is created through RGB images.',
  fileFormat: 'JPG , JPEG',
  fileExtension: ['.jpg', '.jpeg'],
};

export const PROCESSING_SYSTEM_PROVIDERS = [{ label: 'DroneDeploy', value: 'SYSTEM_DRONEDEPLOY' }];

export const missionMapTypes = [
  {
    label: '2D Orthomosaic Map',
    value: '_2dMap',
    description:
      'The single images captured by the drones are stitched together into a single large high-quality 2D orthomosaic map. A 2D map can be utilized across a range of industries, including construction and infrastructure, and used in all modeling and GIS software. Based on the capturing configuration, the resolution is up to a few mm/px. Zoom in and rotate this map to see the high-resolution images and the big difference they can make when compared to satellites',
    fileFormat: 'GeoTIFF, Source Images (ZIP), JPG, PDF.',
    fileExtension: ['.tiff', '.zip', '.tif', '.rar'],
    acceptableFileFormat: [
      {
        title: 'GeoTIFF',
        desc: 'File format suited for 2D analysis in GIS software such as ArcGIS or QGIS',
      },
      {
        title: 'Source Images (ZIP)',
        desc: 'Zip file containing the processed map’s source imagery',
      },
      {
        title: 'JPG',
        desc: 'Easy to share through any standard image software such as Windows Photo Viewer or Preview. Print or use within presentations',
      },
      {
        title: 'PDF',
        desc: 'PDF file of the 2D map for easy sharing among multiple users',
      },
    ],
  },
  {
    label: '3D model or point cloud',
    value: '_3dMap',
    description:
      'Similar to orthomosaic maps, drone images are stitched together and create a high-resolution 3D model represented by a 3D mesh surface or a point cloud. The latter is a 3D visualization of thousands or even millions of georeferenced points. Point clouds provide high-resolution data and give you an interactive 3D model with real-world imagery and easy modification in 3D modeling software. Point clouds can also be used to develop digitized models of structures for CAD and BIM-related purposes, which is at the forefront of modern construction.',
    fileFormat: 'obj, LAS (Point Cloud),LAZ, ASCII .xyz, autodesk .rcp, GEOTIFF',
    fileExtension: ['.obj', '.mtl', '.jpg', '.las', '.laz', '.xyz', '.rcp', '.zip', '.rar'],
    acceptableFileFormat: [
      {
        title: '3D model .obj',
        desc: 'Not georeferenced: defined in a model-local coordinate system. Includes 3 file types: .obj (the 3D geometry), .mtl (information on material), and .jpg (texture/color information used by the material). Can be used in any 3D visualization software.',
      },
      {
        title: 'LAS (Point Cloud)',
        desc: 'Can be used in AutoCAD, ArcGIS, Global Mapper, Applied Imagery, or similar software.',
      },
      {
        title: 'LAZ',
        desc: 'LAZ file format is a compressed version of .LAS.',
      },
      {
        title: 'ASCII .xyz',
        desc: '.xyz point cloud that contains RGB information (XYZRGB). Resolution is specifiable. Most common file format accepted across Construction/Mining software formats.',
      },
      {
        title: 'autodesk .rcp',
        desc: 'AutoCad Specific File. Easily import your export into AutoCAD',
      },
      {
        title: 'GEOTIFF',
        desc: 'File format suited for 2D analysis in GIS software such as ArcGIS or QGIS. Includes a .TWF file with the georeferenced metadata. Includes a .kml file is when using the Web Mercator Projection.',
      },
    ],
  },
  {
    label: '3D model',
    value: '_3dModel',
    description:
      'Similar to orthomosaic maps, drone images are stitched together and create a high-resolution 3D model represented by a 3D mesh surface or a point cloud. The latter is a 3D visualization of thousands or even millions of georeferenced points.',
    fileFormat: 'obj, ASCII .xyz, autodesk .rcp, GEOTIFF',
    fileExtension: ['.obj', '.mtl', '.jpg', '.xyz', '.rcp', '.zip', '.rar'],
    acceptableFileFormat: [
      {
        title: '3D model .obj',
        desc: 'Not georeferenced: defined in a model-local coordinate system. Includes 3 file types: .obj (the 3D geometry), .mtl (information on material), and .jpg (texture/color information used by the material). Can be used in any 3D visualization software.',
      },
      {
        title: 'ASCII .xyz',
        desc: '.xyz point cloud that contains RGB information (XYZRGB). Resolution is specifiable. Most common file format accepted across Construction/Mining software formats.',
      },
      {
        title: 'autodesk .rcp',
        desc: 'AutoCad Specific File. Easily import your export into AutoCAD',
      },
      {
        title: 'GEOTIFF',
        desc: 'File format suited for 2D analysis in GIS software such as ArcGIS or QGIS. Includes a .TWF file with the georeferenced metadata. Includes a .kml file is when using the Web Mercator Projection.',
      },
    ],
  },
  {
    label: 'Digital terrain model',
    value: 'digitalTerrainModel',
    description:
      'The terrain surface map reveals the ground surface without any objects represented. It allows detailed terrain analysis, planning construction, hydrological applications, and modeling environmental risks. The resolution of these DEMs can reach up to a few cm according to the drone configuration. Zoom in and rotate this map to see the high-resolution model we can provide.',
    fileFormat: 'GeoTIFF, Raw Elevation Values (DTM),Contour DXF (AutoCAD),Contour SHP (Shapefile), JPG, PDF.',
    fileExtension: ['.tiff', '.zip', '.shp', '.dxf', '.tif', '.rar'],

    acceptableFileFormat: [
      {
        title: 'GeoTIFF',
        desc: 'One-band GeoTIFF file with embedded elevation values. File format suited for 2D analysis in GIS software such as ArcGIS or QGIS',
      },
      {
        title: 'Raw Elevation Values (DTM)',
        desc: 'One-band GeoTIFF file with embedded elevation values. File format suited for 2D analysis in GIS software such as ArcGIS or QGIS.',
      },
      {
        title: 'Contour DXF (AutoCAD)',
        desc: 'Georeferenced lines of equal elevation according to the chosen interval. For use in AutoDesk suite and Mining/Construction software',
      },
      {
        title: 'Contour SHP (Shapefile)',
        desc: 'Georeferenced lines of equal elevation according to the chosen interval. For use in AutoDesk suite and Mining/Construction software.',
      },
      {
        title: 'JPG',
        desc: 'Easy to share through any standard image software such as Windows Photo Viewer or Preview. Print or use within presentations',
      },
      {
        title: 'PDF',
        desc: 'PDF file of the 2D map for easy sharing among multiple users',
      },
    ],
  },
  {
    label: 'Digital surface model',
    value: 'digitalSurfaceModel',
    description:
      'Represents elevation data captured by a drone, including all the surfaces it sees, such as trees, equipment, and other structures. It is different than the digital terrain model as it shows objects and vegetation. This model is ideal for the agricultural industry and other industries, as it allows for vegetation inspection and management. Depending on the mission configuration, the resolution can be down to 1 cm. The data can also create accurate volumetric calculations from these elevation maps.',
    fileFormat: 'GeoTIFF,Raw Elevation Values (DTM),Contour SHP (Shapefile),Contour DXF (AutoCAD),JPG, PDF.',
    fileExtension: ['.tiff', '.zip', '.rar', '.shp', '.dxf', '.tif'],
    acceptableFileFormat: [
      {
        title: 'GeoTIFF',
        desc: 'One-band GeoTIFF file with embedded elevation values. File format suited for 2D analysis in GIS software such as ArcGIS or QGIS',
      },
      {
        title: 'Raw Elevation Values (DTM)',
        desc: 'One-band GeoTIFF file with embedded elevation values. File format suited for 2D analysis in GIS software such as ArcGIS or QGIS.',
      },
      {
        title: 'Contour SHP (Shapefile)',
        desc: 'Georeferenced lines of equal elevation according to the chosen interval. For use in AutoDesk suite and Mining/Construction software.',
      },
      {
        title: 'Contour DXF (AutoCAD)',
        desc: 'Georeferenced lines of equal elevation according to the chosen interval. For use in AutoDesk suite and Mining/Construction software.',
      },
      {
        title: 'JPG',
        desc: 'Easy to share through any standard image software such as Windows Photo Viewer or Preview. Print or use within presentations',
      },
      {
        title: 'PDF',
        desc: 'PDF file of the 2D map for easy sharing among multiple users',
      },
    ],
  },
  {
    label: 'Topographic map with contour lines',
    value: 'topographicMap',
    description:
      'Topographic maps conventionally show the topography utilizing contour lines. The latter are curves connecting points of equal elevation above a given level, such as the mean sea level. The contour interval of a contour map is the difference in elevation between successive contour lines. High-resolution topographic maps are very useful when investigating natural hazard assessment, slope stability, large construction projects, hydrogeology, and monitoring of underground resources. In addition, differentiated topography resulting from surface motion is critical in understanding tectonic and volcanic activities and their resulting hazards. Resolution can reach less than 1 cm depending on the mission configuration.',
    fileFormat: 'Contour SHP (Shapefile),Contour DXF (AutoCAD), JPG, PDF.',
    fileExtension: ['.tiff', '.zip', '.rar', '.shp', '.dxf', '.jpg', '.tif'],

    acceptableFileFormat: [
      {
        title: 'Contour SHP (Shapefile)',
        desc: 'Georeferenced lines of equal elevation according to the chosen interval. For use in AutoDesk suite and Mining/Construction software.',
      },
      {
        title: 'Contour DXF (AutoCAD)',
        desc: 'Georeferenced lines of equal elevation according to the chosen interval. For use in AutoDesk suite and Mining/Construction software.',
      },
      {
        title: 'PDF',
        desc: 'PDF file of the 2D map for easy sharing among multiple users',
      },
    ],
  },
  {
    label: 'Thermal Map',
    value: 'thermalMap',
    description:
      'Survey with a thermal camera and quickly identify targets with abnormal heat signatures. Thermal surveys can help identify heat loss to improve energy efficiency, can locate water leaks or moisture ingress or faults with wiring and other electrical components. They are also very beneficial in forestry as they help identify early fire risks before they develop and spread.',
    fileFormat: 'GeoTIFF, zip.',
    fileExtension: ['.tiff', '.zip', '.tif', '.rar'],

    acceptableFileFormat: [
      {
        title: 'GeoTIFF',
        desc: 'File format suited for 2D analysis in GIS software such as ArcGIS or QGIS',
      },
      {
        title: 'zip',
        desc: 'Zip file containing the processed map’s source imagery in jpeg format',
      },
    ],
  },
  {
    label: 'Plant health (NDVI maps)',
    value: 'ndvi',
    description: `Plant health maps explore agricultural data even more deeply by
     visualizing variability within a field to quantify damage and predict yields
     by showing the area within a specific range. Uses a multi-spectral camera or
     NDVI algorithm to extract plant health information from RGB images.`,
    fileFormat: 'GeoTIFF, Shapefile, JPG, PDF.',
    fileExtension: ['.tiff', '.zip', '.tif', '.rar'],
    acceptableFileFormat: [
      {
        title: 'GeoTIFF',
        desc: 'File format suited for 2D analysis in GIS software such as ArcGIS or QGIS. Includes a .TWF file with the georeferenced metadata and a .KML file is when using the Web Mercator Projection.',
      },
      {
        title: 'Shapefile',
        desc: 'Plant health data stored as a set of shapes (polygons) with a default resolution of ~10m x 10m (size depends on latitude).',
      },
      {
        title: 'JPG',
        desc: 'Easy to share through any standard image software such as Windows Photo Viewer or Preview. Print or use within presentations',
      },
      {
        title: 'PDF',
        desc: 'PDF file of the 2D map for easy sharing among multiple users',
      },
    ],
  },
  {
    label: 'Multispectral',
    value: 'multispectral',
    description:
      'Plant health maps explore agricultural data even more deeply by visualizing variability within a field to quantify damage and predict yields by showing the area ​within a specific range. Uses a multi-spectral camera or NDVI algorithm to extract plant health information from RGB images.',
    fileFormat: 'GeoTIFF, Shapefile, JPG, PDF.',
    fileExtension: ['.tiff', '.zip', '.tif', '.rar'],
    acceptableFileFormat: [
      {
        title: 'GeoTIFF',
        desc: 'File format suited for 2D analysis in GIS software such as ArcGIS or QGIS. Includes a .TWF file with the georeferenced metadata and a .KML file is when using the Web Mercator Projection.',
      },
      {
        title: 'Shapefile',
        desc: 'Plant health data stored as a set of shapes (polygons) with a default resolution of ~10m x 10m (size depends on latitude).',
      },
      {
        title: 'JPG',
        desc: 'Easy to share through any standard image software such as Windows Photo Viewer or Preview. Print or use within presentations',
      },
      {
        title: 'PDF',
        desc: 'PDF file of the 2D map for easy sharing among multiple users',
      },
    ],
  },
  {
    label: 'Hyperspectral',
    value: 'hyperspectral',
    description:
      'Hyperspectral imaging collects and processes information from across the electromagnetic spectrum. The goal is to obtain the spectrum for each pixel in the image of a scene, with the purpose of finding objects, identifying materials, or detecting processes.',
    fileFormat: 'GeoTIFF, Shapefile, JPG, PDF.',
    fileExtension: ['.tiff', '.zip', '.tif', '.rar'],
    acceptableFileFormat: [
      {
        title: 'GeoTIFF',
        desc: 'File format suited for 2D analysis in GIS software such as ArcGIS or QGIS. Includes a .TWF file with the georeferenced metadata and a .KML file is when using the Web Mercator Projection.',
      },
      {
        title: 'Shapefile',
        desc: 'Plant health data stored as a set of shapes (polygons) with a default resolution of ~10m x 10m (size depends on latitude).',
      },
      {
        title: 'JPG',
        desc: 'Easy to share through any standard image software such as Windows Photo Viewer or Preview. Print or use within presentations',
      },
      {
        title: 'PDF',
        desc: 'PDF file of the 2D map for easy sharing among multiple users',
      },
    ],
  },
  // {
  //   label: "Plant health (NDVI maps)",
  //   value: "ndvi",
  //   description:
  //     "Plant health maps explore agricultural data even more deeply by visualizing variability within a field to quantify damage and predict yields by showing the area ​within a specific range. Uses a multi-spectral camera or NDVI algorithm to extract plant health information from RGB images.",
  //   fileFormat: "GeoTIFF, Shapefile, JPG, PDF.",
  //   fileExtension: [".tiff", ".zip", ".tif"],
  //   acceptableFileFormat: [
  //     {
  //       title: "GeoTIFF",
  //       desc: "File format suited for 2D analysis in GIS software such as ArcGIS or QGIS. Includes a .TWF file with the georeferenced metadata and a .KML file is when using the Web Mercator Projection.",
  //     },
  //     {
  //       title: "Shapefile",
  //       desc: "Plant health data stored as a set of shapes (polygons) with a default resolution of ~10m x 10m (size depends on latitude).",
  //     },
  //     {
  //       title: "JPG",
  //       desc: "Easy to share through any standard image software such as Windows Photo Viewer or Preview. Print or use within presentations",
  //     },
  //     {
  //       title: "PDF",
  //       desc: "PDF file of the 2D map for easy sharing among multiple users",
  //     },
  //   ],
  // },
  {
    label: 'Live streamed data (video footage)',
    value: 'streamedData',
    description:
      'High-quality aerial video recordings captured during flight. These videos provide a detailed visual perspective from the drone’s point of view — ideal for inspections, documentation, marketing, or situational awareness. Video footage can be delivered in various resolutions and formats depending on your needs. They will not be edited unless requested. Live streaming options are also available upon request for real-time monitoring or rapid decision-making.',
    fileFormat: ['.mp4, live broadcast', '.mov', '.avi'],
    fileExtension: ['.mp4', '.mov', '.avi', '.avchd', '.mkv', '.flv', '.f4v', '.swf'],
    acceptableFileFormat: [
      {
        title: '.mp4',
        desc: 'video footage of the recorded scene in a .mp4 format',
      },
      {
        title: 'Live broadcast',
        desc: 'watch the footage live while the drone operator is filming through a dedicate and private link.',
      },
    ],
  },
  {
    label: 'DNG Files',
    value: 'raw',
    description:
      "DNG 'Digital Negative Image' is a raw, untouched, and unprocessed image recorded directly from a camera’s sensor. Optimal format in case you want to edit the images in-house before processing them.",
    fileFormat: 'georeferenced images in .dng',
    fileExtension: ['.dng'],
    acceptableFileFormat: [
      {
        title: 'zip',
        desc: 'Zip file containing the georeferenced imagery in .jpg format',
      },
      {
        title: 'jpg',
        desc: 'individual geoereferenced images in .jpg format',
      },
    ],
  },
  {
    label: '360 panoramas',
    value: 'panoramas',
    description:
      'A 360-degree photo is a controllable panoramic image that surrounds the original point from which the shot was taken. 360-degree photos simulate being in the shoes of a photographer and looking around to the left, right, up and down as desired as well as zooming in to see the details. It is a great tool to see the perspectives and looking into a landscape from all angles.',
    fileFormat: 'jpg',
    fileExtension: ['.jpg', '.png', '.jpeg'],
    acceptableFileFormat: [
      {
        title: 'jpg',
        desc: 'processed image of the 360 panorama in .jpg format to be viewed in a dedicated software.',
      },
    ],
  },
  {
    label: 'LiDAR',
    value: 'LiDAR',
    description:
      'Lidar, which stands for Light Detection and Ranging, is a remote sensing method that uses light in the form of a pulsed laser to measure ranges (variable distances) to the Earth. These light pulses—combined with other data recorded by the airborne system — generate precise, three-dimensional information about the shape of the Earth and its surface characteristics. A lidar instrument principally consists of a laser, a scanner, and a specialized GPS receiver. Airplanes and helicopters are the most commonly used platforms for acquiring lidar data over broad areas. Two types of lidar are topographic and bathymetric. Topographic lidar typically uses a near-infrared laser to map the land, while bathymetric lidar uses water-penetrating green light to also measure seafloor and riverbed elevations',
    fileFormat: '.LAS, .LAZ, .obj, .ply, .txt, .e57, .pts, .u3d, .cl3, .dxf',
    fileExtension: ['.las', '.laz'],
    acceptableFileFormat: [
      {
        title: 'LAS',
        desc: ' The LAS file format is a standard binary file format to store and interchange 3-d point cloud data.',
      },
      {
        title: 'LAZ',
        desc: 'LAZ file format is a compressed version of .LAS.',
      },
      {
        title: 'Wavefront OBJ (*.obj)',
        desc: 'It is a simple data format that only represents 3D geometry, normals, colour and texture. It is commonly ASCII, however there are some proprietary binary versions of OBJ.',
      },
      {
        title: 'Stanford PLY (*.ply)',
        desc: 'known as the polygon file format or Stanford triangle format, PLY was inspired by OBJ and purpose-built to store 3D data.',
      },
      {
        title: 'XYZ Point Cloud (*.txt)',
        desc: 'is a non-standardised set of files based on Cartesian coordinates (‘x’ ‘y’ and ‘z’). XYZ is an archetypal ASCII file type, conveying data in lines of text. There are no unit standardisations for XYZ files',
      },
      {
        title: 'ASTM E57 (*.e57)',
        desc: ' is a vendor-neutral file format for point cloud storage. It can also be used to store images and metadata produced by laser scanners and other 3D imaging systems',
      },
      {
        title: 'ASCII PTS (*.pts)',
        desc: '',
      },
      {
        title: 'Universal 3D (*.u3d)',
        desc: '',
      },
      {
        title: 'Topcon CL3 (*.cl3)',
        desc: '',
      },
      {
        title: 'Autodesk DXF (*.dxf)',
        desc: '',
      },
    ],
  },
  {
    label: 'Point Cloud',
    value: 'pointCloud',
    description: `LiDAR Point Cloud is a collection of data points captured by LiDAR sensors,
    where each point represents a precise location in 3D space. These points are generated by
    measuring the distance between the sensor and objects using laser pulses. The result is a
    “cloud” of millions of points that map the shape, height, and structure of surfaces, such
    as the ground, buildings, and vegetation.
    RGB Point Cloud is a 3D data set similar to a LiDAR point cloud but with additional color
    information. Each point in an RGB point cloud not only has spatial coordinates (x, y, z)
    but also color values (red, green, blue) captured by an RGB camera. This allows the point
    cloud to represent both the geometry and the appearance of the environment, making it
    easier to identify and interpret objects based on their visual characteristics. RGB point
    clouds are used in applications like 3D modeling, virtual reality, visual inspection, and
    augmented reality, where both spatial accuracy and realistic color representation are
    important.`,
    fileFormat: '.LAS, .LAZ, .obj, .ply, .txt, .e57, .pts, .u3d, .cl3, .dxf',
    fileExtension: ['.las', '.laz'],
    acceptableFileFormat: [
      {
        title: 'LAS',
        desc: ' The LAS file format is a standard binary file format to store and interchange 3-d point cloud data.',
      },
      {
        title: 'LAZ',
        desc: 'LAZ file format is a compressed version of .LAS.',
      },
      {
        title: 'Wavefront OBJ (*.obj)',
        desc: 'It is a simple data format that only represents 3D geometry, normals, colour and texture. It is commonly ASCII, however there are some proprietary binary versions of OBJ.',
      },
      {
        title: 'Stanford PLY (*.ply)',
        desc: 'known as the polygon file format or Stanford triangle format, PLY was inspired by OBJ and purpose-built to store 3D data.',
      },
      {
        title: 'XYZ Point Cloud (*.txt)',
        desc: 'is a non-standardised set of files based on Cartesian coordinates (‘x’ ‘y’ and ‘z’). XYZ is an archetypal ASCII file type, conveying data in lines of text. There are no unit standardisations for XYZ files',
      },
      {
        title: 'ASTM E57 (*.e57)',
        desc: ' is a vendor-neutral file format for point cloud storage. It can also be used to store images and metadata produced by laser scanners and other 3D imaging systems',
      },
      {
        title: 'ASCII PTS (*.pts)',
        desc: '',
      },
      {
        title: 'Universal 3D (*.u3d)',
        desc: '',
      },
      {
        title: 'Topcon CL3 (*.cl3)',
        desc: '',
      },
      {
        title: 'Autodesk DXF (*.dxf)',
        desc: '',
      },
    ],
  },
  // {
  //   label: "Elevation Map",
  //   value: "elevationMap",
  //   description:
  //     "The terrain surface map reveals the ground surface without any objects represented. It allows detailed terrain analysis, planning construction, hydrological applications, and modeling environmental risks. The resolution of these DEMs can reach up to a few cm according to the drone configuration. Zoom in and rotate this map to see the high-resolution model we can provide.",
  //   fileFormat:
  //     "GeoTIFF, Raw Elevation Values (DTM),Contour DXF (AutoCAD),Contour SHP (Shapefile), JPG, PDF.",
  //   acceptableFileFormat: [
  //     {
  //       title: "GeoTIFF",
  //       desc: "One-band GeoTIFF file with embedded elevation values. File format suited for 2D analysis in GIS software such as ArcGIS or QGIS",
  //     },
  //     {
  //       title: "Raw Elevation Values (DTM)",
  //       desc: "One-band GeoTIFF file with embedded elevation values. File format suited for 2D analysis in GIS software such as ArcGIS or QGIS.",
  //     },
  //     {
  //       title: "Contour DXF (AutoCAD)",
  //       desc: "Georeferenced lines of equal elevation according to the chosen interval. For use in AutoDesk suite and Mining/Construction software",
  //     },
  //     {
  //       title: "Contour SHP (Shapefile)",
  //       desc: "Georeferenced lines of equal elevation according to the chosen interval. For use in AutoDesk suite and Mining/Construction software.",
  //     },
  //     {
  //       title: "JPG",
  //       desc: "Easy to share through any standard image software such as Windows Photo Viewer or Preview. Print or use within presentations",
  //     },
  //     {
  //       title: "PDF",
  //       desc: "PDF file of the 2D map for easy sharing among multiple users",
  //     },
  //   ],
  // },
];

export const sensorsType = [
  {
    label: 'RGB',
    value: 'rgbSensor',
    description: `RGB (Red, Green, Blue) sensors capture visible light in the three primary
    colors to create standard color images, similar to what the human eye perceives. They
    are widely used in cameras, drones, and other imaging devices for general photography,
    video recording, and basic mapping tasks.`,
    allowedMapTypes: [
      '2D Orthomosaic Map',
      '3D model',
      'Digital surface model',
      'Digital terrain model',
      'DNG Files',
      '360 panoramas',
      'Live streamed data (video footage)',
      'Topographic map with contour lines',
      'Point Cloud',
    ],
  },
  {
    label: 'Thermal',
    value: 'thermalSensor',
    description: `Thermal sensors detect infrared radiation (heat) emitted by objects,
    enabling the measurement of temperature differences. They are used for applications
    like monitoring heat loss in buildings, detecting hotspots in machinery, wildlife
    observation, solar panel inspection (to identify faulty cells or inefficiencies),
    and search-and-rescue operations.`,
    allowedMapTypes: ['Thermal Map', '2D Orthomosaic Map'],
  },
  {
    label: 'Multispectral',
    value: 'multispectralSensor',
    description: `Plant health maps explore agricultural data even more deeply by
    visualizing variability within a field to quantify damage and predict yields by
    showing the area within a specific range. Uses a multi-spectral camera or NDVI
    algorithm to extract plant health information from RGB images.`,
    allowedMapTypes: ['2D Orthomosaic Map', 'Plant health (NDVI maps)'],
  },
  {
    label: 'Hyperspectral',
    value: 'hyperspectralSensor',
    description: `Hyperspectral imaging collects and processes information from across
    the electromagnetic spectrum. The goal is to obtain the spectrum for each pixel in
    the image of a scene, with the purpose of finding objects, identifying materials,
    or detecting processes.`,
    allowedMapTypes: ['2D Orthomosaic Map', 'Plant health (NDVI maps)'],
  },
  {
    label: 'LiDAR',
    value: 'lidarSensor',
    description: `LiDAR (Light Detection and Ranging) is a remote sensing method that uses pulsed lasers with GPS data to create precise 3D maps of the Earth’s surface. The system typically includes a laser, scanner, and GPS receiver, mounted on aircraft like planes or helicopters. There are two main types: Topographic LiDAR, which uses near-infrared light to map land, and Bathymetric LiDAR, which uses green light to measure seafloor and riverbeds.`,
    allowedMapTypes: ['Digital surface model', 'Digital terrain model', 'Point Cloud'],
  },
  {
    label: 'Ground Data Capture',
    value: 'groundCapture',
    description: `Ground capture cameras include handheld devices such as DSLRs, smartphones, 360° cameras, and 3D scanners. They are used to take images and videos from the ground, providing detailed visual documentation from a human perspective. Applications include property and real estate photography, site documentation, marketing visuals, virtual tours (using 360° or 3D cameras), and general on-site inspections.`,
    allowedMapTypes: ['3D model', '360 panoramas', 'Live streamed data (video footage)'],
  },
];

export const subscriptionType = [
  {
    label: 'Daily',
    value: 'daily',
  },
  {
    label: 'Weekly',
    value: 'weekly',
  },
  {
    label: 'Monthly',
    value: 'monthly',
  },
  {
    label: 'Quarterly',
    value: 'quarterly',
  },
  {
    label: 'Yearly',
    value: 'yearly',
  },
];

export const drones = [
  'Other',
  '3DR H520-G',
  'Autel Robotics Evo II',
  'Autel Robotics Evo Lite+',
  'Autel Robotics EVO II Pro',
  'Autel Robotics EVO II Dual',
  'Autel Robotics EVO II Dual 640T',
  'Autel Robotics EVO II Enterprise',
  'Autel Robotics EVO II RTK',
  'Delair UX11',
  'Delair DT26',
  'DJI Air 2S', //"DJI Mavic Air 2s",
  'DJI Air 3',
  'DJI FPV',
  'DJI Inspire 1',
  'DJI Inspire 1 Pro/Raw',
  'DJI Inspire 2',
  'DJI Matrice 30',
  'DJI Matrice 30 Thermal',
  'DJI Matrice 200 Series V2',
  'DJI Matrice 300 RTK',
  'DJI Matrice 350 RTK',
  'DJI Matrice 600 Series',
  'DJI Mavic Air',
  'DJI Mavic Air 2',
  'DJI Mavic Pro',
  'DJI Mavic Pro Platinum',
  'DJI Mavic 2 Pro',
  'DJI Mavic 2 Zoom',
  'DJI Mavic 2 Enterprise Dual',
  'DJI Mavic 2 Enterprise Advanced',
  'DJI Mavic 3',
  'DJI Mavic 3 Cine',
  'DJI Mavic 3 Enterprise Series',
  'DJI Mavic 3 Enterprise Thermal',
  'DJI Mavic 3 Multispectral',
  'DJI Mavic 3 Pro',
  'DJI Mavic 3 Pro Cine',
  'DJI Mavic 3 Thermal',
  'DJI Mavic Mini',
  'DJI Mini 2',
  'DJI Mini 2 SE',
  'DJI Mini 3',
  'DJI Mini 3 Pro',
  'DJI Mini 4 Pro',
  'DJI Phantom 2',
  'DJI Phantom 2 Vision',
  'DJI Phantom 2 Vision+',
  'DJI Phantom 3 SE',
  'DJI Phantom 3 4K',
  'DJI Phantom 3 Advanced',
  'DJI Phantom 3 Professional',
  'DJI Phantom 3 Standard',
  'DJI Phantom 4',
  'DJI Phantom 4 RTK',
  'DJI Phantom 4 Pro',
  'DJI Phantom 4 Pro V2.0',
  'DJI Phantom 4 Advanced',
  'DJI Spreading Wings S900',
  'Flyability Elios',
  'Flyability Elios 2',
  'Microdrones mdLiDAR3000',
  'Parrot Anafi',
  'Parrot Anafi UI',
  'Parrot Anafi USA',
  'Parrot Disco-Pro AG',
  'Quantum Systems Trinity F90+',
  'senseFly eBee tac',
  'sensefly eBee X',
  'sensefly eBee Geo',
  'sensefly eBee Ag',
  'Skydio 2',
  'Skydio x2',
  'Wingtra WingtraOne',
  'Wingtra WingtraOne PPK',
  'Yuneec Typhoon H3',
  'Yuneec Typhoon H Plus',
  'Yuneec Typhoon H520E/520',
  'DJI Mavic 4 Pro',
  'DJI Matrice 3D',
  'DJI Matrice 3TD',
  'DJI Matrice 4D',
  'DJI Matrice 4E',
  'DJI Matrice 4T',
  'DJI Air 3S',
  'DJI Agras T20',
  'DJI Agras T25',
  'DJI Agras T50',
  'Autel EVO Max 4N',
  'Autel EVO Max 4T',
  'Skydio 2+',
  'Skydio X10',
  'Skydio X2E',
  'Parrot ANAFI Ai',
  'Yuneec H850-RTK',
  'Freefly Alta X',
  'Wingtra WingtraOne Gen II',
  'Autel Dragonfish Series',
  'Underwater drone',
  'DJI Matrice 400',
  'DJI Mini 5 Pro',
];

export const sensorsCamerasList = [
  'Thermal',
  'Laser (LIDAR)',
  'RGB image',
  'Multispectral',
  'Hyperspectral',
  'Ground Data Capture',
];

export const sensorList = ['Thermal', 'Rgb', 'Laser', 'Multispectral', 'Hyperspectral'];

export const groundCaptureEquipment = [
  'Insta 360 ONE',
  'Insta 360 ONE X',
  'Insta 360 ONE R',
  'Insta 360 ONE RS',
  'Insta 360 ONE X2',
  'Insta 360 X3',
  'Insta 360 GO',
  'Insta 360 GO 2',
  'Insta 360 GO 3',
  'Insta 360 Ace',
  'Insta 360 Ace Pro',
  'Insta 360 Titan',
  'Insta 360 Pro 2',
  'Matterport Pro2',
  'Matterport Pro3',
  'Leica BLK360',
  'None',
  'Other',
];

export const baseStations = ['DJI D-RTK 2 Mobile Station', 'Emlid Reach RS3', 'None', 'Other'];

export const InitialRequirements = ['Just data capture', 'other'];

export const ObjectTypes = ['Area', 'Linear', 'Individual Assests', 'Other'];

export const UploadTo = ['Crowddroning API', 'Another platform'];

export const Services = [
  'Just data',
  'Project management',
  'Regulatory / permitting',
  'tech support / training',
  'Reporting',
  'Other',
];

export const whoWillDoThis = ['Pilot', 'Globhe', '3rd party'];

export const SalesAssistantStatus = {
  complicated: 'Complicated',
  feasible: 'Feasible',
  notFeasible: 'Not Feasible',
};

export const SalesAssistantStatusName = {
  complicated: 'COMPLICATED',
  feasible: 'FEASIBLE',
  notFeasible: 'NOT FEASIBLE',
};

export const InitialStateMessage = {
  NoSelect: 'No value is selected. Standard procedure will be applied.',
};

export const InitialRequirementsMessages = {
  JustDataCapture: 'Just data capture is feasible and falls within the Crowddroning scope',
  Other: 'Requirements other than data capture require more work',
};

export const TypeMessages = {
  Area: 'Area objects are feasible and fall within the Crowddroning scope',
  Linear: 'Linear objects require more batteries and constant displacement of the pilot',
  IndividualAssets: 'Individual assets are usually ok but some of them are complicated. Check the type of asse',
  Other: 'Other types are complicated as they are not standard. Check the size and operational feasibility  ',
};

export const SizeMessages = {
  AreaSizeFeasible: 'Areas less than 1 km2 are feasible under a day of work Areas',
  AreaSizeComplicated: 'Areas more than 1 km2 are complicated and require more time',
  LinearSizeFeasible: 'Linear objects less than 300 m long are feasible under a day of work ',
  LinearSizeComplicated: 'Linear objects more than 300 m long are complicated and require more time',
  IndividualAssetsSizeFeasible:
    'Individual assets with an underlying surface area less than 300 m2 are feasible under a day of work. Check the type of asset first.',
  IndividualAssetsSizeComplicated:
    'Individual assets with an underlying surface area more than 300 m2 are complicated and require more time',
};

export const CountryMessages = {
  CountryNotFeasible: 'This country is on a forbidden list. Drones cannot fly there',
  CountryComplicated:
    'It is complicated to obtain a permit in this country and fly a drone. Check regulations with local pilots before you get back to client',
};

export const PilotMessages = {
  PilotFeasible: 'It is possible to fly in this country and we have more than 10 pilots there',
  PilotComplicated: 'It is possible to fly in this country but we have less than 10 pilots there',
  PilotNotFeasible: 'It is possible to fly in this country but we have no pilots there  ',
};

export const DroneTypeMessages = {
  DroneFeasible: 'No requirement for a drone type is the best so we can use all that is found in crowddroning',
  DroneComplicated:
    'Choosing a specific drone type is complicated. Check if we have enough operator having that in that country',
};

export const SensorsCamerasMessages = {
  SensorFeasible: 'No requirement for a sensor is good because we can use an RGB camera',
  SensorComplicated:
    'Choosing a specific sensor type is complicated. Check if we have enough operator having that in that country',
};

export const TimeOfTheDay = {
  TimeDayFeasible: 'No specific time of the day is best because the operator can choose when is the best time to fly',
  TimeDayComplicated: 'Having a specific time to fly might be complicated',
};

export const Weather = {
  WeatherFeasible: 'No specific weather is best because the operator can choose when is the best time to fly',
  WeatherComplicated: 'Having a specific weather to fly might be complicated',
};

export const Altitude = {
  AltitudeFeasible: 'Our standard altitude is 110 m so it is good',
  AltitudeComplicated:
    'Choosing an altitude less than 110 requires more time and more batteries, and therefore might be complicated',
  AltitudeNotFeasible: 'Choosing an altitude more than 120m is not allowed by law',
};

export const DroneOtherRequest = {
  OtherComplicated: 'For any other request, check what it entails exactly as it might be complicated',
};

export const ProductTypeMessages = {
  ProductFeasible: 'This product type is offered by Crowddroning',
  ProductComplicated:
    'This product type is not offered by Crowddroning so it is complicated to  use it in this project',
};

export const ProcessDataMessages = {
  ProcessDataFeasible: 'Globhe or the operator can process the data. Unprocessed data is also acceptable and delivered',
};

export const ResolutionMessages = {
  ResolutionFeasible: 'Resolution lower than 1.5 cm is accepted and feasible',
  ResolutionComplicated:
    'Resolution higher than 1.5 cm is difficult as the drones must fly lower so it takes more time and batteries',
};

export const UploadTomessages = {
  UploadToFeasible: 'Uploading to Crowddroning or using the API is the best',
  UploadToComplicated: 'Uploading to another platform is complicated as we want to own all the data',
};

export const SpecificAcceptanceMessages = {
  SpecificComplicated:
    'Other specific acceptance criteria are complicated. Check with the client and operations on how to move forward. This product type is not offered by Crowddroning so it is complicated to use it in this project ',
};

export const OneTimeMessages = {
  OneTimeFeasible: 'A single order is easy and feasible',
  OneTimeComplicated: 'Recurrent orders are more complicated. Fill in the details below to get more answers',
};

export const RecAreaMessages = {
  RecAreaFeasible: 'Repeating the mission in the same area is ok',
  RecAreaComplicated: 'Repeating the mission in different areas might be complicated',
};

export const RecInternal = {
  RecInternalFeasible: 'A regular time between repeated missions is ok',
  RecInternalComplicated: 'An irregular time between repeated missions might be complicated',
};

export const DeadlineMessages = {
  DeadlineFeasible: 'A deadline longer than in 2 weeks is ok to start planning and get pilots',
  DeadlineComplicated: 'A deadline less than in 2 weeks is too short to start planning and inviting pilots',
};

export const ServicesMessages = {
  ServiceFeasible: 'Ordering just data from Globhe is the best and easiest',
  ServiceComplicated: 'Services other than just ordering data might be complicated and incur additional costs',
};

export const WhoWillMessages = {
  WhoWillComplicated:
    'If pilots, Globhe or a 3rd party will perform this services, this might incur additional costs and might be complicated. Check with operations if this is feasible',
};

export const estimatedPriceMessages = {
  PriceMsg:
    'Is the estimated price for this project based on your USD/MB and if all fields are marked green. For fields marked in yellow, they will increase the costs of this project and higher the pricing. Check with operations if they are feasible',
};

export const mappingProcessing = [
  'Agisoft Metashape',
  'ArcGIS Drone2Map',
  'Autodesk ReCap',
  'Autodesk ReCap Photo',
  'Bentley ContextCapture',
  'CloudCompare',
  'DJI Terra',
  'DroneDeploy',
  'DroneMapper',
  'FME',
  'LASTools',
  'LiDAR360',
  'LP360',
  'Maps Made Easy',
  'OpenDroneMap',
  'Pix4Dcloud',
  'Pix4Dmapper',
  'Pix4Dmatic',
  'Propeller Aero',
  'RealityCapture',
  'RealityScan',
  'SimActive Correlator3D',
  'Skycatch',
  'WebODM',
  '3DF Zephyr',
  'None',
  'Other',
];

export const referralSourceList = [
  'Search Engine',
  'LinkedIn',
  'Instagram',
  'Youtube',
  'twitter',
  'Recommended by friend or colleague',
  'Conference or public event',
  'Globhe Drone Operator Challenge',
  'Contacted by Globhe',
  'Other(please specify)',
];

export const checkboxOptionsProfile = [
  {
    label: 'I am a certified drone operator',
    name: 'permissionToFly',
  },
  {
    label: 'I’ve got a registered business',
    name: 'registeredBusiness',
  },
  {
    label: 'I’m insured',
    name: 'insurance',
  },
  {
    label: 'My company holds operator-level authorizations',
    name: 'permit',
  },
];
export const preferredPaymentMethods = ['PayPal', 'Bank Account'];

export const skillsList = [
  '3D modelling',
  'Aviation principles',
  'GIS',
  'Image editing',
  'Photography',
  'Reading and creating maps',
  'Object detection & classification using AI',
];
export const indudstryList = [
  'Agriculture',
  'Aid and relief',
  'Aviation',
  'Construction and Infrastructure',
  'Electrical power',
  'Energy',
  'Environment',
  'Forestry',
  'Health',
  'Insurance',
  'Real estate',
  'Telecom',
  'Waste and recycling',
  'Water',
  'Other',
];
export const areaUnits = {
  sqkm: 'sq km',
  sqm: 'sq m',
  hectare: 'hectare',
  sqmiles: 'sq miles',
};

export const areaUnitV2 = {
  km: 'km',
  assets: 'assets',
  hectare: 'hectare',
};

export const globheMainURL = 'https://www.globhe.com';

export const alternativeBankOption = [
  {
    label: 'Paypal',
    value: 'paypal',
  },
  {
    label: 'Skrill',
    value: 'skrill',
  },
];

export const FilterFields = [
  'Name/Email',
  'Country',
  'Drone',
  'Available Locations',
  'Sensors/Cameras',
  'Minimum Megapixels',
  'City',
  'Overall Rating',
  'Project Management (Rating)',
  'Data Quality (Rating)',
  'Pricing (Rating)',
  'Communication (Rating)',
  'Insurance',
  'License',
  'Registered Company',
];

export const columnForPilotAllMissionList = [
  {
    id: 'id',
    label: 'Data ID #',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'missionName',
    label: 'Dataset name',
    align: 'left',
    field: 'normal',
    sort: true,
  },
  {
    id: 'locationLabel',
    label: 'Location',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Created',
    align: 'left',
    field: 'date',
    sort: true,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'pilotMissionStatus',
    sort: false,
  },
];

export const OrderTypeConstant = {
  area: 'area',
  linear: 'linear',
  assets: 'assets',
};

export const rejectFeedBackString = `We love to hear your feedback to improve our operations and invite you to more meaningful missions.
Can you please tell us why this mission was not interesting for you?`;

export const pilotInterestWithPriceStr = `This is the total, all-inclusive amount you will be paid if selected and the work is completed. To confirm your interest, please submit your fee in USD or EUR. Globhe will review all bids, select the most suitable Drone Operator for the project, and forward the quote to the Client. You can update your bid at any time. In the Additional Notes section you can write any information you feel is important for Globhe to know, such as which equipment you would use.`;

export const pilotBundleInterestWithPriceStr = (country) =>
  `This is your total payment for completing all missions in ${country} for this project. Submit your bid in $USD to confirm interest. Globhe will select the best operator for these missions.`;

export const pilotInterestWithoutPriceStr = ` When showing interest, you are added to the pool of drone
operators that are interested in taking this mission. A Globhe mission representative will select
the most appropriate operator for this project`;

export const MBprice = {
  area: 0.05,
  linear: 0.035,
};

export const OrderTypeMBSize = {
  area: 100 * 163,
  linear: 2000,
  assets: 815,
};
export const OrderTypePrice = {
  area: 100 * 163 * MBprice.area,
  linear: 2000 * MBprice.linear,
  assets: 200,
};

export const subsIndusryCat = {
  health: 'Health',
  enviroment: 'Enviroment',
  metaverse: 'Metaverse',
  infrastructure: 'Infrastructure',
  energy: 'Energy',
  insurance: 'Insurance',
};

export const zones = [
  { name: 'zone 1', id: 1 },
  { name: 'zone 2', id: 2 },
  { name: 'zone 3', id: 3 },
  { name: 'zone 4', id: 4 },
];

export const productTypeContent = {
  'individual assets':
    'This includes telecom towers, wind turbines, metaverse objects, houses, and any stand alone object that needs inspection or 3D modelling. Individual assets do not include projects that require orthomosaic maps. It is priced per site and per order.',
  area: 'This includes projects that require mapping of surfaces and includes orthomosaic maps, thermal maps, elevation models, DTM, DSM, among others. It is priced by hectares.',
  linear:
    'This includes projects that require mapping of linear  objects such as roads, railroads, and electrical cables. It is priced per km.',
};

export const recurringIntervals = {
  day: 'day',
  week: 'week',
  month: 'month',
  year: 'year',
};

export const deadlineDayForIntervals = {
  day: 1,
  week: 3,
  month: 7,
  year: 14,
};

export const recurringIntervalsArray = ['day', 'week', 'month', 'year'];

export const intervalOptions = [
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'year', label: 'Year' },
];
export const missionPlanningStatus = {
  active: 'active',
  inActive: 'inActive',
};

export const missionPlanningType = {
  preFlight: 'preFlight',
  postFlight: 'postFlight',
};

export const missionPlanningStatusLabel = {
  reschedule: { label: 'Mission rescheduled', color: 'red' },
  notFeasible: { label: 'Mission not feasible', color: 'red' },
  reviewed: { label: 'Mission reviewed', color: 'green' },
  canelled: { label: 'Mission cancelled', color: 'red' },
  inReview: { label: 'Being reviewed', color: 'grey' },
  pendingUpload: { label: 'Issue in collecting data', color: 'grey' },
  readyToUpload: { label: 'Data collected', color: 'green' },
  completed: { label: 'Mission completed', color: 'green' },
  delayed: { label: 'Flying delayed', color: 'red' },
};

export const missionPlanningStates = {
  reschedule: 'reschedule',
  onTime: 'onTime',
  early: 'early',
  notFeasible: 'notFeasible',
  inReview: 'inReview',
  reviewed: 'reviewed',
  readyToUpload: 'readyToUpload',
  pendingUpload: 'pendingUpload',
  canelled: 'canelled',
  delayed: 'delayed',
  noData: 'noData',
};

export const missionFeasibility = {
  yes: 'Yes',
  no: 'No',
  review: 'Reviewed',
};

export const siteNotFeasibleReason = [
  'Restricted airspace',
  'Needs special permits',
  'Located on a private property',
  'Dangerous area',
  'Located at country boundaries',
  'Located close to airfields',
  'Other',
];

export const intervalEndOption = [
  { label: 'On', name: 'intervalEndOn' },
  { label: 'After', name: 'intervalEndAfter' },
];

export const subsIndustries = [
  {
    name: 'Public/global health',
    id: 1,
    category: subsIndusryCat.health,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Water health',
    id: 2,
    category: subsIndusryCat.health,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Disaster prevention & response',
    id: 3,
    category: subsIndusryCat.health,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Agriculture',
    id: 4,
    category: subsIndusryCat.enviroment,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Forestry',
    id: 5,
    category: subsIndusryCat.enviroment,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Fishing',
    id: 6,
    category: subsIndusryCat.enviroment,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Wild life',
    id: 7,
    category: subsIndusryCat.enviroment,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Metaverse',
    id: 8,
    category: subsIndusryCat.metaverse,
    orderType: OrderTypeConstant.assets,
  },
  {
    name: 'Mining',
    id: 9,
    category: subsIndusryCat.infrastructure,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Telecom inspection',
    id: 10,
    category: subsIndusryCat.infrastructure,
    orderType: OrderTypeConstant.assets,
  },
  {
    name: 'Transportation',
    id: 11,
    category: subsIndusryCat.infrastructure,
    orderType: OrderTypeConstant.linear,
  },
  {
    name: 'Smart city planing',
    id: 12,
    category: subsIndusryCat.infrastructure,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Construction',
    id: 13,
    category: subsIndusryCat.eneinfrastructurergy,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Land use planning',
    id: 14,
    category: subsIndusryCat.infrastructure,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Port management',
    id: 15,
    category: subsIndusryCat.infrastructure,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Electric utility/powerline inspection',
    id: 16,
    category: subsIndusryCat.energy,
    orderType: OrderTypeConstant.linear,
  },
  {
    name: 'Solar parks',
    id: 17,
    category: subsIndusryCat.energy,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Wind turbine inspection',
    id: 18,
    category: subsIndusryCat.energy,
    orderType: OrderTypeConstant.assets,
  },
  {
    name: 'Flood',
    id: 19,
    category: subsIndusryCat.insurance,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Hurricane',
    id: 20,
    category: subsIndusryCat.insurance,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Wildfire',
    id: 21,
    category: subsIndusryCat.insurance,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Earthquake',
    id: 22,
    category: subsIndusryCat.insurance,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Landslide',
    id: 23,
    category: subsIndusryCat.insurance,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Avalanche',
    id: 24,
    category: subsIndusryCat.insurance,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Disaser prevention',
    id: 25,
    category: subsIndusryCat.insurance,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Risk management & assessment',
    id: 26,
    category: subsIndusryCat.insurance,
    orderType: OrderTypeConstant.area,
  },
  {
    name: 'Accelerate claim prices',
    id: 27,
    category: subsIndusryCat.insurance,
    orderType: OrderTypeConstant.area,
  },
];

export const subsContinent = {
  africa: 'Africa',
  southAmerica: 'South America',
  asia: 'Asia',
  centralAmerica: 'Central America',
  northAmerica: 'North America',
  europe: 'Europe',
  oceania: 'Oceania',
};

export const subsCountries = [
  {
    name: 'Algeria',
    id: 1,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'DZ',
  },
  {
    name: 'Angola',
    id: 2,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'AO',
  },
  {
    name: 'Benin',
    id: 3,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'BJ',
  },
  {
    name: 'Botswana',
    id: 4,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'BW',
  },
  {
    name: 'Burkina Faso',
    id: 5,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'BF',
  },
  {
    name: 'Burundi',
    id: 6,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'BI',
  },
  {
    name: 'Cameron',
    id: 7,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'CM',
  },
  {
    name: 'Cape Verde',
    id: 8,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'CV',
  },
  {
    name: 'Central African Republic',
    id: 9,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'CF',
  },
  {
    name: 'Chad',
    id: 10,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'TD',
  },
  {
    name: 'Comoros',
    id: 11,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'KM',
  },
  {
    name: 'Djibouti',
    id: 12,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'DJ',
  },
  {
    name: 'Egypt',
    id: 13,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'EG',
  },
  {
    name: 'Equatorial Guinea',
    id: 14,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'GQ',
  },
  {
    name: 'Eritea',
    id: 15,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'ER',
  },
  {
    name: 'Eswatini',
    id: 16,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'SZ',
  },
  {
    name: 'Ethiopia',
    id: 17,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'ET',
  },
  {
    name: 'Gabon',
    id: 18,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'GA',
  },
  {
    name: 'Gambia',
    id: 19,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'GM',
  },
  {
    name: 'Guinea',
    id: 20,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'GN',
  },
  {
    name: 'Guinea-Bissau',
    id: 21,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'GW',
  },
  {
    name: 'Ivory Coast',
    id: 22,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'CI',
  },
  {
    name: 'Kenya',
    id: 23,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'KE',
  },
  {
    name: 'Lesotho',
    id: 24,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'LS',
  },
  {
    name: 'Liberia',
    id: 25,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'LR',
  },
  {
    name: 'Libya',
    id: 26,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'LY',
  },
  {
    name: 'Malawi',
    id: 27,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'MW',
  },
  {
    name: 'Mali',
    id: 28,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'ML',
  },
  {
    name: 'Mauritania',
    id: 29,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'MR',
  },
  {
    name: 'Mauritius',
    id: 31,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'MU',
  },
  {
    name: 'Morocco',
    id: 32,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'MA',
  },
  {
    name: 'Mozambique',
    id: 33,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'MZ',
  },
  {
    name: 'Namibia',
    id: 34,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'NA',
  },
  {
    name: 'Niger',
    id: 35,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'NE',
  },
  {
    name: 'Republic of the Congo',
    id: 36,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'CG',
  },
  {
    name: 'Rwanda',
    id: 37,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'RW',
  },
  {
    name: 'Sahrawi Arab Democratic Republic',
    id: 38,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'ET',
  },
  {
    name: 'Sao Tome and Principle',
    id: 39,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'ST',
  },
  {
    name: 'Senegal',
    id: 40,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'SN',
  },
  {
    name: 'Seychelles',
    id: 41,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'SC',
  },
  {
    name: 'Sierra Leone',
    id: 42,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'SL',
  },
  {
    name: 'Somalia',
    id: 43,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'SO',
  },
  {
    name: 'South Sudan',
    id: 44,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'SS',
  },
  {
    name: 'Sudan',
    id: 45,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'SD',
  },
  {
    name: 'Tanzania',
    id: 46,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'TZ',
  },
  {
    name: 'Togo',
    id: 47,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'TG',
  },
  {
    name: 'Tunisia',
    id: 48,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'TN',
  },
  {
    name: 'Uganda',
    id: 49,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'UG',
  },
  {
    name: 'Zambia',
    id: 50,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'ZM',
  },
  {
    name: 'Zimbabwe',
    id: 51,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'ZW',
  },
  {
    name: 'Argentina',
    id: 52,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'AR',
  },
  {
    name: 'Bolivia',
    id: 53,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'BO',
  },
  {
    name: 'Bouvet Island',
    id: 54,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'BV',
  },
  {
    name: 'Chile',
    id: 55,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'CL',
  },
  {
    name: 'Colombia',
    id: 56,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'CO',
  },
  {
    name: 'Ecuador',
    id: 57,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'EC',
  },
  {
    name: 'Falkland Islands (United Kingdom)',
    id: 58,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'FK',
  },
  {
    name: 'French Guiana (France)',
    id: 59,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'GF',
  },
  {
    name: 'Guyana',
    id: 60,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'GY',
  },
  {
    name: 'Paraguay',
    id: 61,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'PY',
  },
  {
    name: 'Peru',
    id: 62,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'PE',
  },
  {
    name: 'South Georgia and the South Sandwich Islands (United Kingdom)',
    id: 63,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'GS',
  },
  {
    name: 'Suriname',
    id: 64,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'SR',
  },
  {
    name: 'Uruguay',
    id: 65,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'UY',
  },
  {
    name: 'Venezuela',
    id: 66,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'VE',
  },
  {
    name: 'Afganistan',
    id: 67,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'AF',
  },
  {
    name: 'Bahrain',
    id: 70,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'BH',
  },
  {
    name: 'Bangladesh',
    id: 71,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'BD',
  },
  {
    name: 'Brunei',
    id: 72,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'BN',
  },
  {
    name: 'Combodia',
    id: 73,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'KH',
  },
  {
    name: 'China',
    id: 74,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'CN',
  },
  {
    name: 'India',
    id: 78,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'IN',
  },
  {
    name: 'Indonesia',
    id: 79,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'ID',
  },
  {
    name: 'Iran',
    id: 80,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'IR',
  },
  {
    name: 'Iraq',
    id: 81,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'IQ',
  },
  {
    name: 'Israel',
    id: 82,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'IL',
  },
  {
    name: 'Japan',
    id: 83,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'JP',
  },
  {
    name: 'Jordan',
    id: 84,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'JO',
  },
  {
    name: 'Kuwait',
    id: 86,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    id: 87,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'KG',
  },
  {
    name: 'Laos',
    id: 88,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'LA',
  },

  {
    name: 'Lebanon',
    id: 89,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'LB',
  },

  {
    name: 'Malaysia',
    id: 90,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'MY',
  },
  {
    name: 'Maldives',
    id: 91,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'MV',
  },

  {
    name: 'Mongolia',
    id: 92,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'MN',
  },

  {
    name: 'Myanmar',
    id: 93,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'MM',
  },
  {
    name: 'Nepal',
    id: 94,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'NP',
  },
  {
    name: 'Oman',
    id: 95,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'OM',
  },
  {
    name: 'Pakistan',
    id: 96,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'PK',
  },
  {
    name: 'Palestine',
    id: 97,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'PS',
  },

  {
    name: 'Philippines',
    id: 98,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'PH',
  },
  {
    name: 'Qatar',
    id: 99,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'QA',
  },

  {
    name: 'Saudi Arabia',
    id: 100,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'SA',
  },

  {
    name: 'Singapore',
    id: 101,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'SG',
  },
  {
    name: 'South Korea',
    id: 102,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'KR',
  },

  {
    name: 'Sri Lanka',
    id: 103,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'LK',
  },
  {
    name: 'Taiwan',
    id: 104,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'TW',
  },

  {
    name: 'Tajikistan',
    id: 105,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'TJ',
  },
  {
    name: 'Thailand',
    id: 106,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'TH',
  },

  {
    name: 'Timor-Leste',
    id: 107,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'TL',
  },
  {
    name: 'Turkmenistan',
    id: 109,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'TM',
  },
  {
    name: 'United Arab Emirates',
    id: 110,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'AE',
  },
  {
    name: 'Uzebkistan',
    id: 111,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'UZ',
  },
  {
    name: 'Vietnam',
    id: 112,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'VN',
  },

  {
    name: 'Yemen',
    id: 113,
    zoneNum: 1,
    continent: subsContinent.asia,
    countryCode: 'YE',
  },
  {
    name: 'Belize',
    id: 114,
    zoneNum: 1,
    continent: subsContinent.centralAmerica,
    countryCode: 'BZ',
  },
  {
    name: 'Costa Rica',
    id: 115,
    zoneNum: 1,
    continent: subsContinent.centralAmerica,
    countryCode: 'CR',
  },
  {
    name: 'El Salvador',
    id: 116,
    zoneNum: 1,
    continent: subsContinent.centralAmerica,
    countryCode: 'SV',
  },
  {
    name: 'Guatemala',
    id: 117,
    zoneNum: 1,
    continent: subsContinent.centralAmerica,
    countryCode: 'GT',
  },
  {
    name: 'Honduras',
    id: 118,
    zoneNum: 1,
    continent: subsContinent.centralAmerica,
    countryCode: 'HN',
  },
  {
    name: 'Nicaragua',
    id: 119,
    zoneNum: 1,
    continent: subsContinent.centralAmerica,
    countryCode: 'NI',
  },
  {
    name: 'Panama',
    id: 120,
    zoneNum: 1,
    continent: subsContinent.centralAmerica,
    countryCode: 'PA',
  },
  {
    name: 'Anguilla',
    id: 121,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'AI',
  },
  {
    name: 'Antigua and Barbuda',
    id: 121,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'AG',
  },
  {
    name: 'Aruba (Kingdom of the Netherlands)',
    id: 122,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'AW',
  },
  {
    name: 'The Bahamas',
    id: 123,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'BS',
  },
  {
    name: 'Barbados',
    id: 124,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'BB',
  },
  {
    name: 'Bermuda (United Kingdom)',
    id: 125,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'BM',
  },
  {
    name: 'Bonaire (Kingdom of the Netherlands)',
    id: 126,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'BQ',
  },
  {
    name: 'British Virgin Islands (United Kingdom)',
    id: 127,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'VG',
  },
  {
    name: 'Cayman Islands (United Kingdom)',
    id: 128,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'KY',
  },
  {
    name: 'Clipperton Island (France)',
    id: 129,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'CP',
  },
  {
    name: 'Cuba',
    id: 130,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'CU',
  },
  {
    name: 'Curaçao (Kingdom of the Netherlands)',
    id: 131,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'CW',
  },
  {
    name: 'Dominica',
    id: 132,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'DM',
  },
  {
    name: 'Dominican Republic',
    id: 133,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'DO',
  },
  {
    name: 'Federal Dependencies of Venezuela (Venezuela)',
    id: 132,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'VE',
  },
  {
    name: 'Grenada',
    id: 133,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'GD',
  },
  {
    name: 'Guadeloupe (France)',
    id: 134,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'GP',
  },
  {
    name: 'Haiti',
    id: 135,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'HT',
  },
  {
    name: 'Jamaica',
    id: 136,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'JM',
  },
  {
    name: 'Martinique',
    id: 137,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'MQ',
  },
  {
    name: 'Mexico',
    id: 139,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'MX',
  },
  {
    name: 'Montserrat (United Kingdom)',
    id: 140,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'MS',
  },
  {
    name: 'Nueva Esparta (Venezuela)',
    id: 141,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'VE',
  },
  {
    name: 'Puerto Rico (United States)',
    id: 142,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'PR',
  },
  {
    name: 'Saba (Kingdom of the Netherlands)',
    id: 143,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'BQ',
  },
  {
    name: 'San Andrés and Providencia (Colombia)',
    id: 144,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'CO',
  },
  {
    name: 'Saint Barthélemy (France)',
    id: 145,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'BL',
  },
  {
    name: 'Saint Lucia',
    id: 146,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'LC',
  },
  {
    name: 'Saint Martin (France)',
    id: 147,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'MF',
  },
  {
    name: 'Saint Pierre and Miquelon (France)',
    id: 148,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'PM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    id: 149,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'VC',
  },

  {
    name: 'Sint Eustatius (Kingdom of the Netherlands)',
    id: 150,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'BQ',
  },
  {
    name: 'Sint Maarten (Kingdom of the Netherlands)',
    id: 151,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'SX',
  },
  {
    name: 'Trinidad and Tobago',
    id: 152,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'TT',
  },
  {
    name: 'Turks and Caicos Islands (United Kingdom)',
    id: 153,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'TC',
  },
  {
    name: 'United States of America (the)',
    id: 154,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'US',
  },
  {
    name: 'United States Virgin Islands (United States)',
    id: 155,
    zoneNum: 2,
    continent: subsContinent.northAmerica,
    countryCode: 'VI',
  },
  {
    name: 'Albania',
    id: 156,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'AL',
  },
  {
    name: 'Andorra',
    id: 157,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'AD',
  },
  {
    name: 'Armenia',
    id: 158,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'AM',
  },
  {
    name: 'Azerbaijan',
    id: 159,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'AZ',
  },
  {
    name: 'Belarus',
    id: 160,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'BY',
  },
  {
    name: 'Bosnia and Herzegovina',
    id: 161,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'BA',
  },
  {
    name: 'Bulgaria',
    id: 162,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'BG',
  },
  {
    name: 'Croatia',
    id: 163,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'HR',
  },
  {
    name: 'Cyprus',
    id: 164,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'CY',
  },
  {
    name: 'Czechia',
    id: 165,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'CZ',
  },

  {
    name: 'Estonia',
    id: 166,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'EE',
  },
  {
    name: 'Georgia',
    id: 167,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'GE',
  },
  {
    name: 'Greece',
    id: 168,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'GR',
  },

  {
    name: 'Hungary',
    id: 169,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'HU',
  },
  {
    name: 'Iceland',
    id: 170,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'IS',
  },
  {
    name: 'Kazakhstan',
    id: 171,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'KZ',
  },
  {
    name: 'Kosovo',
    id: 172,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'XK',
  },
  {
    name: 'Latvia',
    id: 173,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'LV',
  },
  {
    name: 'Liechtenstein',
    id: 174,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'LI',
  },
  {
    name: 'Lithuania',
    id: 175,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'LT',
  },

  {
    name: 'Malta',
    id: 176,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'MT',
  },
  {
    name: 'Moldova',
    id: 177,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'MD',
  },

  {
    name: 'Montenegro',
    id: 178,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'ME',
  },

  {
    name: 'North Macedonia',
    id: 179,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'MK',
  },
  {
    name: 'Poland',
    id: 180,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'PL',
  },

  {
    name: 'Portugal',
    id: 181,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'PT',
  },
  {
    name: 'Romania',
    id: 182,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'RO',
  },
  {
    name: 'San Marino',
    id: 183,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'SM',
  },
  {
    name: 'Serbia',
    id: 184,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'RS',
  },

  {
    name: 'Slovakia',
    id: 185,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'SK',
  },
  {
    name: 'Slovenia',
    id: 186,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'SI',
  },
  {
    name: 'Spain',
    id: 187,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'ES',
  },
  {
    name: 'Turkey',
    id: 188,
    zoneNum: 2,
    continent: subsContinent.europe,
    countryCode: 'TR',
  },
  {
    name: 'South Africa',
    id: 190,
    zoneNum: 2,
    continent: subsContinent.africa,
    countryCode: 'ZA',
  },
  {
    name: 'Nigeria',
    id: 191,
    zoneNum: 2,
    continent: subsContinent.africa,
    countryCode: 'NG',
  },
  {
    name: 'Ghana',
    id: 192,
    zoneNum: 2,
    continent: subsContinent.africa,
    countryCode: 'GH',
  },
  {
    name: 'Madagascar',
    id: 193,
    zoneNum: 2,
    continent: subsContinent.africa,
    countryCode: 'MG',
  },
  {
    name: 'Greenland (Kingdom of Denmark)',
    id: 194,
    zoneNum: 3,
    continent: subsContinent.northAmerica,
    countryCode: 'GL',
  },
  {
    name: 'Canada',
    id: 195,
    zoneNum: 3,
    continent: subsContinent.northAmerica,
    countryCode: 'CA',
  },
  {
    name: 'Austria',
    id: 196,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'AT',
  },
  {
    name: 'Belgium',
    id: 197,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'BE',
  },
  {
    name: 'Denmark',
    id: 198,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'DK',
  },
  {
    name: 'Finland',
    id: 199,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'FI',
  },
  {
    name: 'France',
    id: 200,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'FR',
  },
  {
    name: 'Germany',
    id: 201,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'DE',
  },
  {
    name: 'Ireland',
    id: 202,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'IE',
  },
  {
    name: 'Italy',
    id: 203,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'IT',
  },

  {
    name: 'Luxembourg',
    id: 204,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'LU',
  },
  {
    name: 'Netherlands',
    id: 205,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'NL',
  },
  {
    name: 'Monaco',
    id: 206,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'MC',
  },
  {
    name: 'Norway',
    id: 207,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'NO',
  },
  {
    name: 'Sweden',
    id: 208,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'SE',
  },

  {
    name: 'Switzerland',
    id: 209,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'CH',
  },
  {
    name: 'United Kingdom',
    id: 210,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'GB',
  },
  {
    name: 'Vatican City',
    id: 211,
    zoneNum: 3,
    continent: subsContinent.europe,
    countryCode: 'VA',
  },
  {
    name: 'Australia',
    id: 212,
    zoneNum: 3,
    continent: subsContinent.oceania,
    countryCode: 'AU',
  },
  {
    name: 'New Zealand',
    id: 213,
    zoneNum: 3,
    continent: subsContinent.oceania,
    countryCode: 'NZ',
  },
  {
    name: 'Bhutan',
    id: 214,
    zoneNum: 3,
    continent: subsContinent.asia,
    countryCode: 'BT',
  },
  {
    name: 'Brazil',
    id: 215,
    zoneNum: 1,
    continent: subsContinent.southAmerica,
    countryCode: 'BR',
  },
  {
    name: 'Congo (the Democratic Republic of the)',
    id: 216,
    zoneNum: 1,
    continent: subsContinent.africa,
    countryCode: 'CD',
  },
];

export const planTypeConstant = {
  basic: 'Basic',
  advanced: 'Advanced',
  premium: 'Premium',
};

export const subTypeConstant = {
  basic: 'basic',
  advance: 'advance',
  premium: 'premium',
};

export const priceUnitConstant = {
  hectares: 'hectares',
  site: 'site',
  km: 'km',
};

export const subsPrice = {
  customOrder: {
    assets: [
      {
        zoneNum: 1,
        price: 700,
        coverage: 1,
        unlimited: false,
        unit: priceUnitConstant.site,
      },
      {
        zoneNum: 2,
        price: 3000,
        coverage: 1,
        unlimited: false,
        unit: priceUnitConstant.site,
      },
      {
        zoneNum: 3,
        price: 10000,
        coverage: 1,
        unlimited: false,
        unit: priceUnitConstant.site,
      },
      {
        zoneNum: 4,
        price: 20000,
        coverage: 1,
        unlimited: false,
        unit: priceUnitConstant.site,
      },
    ],
    area: [
      {
        zoneNum: 1,
        price: 815,
        unlimited: true,
        coverage: 'UNLIMITED',
        unit: priceUnitConstant.hectares,
      },
      {
        zoneNum: 2,
        price: 1467,
        unlimited: true,
        coverage: 'UNLIMITED',
        unit: priceUnitConstant.hectares,
      },
      {
        zoneNum: 3,
        price: 1956,
        unlimited: true,
        coverage: 'UNLIMITED',
        unit: priceUnitConstant.hectares,
      },
    ],
    linear: [
      {
        zoneNum: 1,
        price: 700,
        unlimited: true,
        coverage: 'UNLIMITED',
        unit: priceUnitConstant.km,
      },
      {
        zoneNum: 2,
        price: 3000,
        unlimited: true,
        coverage: 'UNLIMITED',
        unit: priceUnitConstant.km,
      },
      {
        zoneNum: 3,
        price: 10000,
        unlimited: true,
        coverage: 'UNLIMITED',
        unit: priceUnitConstant.km,
      },
      {
        zoneNum: 4,
        price: 20000,
        unlimited: true,
        coverage: 'UNLIMITED',
        unit: priceUnitConstant.km,
      },
    ],
  },
  basic: {
    assets: [
      {
        zoneNum: 1,
        price: 700,
        coverage: 12,
        unlimited: false,
        unit: priceUnitConstant.site,
      },
      {
        zoneNum: 2,
        price: 3000,
        coverage: 12,
        unlimited: false,
        unit: priceUnitConstant.site,
      },
      {
        zoneNum: 3,
        price: 10000,
        coverage: 12,
        unlimited: false,
        unit: priceUnitConstant.site,
      },
      {
        zoneNum: 4,
        price: 20000,
        coverage: 12,
        unlimited: false,
        unit: priceUnitConstant.site,
      },
    ],
    area: [
      {
        zoneNum: 1,
        price: 5000,
        coverage: 2500,
        unlimited: false,
        unit: priceUnitConstant.hectares,
      },
      {
        zoneNum: 2,
        price: 3000,
        coverage: 2500,
        unlimited: false,
        unit: priceUnitConstant.hectares,
      },
      {
        zoneNum: 3,
        price: 10000,
        coverage: 2500,
        unlimited: false,
        unit: priceUnitConstant.hectares,
      },
      {
        zoneNum: 4,
        price: 10000,
        coverage: 2500,
        unlimited: false,
        unit: priceUnitConstant.hectares,
      },
    ],
    linear: [
      {
        zoneNum: 1,
        price: 700,
        coverage: 500,
        unlimited: false,
        unit: priceUnitConstant.km,
      },
      {
        zoneNum: 2,
        price: 3000,
        coverage: 500,
        unlimited: false,
        unit: priceUnitConstant.km,
      },
      {
        zoneNum: 3,
        price: 10000,
        coverage: 500,
        unlimited: false,
        unit: priceUnitConstant.km,
      },
      {
        zoneNum: 4,
        price: 20000,
        coverage: 500,
        unlimited: false,
        unit: priceUnitConstant.km,
      },
    ],
  },
  advanced: {
    assets: [
      {
        zoneNum: 1,
        price: 700,
        coverage: 25,
        unlimited: false,
        unit: priceUnitConstant.site,
      },
      {
        zoneNum: 2,
        price: 3000,
        coverage: 25,
        unlimited: false,
        unit: priceUnitConstant.site,
      },
      {
        zoneNum: 3,
        price: 10000,
        coverage: 25,
        unlimited: false,
        unit: priceUnitConstant.site,
      },
      {
        zoneNum: 4,
        price: 20000,
        coverage: 25,
        unlimited: false,
        unit: priceUnitConstant.site,
      },
    ],
    area: [
      {
        zoneNum: 1,
        price: 700,
        coverage: 2500,
        unlimited: false,
        unit: priceUnitConstant.hectares,
      },
      {
        zoneNum: 2,
        price: 3000,
        coverage: 5000,
        unlimited: false,
        unit: priceUnitConstant.hectares,
      },
      {
        zoneNum: 3,
        price: 10000,
        coverage: 5000,
        unlimited: false,
        unit: priceUnitConstant.hectares,
      },
      {
        zoneNum: 4,
        price: 20000,
        coverage: 5000,
        unlimited: false,
        unit: priceUnitConstant.hectares,
      },
    ],
    linear: [
      {
        zoneNum: 1,
        price: 700,
        coverage: 1000,
        unlimited: false,
        unit: priceUnitConstant.km,
      },
      {
        zoneNum: 2,
        price: 3000,
        coverage: 1000,
        unlimited: false,
        unit: priceUnitConstant.km,
      },
      {
        zoneNum: 3,
        price: 10000,
        coverage: 1000,
        unlimited: false,
        unit: priceUnitConstant.km,
      },
      {
        zoneNum: 4,
        price: 20000,
        coverage: 1000,
        unlimited: false,
        unit: priceUnitConstant.km,
      },
    ],
  },
  unlimited: {
    assets: [
      {
        zoneNum: 1,
        price: 700,
        coverage: 25,
        unlimited: true,
        unit: priceUnitConstant.site,
      },
      {
        zoneNum: 2,
        price: 3000,
        coverage: 25,
        unlimited: true,
        unit: priceUnitConstant.site,
      },
      {
        zoneNum: 3,
        price: 10000,
        coverage: 25,
        unlimited: true,
        unit: priceUnitConstant.site,
      },
      {
        zoneNum: 4,
        price: 20000,
        coverage: 25,
        unlimited: true,
        unit: priceUnitConstant.site,
      },
    ],
    area: [
      {
        zoneNum: 1,
        price: 700,
        coverage: 2500,
        unlimited: true,
        unit: priceUnitConstant.hectares,
      },
      {
        zoneNum: 2,
        price: 3000,
        coverage: 5000,
        unlimited: true,
        unit: priceUnitConstant.hectares,
      },
      {
        zoneNum: 3,
        price: 10000,
        coverage: 5000,
        unlimited: true,
        unit: priceUnitConstant.hectares,
      },
      {
        zoneNum: 4,
        price: 20000,
        coverage: 5000,
        unlimited: true,
        unit: priceUnitConstant.hectares,
      },
    ],
    linear: [
      {
        zoneNum: 1,
        price: 700,
        coverage: 1000,
        unlimited: true,
        unit: priceUnitConstant.km,
      },
      {
        zoneNum: 2,
        price: 3000,
        coverage: 1000,
        unlimited: true,
        unit: priceUnitConstant.km,
      },
      {
        zoneNum: 3,
        price: 10000,
        coverage: 1000,
        unlimited: true,
        unit: priceUnitConstant.km,
      },
      {
        zoneNum: 4,
        price: 20000,
        coverage: 1000,
        unlimited: true,
        unit: priceUnitConstant.km,
      },
    ],
  },
};

export const subsType = {
  year: 'yearly',
  month: 'monthly',
};

export const subsDiscount = {
  year: 5,
};

export const subsMissionUpdateStatus = {
  cancelOrder: 'cancel',
  editOrder: 'update',
  addOrder: 'add',
  archiveOrder: 'archive',
  rejectOrder: 'reject',
  changeToCustomOrder: 'custom',
};

export const subsStatus = {
  active: 'active',
  inactive: 'inactive',
};

export const collaborationStatus = {
  active: 'active',
  inactive: 'inactive',
};

export const collaborationType = {
  clientMission: 'clientMission',
};

export const usaStatesList = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];
export const countryListAlpha3 = {
  AFG: 'Afghanistan',
  ALB: 'Albania',
  DZA: 'Algeria',
  ASM: 'American Samoa',
  AND: 'Andorra',
  AGO: 'Angola',
  AIA: 'Anguilla',
  ATA: 'Antarctica',
  ATG: 'Antigua and Barbuda',
  ARG: 'Argentina',
  ARM: 'Armenia',
  ABW: 'Aruba',
  AUS: 'Australia',
  AUT: 'Austria',
  AZE: 'Azerbaijan',
  BHS: 'Bahamas (the)',
  BHR: 'Bahrain',
  BGD: 'Bangladesh',
  BRB: 'Barbados',
  BLR: 'Belarus',
  BEL: 'Belgium',
  BLZ: 'Belize',
  BEN: 'Benin',
  BMU: 'Bermuda',
  BTN: 'Bhutan',
  BOL: 'Bolivia (Plurinational State of)',
  BES: 'Bonaire, Sint Eustatius and Saba',
  BIH: 'Bosnia and Herzegovina',
  BWA: 'Botswana',
  BVT: 'Bouvet Island',
  BRA: 'Brazil',
  IOT: 'British Indian Ocean Territory (the)',
  BRN: 'Brunei Darussalam',
  BGR: 'Bulgaria',
  BFA: 'Burkina Faso',
  BDI: 'Burundi',
  CPV: 'Cabo Verde',
  KHM: 'Cambodia',
  CMR: 'Cameroon',
  CAN: 'Canada',
  CYM: 'Cayman Islands (the)',
  CAF: 'Central African Republic (the)',
  TCD: 'Chad',
  CHL: 'Chile',
  CHN: 'China',
  CXR: 'Christmas Island',
  CCK: 'Cocos (Keeling) Islands (the)',
  COL: 'Colombia',
  COM: 'Comoros (the)',
  COD: 'Congo (the Democratic Republic of the)',
  COG: 'Congo (the)',
  COK: 'Cook Islands (the)',
  CRI: 'Costa Rica',
  HRV: 'Croatia',
  CUB: 'Cuba',
  CUW: 'Curaçao',
  CYP: 'Cyprus',
  CZE: 'Czechia',
  CIV: "Côte d'Ivoire",
  DNK: 'Denmark',
  DJI: 'Djibouti',
  DMA: 'Dominica',
  DOM: 'Dominican Republic (the)',
  ECU: 'Ecuador',
  EGY: 'Egypt',
  SLV: 'El Salvador',
  GNQ: 'Equatorial Guinea',
  ERI: 'Eritrea',
  EST: 'Estonia',
  SWZ: 'Eswatini',
  ETH: 'Ethiopia',
  FLK: 'Falkland Islands (the) [Malvinas]',
  FRO: 'Faroe Islands (the)',
  FJI: 'Fiji',
  FIN: 'Finland',
  FRA: 'France',
  GUF: 'French Guiana',
  PYF: 'French Polynesia',
  ATF: 'French Southern Territories (the)',
  GAB: 'Gabon',
  GMB: 'Gambia (the)',
  GEO: 'Georgia',
  DEU: 'Germany',
  GHA: 'Ghana',
  GIB: 'Gibraltar',
  GRC: 'Greece',
  GRL: 'Greenland',
  GRD: 'Grenada',
  GLP: 'Guadeloupe',
  GUM: 'Guam',
  GTM: 'Guatemala',
  GGY: 'Guernsey',
  GIN: 'Guinea',
  GNB: 'Guinea-Bissau',
  GUY: 'Guyana',
  HTI: 'Haiti',
  HMD: 'Heard Island and McDonald Islands',
  VAT: 'Holy See (the)',
  HND: 'Honduras',
  HKG: 'Hong Kong',
  HUN: 'Hungary',
  ISL: 'Iceland',
  IND: 'India',
  IDN: 'Indonesia',
  IRN: 'Iran (Islamic Republic of)',
  IRQ: 'Iraq',
  IRL: 'Ireland',
  IMN: 'Isle of Man',
  ISR: 'Israel',
  ITA: 'Italy',
  JAM: 'Jamaica',
  JPN: 'Japan',
  JEY: 'Jersey',
  JOR: 'Jordan',
  KAZ: 'Kazakhstan',
  KEN: 'Kenya',
  KIR: 'Kiribati',
  PRK: "Korea (the Democratic People's Republic of)",
  KOR: 'Korea (the Republic of)',
  KWT: 'Kuwait',
  KGZ: 'Kyrgyzstan',
  LAO: "Lao People's Democratic Republic (the)",
  LVA: 'Latvia',
  LBN: 'Lebanon',
  LSO: 'Lesotho',
  LBR: 'Liberia',
  LBY: 'Libya',
  LIE: 'Liechtenstein',
  LTU: 'Lithuania',
  LUX: 'Luxembourg',
  MAC: 'Macao',
  MDG: 'Madagascar',
  MWI: 'Malawi',
  MYS: 'Malaysia',
  MDV: 'Maldives',
  MLI: 'Mali',
  MLT: 'Malta',
  MHL: 'Marshall Islands (the)',
  MTQ: 'Martinique',
  MRT: 'Mauritania',
  MUS: 'Mauritius',
  MYT: 'Mayotte',
  MEX: 'Mexico',
  FSM: 'Micronesia (Federated States of)',
  MDA: 'Moldova (the Republic of)',
  MCO: 'Monaco',
  MNG: 'Mongolia',
  MNE: 'Montenegro',
  MSR: 'Montserrat',
  MAR: 'Morocco',
  MOZ: 'Mozambique',
  MMR: 'Myanmar',
  NAM: 'Namibia',
  NRU: 'Nauru',
  NPL: 'Nepal',
  NLD: 'Netherlands (the)',
  NCL: 'New Caledonia',
  NZL: 'New Zealand',
  NIC: 'Nicaragua',
  NER: 'Niger (the)',
  NGA: 'Nigeria',
  NIU: 'Niue',
  NFK: 'Norfolk Island',
  MNP: 'Northern Mariana Islands (the)',
  NOR: 'Norway',
  OMN: 'Oman',
  PAK: 'Pakistan',
  PLW: 'Palau',
  PSE: 'Palestine, State of',
  PAN: 'Panama',
  PNG: 'Papua New Guinea',
  PRY: 'Paraguay',
  PER: 'Peru',
  PHL: 'Philippines (the)',
  PCN: 'Pitcairn',
  POL: 'Poland',
  PRT: 'Portugal',
  PRI: 'Puerto Rico',
  QAT: 'Qatar',
  MKD: 'Republic of North Macedonia',
  ROU: 'Romania',
  RUS: 'Russian Federation (the)',
  RWA: 'Rwanda',
  REU: 'Réunion',
  BLM: 'Saint Barthélemy',
  SHN: 'Saint Helena, Ascension and Tristan da Cunha',
  KNA: 'Saint Kitts and Nevis',
  LCA: 'Saint Lucia',
  MAF: 'Saint Martin (French part)',
  SPM: 'Saint Pierre and Miquelon',
  VCT: 'Saint Vincent and the Grenadines',
  WSM: 'Samoa',
  SMR: 'San Marino',
  STP: 'Sao Tome and Principe',
  SAU: 'Saudi Arabia',
  SEN: 'Senegal',
  SRB: 'Serbia',
  SYC: 'Seychelles',
  SLE: 'Sierra Leone',
  SGP: 'Singapore',
  SXM: 'Sint Maarten (Dutch part)',
  SVK: 'Slovakia',
  SVN: 'Slovenia',
  SLB: 'Solomon Islands',
  SOM: 'Somalia',
  ZAF: 'South Africa',
  SGS: 'South Georgia and the South Sandwich Islands',
  SSD: 'South Sudan',
  ESP: 'Spain',
  LKA: 'Sri Lanka',
  SDN: 'Sudan (the)',
  SUR: 'Suriname',
  SJM: 'Svalbard and Jan Mayen',
  SWE: 'Sweden',
  CHE: 'Switzerland',
  SYR: 'Syrian Arab Republic',
  TWN: 'Taiwan',
  TJK: 'Tajikistan',
  TZA: 'Tanzania, United Republic of',
  THA: 'Thailand',
  TLS: 'Timor-Leste',
  TGO: 'Togo',
  TKL: 'Tokelau',
  TON: 'Tonga',
  TTO: 'Trinidad and Tobago',
  TUN: 'Tunisia',
  TUR: 'Turkey',
  TKM: 'Turkmenistan',
  TCA: 'Turks and Caicos Islands (the)',
  TUV: 'Tuvalu',
  UGA: 'Uganda',
  UKR: 'Ukraine',
  ARE: 'United Arab Emirates (the)',
  GBR: 'United Kingdom of Great Britain and Northern Ireland (the)',
  UMI: 'United States Minor Outlying Islands (the)',
  USA: 'United States of America (the)',
  URY: 'Uruguay',
  UZB: 'Uzbekistan',
  VUT: 'Vanuatu',
  VEN: 'Venezuela (Bolivarian Republic of)',
  VNM: 'Viet Nam',
  VGB: 'Virgin Islands (British)',
  VIR: 'Virgin Islands (U.S.)',
  WLF: 'Wallis and Futuna',
  ESH: 'Western Sahara',
  YEM: 'Yemen',
  ZMB: 'Zambia',
  ZWE: 'Zimbabwe',
  ALA: 'Åland Islands',
};
export const countryListAlpha2 = {
  AF: 'Afghanistan',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas (the)',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia (Plurinational State of)',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory (the)',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Cabo Verde',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  KY: 'Cayman Islands (the)',
  CF: 'Central African Republic (the)',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands (the)',
  CO: 'Colombia',
  KM: 'Comoros (the)',
  CD: 'Congo (the Democratic Republic of the)',
  CG: 'Congo (the)',
  CK: 'Cook Islands (the)',
  CR: 'Costa Rica',
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czechia',
  CI: "Côte d'Ivoire",
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic (the)',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  SZ: 'Eswatini',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (the) [Malvinas]',
  FO: 'Faroe Islands (the)',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories (the)',
  GA: 'Gabon',
  GM: 'Gambia (the)',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Holy See (the)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran (Islamic Republic of)',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: "Korea (the Democratic People's Republic of)",
  KR: 'Korea (the Republic of)',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic (the)",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands (the)',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia (Federated States of)',
  MD: 'Moldova (the Republic of)',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands (the)',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger (the)',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands (the)',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestine, State of',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines (the)',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  MK: 'Republic of North Macedonia',
  RO: 'Romania',
  RU: 'Russian Federation (the)',
  RW: 'Rwanda',
  RE: 'Réunion',
  BL: 'Saint Barthélemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin (French part)',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten (Dutch part)',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan (the)',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands (the)',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates (the)',
  GB: 'United Kingdom of Great Britain and Northern Ireland (the)',
  UM: 'United States Minor Outlying Islands (the)',
  US: 'United States of America (the)',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela (Bolivarian Republic of)',
  VN: 'Viet Nam',
  VG: 'Virgin Islands (British)',
  VI: 'Virgin Islands (U.S.)',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AX: 'Åland Islands',
};

export const reportType = {
  capture: 'capture',
  upload: 'upload',
};

export const uncompleteReasonsOptions = [
  'unable to access location',
  'no LOP',
  'permission denied',
  'weather',
  'other - please describe',
];

export const dailyReportStatus = {
  read: 'read',
  unread: 'unread',
};

export const PeruProvinces = [
  'Ancash',
  'Apurimac',
  'Arequipa',
  'Ayacucho',
  'Cajamarca',
  'Callao',
  'Cuzco',
  'Huancavelica',
  'Huanuco',
  'Ica',
  'Junin',
  'La Libertad',
  'Lambayeque',
  'Lima',
  'Moquegua',
  'Pasco',
  'Piura',
  'Tacna',
  'Tumbes',
];

export const dataCaptureStatusOptions = ['Started', 'Completed', 'Neither'];
export const dataUploadStatusOptions = ['Started', 'Completed', 'Neither'];

export const PeruSites = [
  'PE-LR-1221',
  'PE-LR-1225',
  'PE-IC-1026',
  'PE-LR-1178',
  'PE-IC-1034',
  'PE-IC-1042',
  'PE-PI-1029',
  'PE-IC-1036',
  'PE-IC-1040',
  'PE-IC-1028',
  'PE-PI-1064',
  'PE-AY-1005',
  'PE-LR-1186',
  'PE-LR-1187',
  'PE-PI-1027',
  'PE-PI-1038',
  'PE-IC-1029',
  'PE-IC-1052',
  'PE-CS-1025',
  'PE-IC-1053',
  'PE-LR-1189',
  'PE-LR-1208',
  'PE-LR-1209',
  'PE-AN-1025',
  'PE-PI-1040',
  'PE-IC-1041',
  'PE-LR-1220',
  'PE-LR-1237',
  'PE-LR-1182',
  'PE-PI-1041',
  'PE-PI-1028',
  'PE-AN-1027',
  'PE-AN-1032',
  'PE-IC-1001',
  'PE-AN-1017',
  'PE-AN-1013',
  'PE-IC-1021',
  'PE-IC-1024',
  'PE-PI-1045',
  'PE-PI-1017',
  'PE-CS-1010',
  'PE-CS-1013',
  'PE-PI-1016',
  'PE-IC-1018',
  'PE-IC-1044',
  'PE-PI-1018',
  'PE-CS-1020',
  'PE-LR-1222',
  'PE-LR-1213',
  'PE-IC-1030',
  'PE-IC-1019',
  'PE-IC-1056',
  'PE-IC-1033',
  'PE-IC-1022',
  'PE-LR-1166',
  'PE-LR-1144',
  'PE-LR-1196',
  'PE-IC-1023',
  'PE-CS-1019',
  'PE-IC-1025',
  'PE-IC-1031',
  'PE-IC-1045',
  'PE-LR-1223',
  'PE-LR-1228',
  'PE-AN-1015',
  'PE-PI-1065',
  'PE-LR-1442',
  'PE-IC-1043',
  'PE-AR-1058',
  'PE-PI-1025',
  'PE-CS-1023',
  'PE-IC-1054',
  'PE-AN-1016',
  'PE-CS-1006',
  'PE-IC-1055',
  'PE-LR-1180',
  'PE-AY-1000',
  'PE-HC-1016',
  'PE-PA-1003',
  'PE-JU-1004',
  'PE-HC-1011',
  'PE-JU-1005',
  'PE-HC-1000',
  'PE-HC-1001',
  'PE-HC-1009',
  'PE-HC-1003',
  'PE-HC-1002',
  'PE-AY-1006',
  'PE-JU-1019',
  'PE-JU-1007',
  'PE-AY-1011',
  'PE-LR-1018',
  'PE-LR-1198',
  'PE-LR-1200',
  'PE-LR-1202',
  'PE-LB-1011',
  'PE-LL-1016',
  'PE-LL-1017',
  'PE-LL-1018',
  'PE-LL-1019',
  'PE-LL-1021',
  'PE-LL-1022',
  'PE-LB-1008',
  'PE-PI-1019',
  'PE-LL-1023',
  'PE-LL-1024',
  'PE-LL-1015',
  'PE-AN-1005',
  'PE-SM-1002',
  'PE-SM-1003',
  'PE-AM-1002',
  'PE-AN-1006',
  'PE-AN-1001',
  'PE-LB-1015',
  'PE-PI-1026',
  'PE-LO-1001',
  'PE-LO-1002',
  'PE-LO-1003',
  'PE-LO-1004',
  'PE-PI-1021',
  'PE-LB-1014',
  'PE-PI-1032',
  'PE-SM-1008',
  'PE-CJ-1014',
  'PE-SM-1009',
  'PE-IC-1000',
  'PE-AR-1014',
  'PE-IC-1020',
  'PE-AR-1029',
  'PE-AR-1021',
  'PE-AR-1012',
  'PE-PU-1006',
  'PE-TA-1010',
  'PE-MQ-1006',
  'PE-JU-1036',
  'PE-AY-1007',
  'PE-AY-1008',
  'PE-UC-1010',
  'PE-HC-1037',
  'PE-JU-1034',
  'PE-MQ-1007',
  'PE-HC-1045',
  'PE-HC-1042',
  'PE-LR-1557',
  'PE-LR-1558',
  'PE-PI-1054',
  'PE-LB-1029',
  'PE-CJ-1020',
  'PE-PI-1062',
  'PE-PI-1061',
  'PE-PU-1009',
  'PE-CJ-1021',
  'PE-PI-1063',
  'PE-LR-3074',
  'PE-LR-3077',
  'PE-AM-1009',
  'PE-AP-1003',
  'PE-AY-1016',
  'PE-JU-1053',
  'PE-JU-1054',
  'PE-LR-3078',
  'PE-TU-1005',
  'PE-AM-1010',
  'PE-AN-1052',
  'PE-CJ-1022',
  'PE-LR-3086',
  'PE-LR-3089',
  'PE-LR-3090',
  'PE-LR-3091',
  'PE-TU-1006',
  'PE-LR-3092',
  'PE-AN-1049',
  'PE-AN-1048',
  'PE-AM-1008',
];

// export const defaultMissionRepresentative = {
//   email: "mikael@globhe.com",
//   name: "Mikael Costa Pinto",
//   id: "zE1fEryq3jaGBeDPTF4YLikjktY2",
// };
export const defaultMissionRepresentative = {
  email: 'alexander@globhe.com',
  name: 'Alexander DC Mtambo',
  id: 'nRyY7MXkcbgpmlf16n7YXnT5p6L2',
};

export const formTypeConstant = {
  edit: 'edit order',
  create: 'create order',
};
export const orderLogStatus = {
  orderPlaced: 'orderPlaced',
  orderConfirmed: 'orderConfirmed',
  biddingOngoing: 'biddingOngoing',
  pilotSelected: 'pilotSelected',
  pilotUnassigned: 'pilotUnassigned',
  quoteAdded: 'quoteAdded',
  quoteRejected: 'quoteRejected',
  quoteDeclined: 'quoteDeclined',
  quoteAccepted: 'quoteAccepted',
  quoteSkipped: 'quoteSkipped',
  pilotAssigned: 'pilotAssigned',
  pilotReassigned: 'pilotReassigned',
  flightPermissionApplied: 'flightPermissionApplied',
  flightPermissionDenied: 'flightPermissionDenied',
  flightPermissionApproved: 'flightPermissionApproved',
  flightPermissionReapplied: 'flightPermissionReapplied',
  flyingDateSet: 'flyingDateSet',
  flightDateRescheduled: 'flightDateRescheduled',
  missionNotFeasible: 'missionNotFeasible',
  dataProcessing: 'dataProcessing',
  pilotPackageAdded: 'pilotPackageAdded',
  pilotPackageRejected: 'pilotPackageRejected',
  dataAcceptedByGlobhe: 'dataAcceptedByGlobhe',
  quickDeliveryPackageAutoApproved: 'quickDeliveryPackageAutoApproved',
  dataRejectedByClient: 'dataRejectedByClient',
  dataAcceptedByClient: 'dataAcceptedByClient',
  packageAddToDelivery: 'packageAddToDelivery',
  clientPaid: 'clientPaid',
  pilotPaid: 'pilotPaid',
  completed: 'completed',
  archived: 'archived',
  cancelled: 'cancelled',
};

export const sdgGoals = [
  { label: 'No Poverty', id: 'goal1' },
  { label: 'Zero Hunger', id: 'goal2' },
  { label: 'Good Health and Well-being', id: 'goal3' },
  { label: 'Quality Education', id: 'goal4' },
  { label: 'Gender Equality', id: 'goal5' },
  { label: 'Clean Water and Sanitation', id: 'goal6' },
  { label: 'Affordable and Clean Energy', id: 'goal7' },
  { label: 'Decent Work and Economic Growth', id: 'goal8' },
  { label: 'Industry, Innovation and Infrastructure', id: 'goal9' },
  { label: 'Reduced Inequality', id: 'goal10' },
  { label: 'Sustainable Cities and Communities', id: 'goal11' },
  { label: 'Responsible Consumption and Production', id: 'goal12' },
  { label: 'Climate Action', id: 'goal13' },
  { label: 'Life Below Water', id: 'goal14' },
  { label: 'Life on Land', id: 'goal15' },
  { label: 'Peace and Justice Strong Institutions', id: 'goal16' },
  { label: 'Partnerships to achieve the Goal', id: 'goal17' },
];

export const dataLibCategory = [
  { label: 'Agriculture', id: 'agriculture' },
  { label: 'Forest', id: 'forest' },
  { label: 'Inspection', id: 'inspection' },
  { label: '3D models', id: '3D models' },
  { label: 'Orthomosaic Maps', id: 'orthomosaic maps' },
  { label: 'NDVI', id: 'NDVI' },
  { label: 'Flooding', id: 'flooding' },
  { label: 'Restoration', id: 'restoration' },
  { label: 'Construction', id: 'construction' },
  { label: 'Wind Turbines', id: 'wind turbines' },
  { label: 'Telecom Towers', id: 'telecom towers' },
  { label: 'Solar Panels', id: 'solar panels' },
  { label: 'Water', id: 'water' },
  { label: 'Health', id: 'health' },
  { label: 'Malaria', id: 'malaria' },
];

export const industries = [
  'Accelerate claim prices',
  'Agriculture',
  'Avalanche',
  'construction',
  'Disaster prevention & response',
  'Earthquake',
  'Electric utility/powerline inspection',
  'Fishing',
  'Flood',
  'Forestry',
  'Hurricane',
  'Land use planning',
  'Landslide',
  'Metaverse',
  'Mining',
  'Port management',
  'Public/global health',
  'Risk management & assessment',
  'Smart city planning',
  'Solar parks',
  'Telecom inspection',
  'transportation',
  'Water health',
  'Wild life',
  'Wildfire',
  'Wind turbine inspection',
];

export const planTypeStaticContent = [
  // {
  //   title: "Single Order",
  //   pricingMonthly: "$700 /Month",
  //   pricingYearly: "",
  //   originalPriceMonthly: "",
  //   originalPriceYearly: "",
  //   description: ["Access over 6300 drone operators"],
  //   note: "For one-off orders and smaller data needs",
  // },
  {
    title: 'Basic',
    pricingMonthly: 'select options to see',
    pricingYearly: '$95000 /Year',
    originalPriceMonthly: '$7000',
    originalPriceYearly: '$10000',
    description: [
      'Access all of Globhe operators',
      'Up to 5 drone data orders per month',
      '20% discounts on all data library orders',
    ],
    note: 'For organizations with sites monitored on a lower frequency',
  },
  {
    title: 'Advanced',
    pricingMonthly: 'select options to see',
    pricingYearly: '$95000 /Year',
    originalPriceMonthly: '$12000',
    originalPriceYearly: '$120000',
    description: [
      'Access all of Globhe operators',
      'Up to 10 drone data orders per month',
      'Order and receive data through GLOBHE’s API',
      '25% discounts on all data library orders',
    ],
    note: 'Ideal for more mature organizations and suitable for most use cases',
  },
  {
    title: 'Premium',
    pricingMonthly: 'select options to see',
    pricingYearly: '$95000 /Year',
    originalPriceMonthly: '$20000',
    originalPriceYearly: '$10000',
    description: [
      'Access all of Globhe operators',
      'Up to 25 drone data orders per month',
      'Order and receive data through GLOBHE’s API',
      '25% discounts on all data library orders',
      'Order Priority',
    ],
    note: 'For organizations that want to enjoy nearly unlimited drone data.',
  },
];

export const planType = [
  {
    title: 'Single Order',
    pricingMonthly: '$700 /Month',
    pricingYearly: '',
    originalPriceMonthly: '',
    originalPriceYearly: '',
    description: ['Access all of Globhe operators'],
    note: 'For one-off orders and smaller data needs',
  },
  {
    title: 'Basic',
    pricingMonthly: 'select options to see',
    pricingYearly: '$95000 /Year',
    originalPriceMonthly: '$7000',
    originalPriceYearly: '$10000',
    description: [
      'Access all of Globhe operators',
      'Up to 5 drone data orders per month',
      '20% discounts on all data library orders',
    ],
    note: 'For organizations with sites monitored on a lower frequency',
  },
  {
    title: 'Advanced',
    pricingMonthly: 'select options to see',
    pricingYearly: '$95000 /Year',
    originalPriceMonthly: '$12000',
    originalPriceYearly: '$120000',
    description: [
      'Access all of Globhe operators',
      'Up to 10 drone data orders per month',
      'Order and receive data through GLOBHE’s API',
      '25% discounts on all data library orders',
    ],
    note: 'Ideal for more mature organizations and suitable for most use cases',
  },
  {
    title: 'Premium',
    pricingMonthly: 'select options to see',
    pricingYearly: '$95000 /Year',
    originalPriceMonthly: '$20000',
    originalPriceYearly: '$10000',
    description: [
      'Access all of Globhe operators',
      'Up to 25 drone data orders per month',
      'Order and receive data through GLOBHE’s API',
      '25% discounts on all data library orders',
      'Order Priority',
    ],
    note: 'For organizations that want to enjoy nearly unlimited drone data.',
  },
];

export const progressData = {
  activeMission: 'activeMission',
  adminType: 'adminType',
  ambassador: 'ambassador',
  availableLocations: 'availableLocations',
  company: 'company',
  completedMission: 'completedMission',
  cvURL: 'cvURL',
  dateCreated: 'dateCreated',
  dateUpdated: 'dateUpdated',
  deleted: 'deleted',
  droneLicenseURL: 'droneLicenseURL',
  education: 'education',
  instagram: 'instagram',
  insurance: 'insurance',
  insuranceURL: 'insuranceURL',
  permit: 'permit',
  permitURL: 'permitURL',
  isNewUser: 'isNewUser',
  linkedin: 'linkedin',
  moreDetails: 'moreDetails',
  originalCvFile: 'originalCvFile',
  originalInsuranceFile: 'originalInsuranceFile',
  originalPermitFile: 'originalPermitFile',
  originalLicenseFile: 'originalLicenseFile',
  otherEquipmentType: 'otherEquipmentType',
  permissionToFly: 'permissionToFly',
  preferredPaymentMethods: 'preferredPaymentMethods',
  profileImageURL: 'profileImageURL',
  registeredBusiness: 'registeredBusiness',
  EASACertified2024: 'EASACertified2024',
  registrationNo: 'registrationNo',
  searchName: 'searchName',
  sqkmCharge: 'sqkmCharge',
  state: 'state',
  twitter: 'twitter',
  unassignedMission: 'unassignedMission',
  isEUCountry: 'isEUCountry',
  gcpExperience: 'gcpExperience',
  lidarType: 'lidarType',
  activeProject: 'activeProject',
  completedProject: 'completedProject',
  invitedProject: 'invitedProject',
  pricePerHectare: 'pricePerHectare',
  pricePerKilometer: 'pricePerKilometer',
  assetPrice: 'assetPrice',
  manWeekPrice: 'manWeekPrice',
  otherLink: 'otherLink',
  associatedPilotFile: 'associatedPilotFile',
  groundCaptureEquipment: 'groundCaptureEquipment',
  baseStations: 'baseStations',
};

export const dataLibraryZoneUnitPrice = {
  1: '0.025', // USD/MB
  2: '0.045', // USD/MB
  3: '0.06', // USD/MB
  4: '0.05',
};
export const columnForQuotesClientNew = [
  // 0
  {
    id: 'quoteName',
    label: 'Quote Id',
    align: 'left',
    field: 'capital',
    sort: false,
    custom: false,
  },
  // 1
  {
    id: 'dateCreated',
    label: 'Date created',
    align: 'left',
    field: 'date',
    sort: false,
  },
  // 2
  {
    id: 'priceBeforeDiscount',
    label: 'Subtotal',
    align: 'left',
    field: 'price',
    sort: false,
    custom: false,
  },
  // 3
  {
    id: 'discountPercentage',
    label: 'Discount',
    align: 'left',
    field: 'quoteDiscount',
    sort: false,
    custom: false,
  },
  // 4
  {
    id: 'discountReason',
    label: 'Discount reason',
    align: 'left',
    field: '',
    sort: false,
  },
  // 5
  {
    id: 'days',
    label: 'Estimated Delivery by',
    align: 'left',
    field: 'quotedeliverydate',
    sort: false,
    custom: false,
  },
  // 6
  {
    id: 'expiryDate',
    label: 'Quote expiry date',
    align: 'left',
    field: 'date',
    sort: false,
  },
  // 7
  {
    id: 'quoteDescription',
    label: 'Quote description',
    align: 'left',
    field: 'description',
    sort: false,
    custom: false,
  },
  // 8
  {
    id: 'action',
    label: 'Action',
    align: 'left',
    field: 'action',
    sort: false,
    custom: true,
  },
  // 9
  {
    id: 'finalPrice',
    label: 'Final Cost',
    align: 'left',
    field: 'quotefinalPrice',
    sort: false,
    custom: false,
  },
  // 10
  {
    id: 'rejectReason',
    label: 'Reject reason',
    align: 'left',
    field: 'rejectReason',
    sort: false,
    custom: false,
  },
  //11
  {
    id: 'currency',
    label: 'Currency',
    align: 'left',
    field: 'quoteCurrency',
    sort: false,
    custom: false,
  },
];

export const columnForQuotesAdminNew = [
  // 0
  // {
  //   id: "quoteName",
  //   label: "Quote name",
  //   align: "left",
  //   field: "capital",
  //   sort: false,
  //   custom: false,
  // },
  {
    id: 'quoteName',
    label: 'Quote id',
    align: 'left',
    field: 'capital',
    sort: false,
    custom: false,
  },
  // 1
  {
    id: 'dateCreated',
    label: 'Date created',
    align: 'left',
    field: 'date',
    sort: false,
  },
  // 2
  {
    id: 'priceBeforeDiscount',
    label: 'Subtotal',
    align: 'left',
    field: 'price',
    sort: false,
    custom: false,
  },
  // 3
  {
    id: 'discountPercentage',
    label: 'Discount',
    align: 'left',
    field: 'quoteDiscount',
    sort: false,
    custom: false,
  },
  // 4
  {
    id: 'discountReason',
    label: 'Discount reason',
    align: 'left',
    field: '',
    sort: false,
  },
  // 5
  {
    id: 'days',
    label: 'Estimated Delivery by',
    align: 'left',
    field: 'quotedeliverydate',
    sort: false,
    custom: false,
  },
  // 6
  {
    id: 'expiryDate',
    label: 'Quote expiry date',
    align: 'left',
    field: 'date',
    sort: false,
  },
  // 7
  {
    id: 'quoteDescription',
    label: 'Quote description',
    align: 'left',
    field: 'description',
    sort: false,
    custom: false,
  },
  // 8
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'missionQuotestatus',
    sort: false,
  },
  // 9
  {
    id: 'finalPrice',
    label: 'Final Cost',
    align: 'left',
    field: 'quotefinalPrice',
    sort: false,
    custom: false,
  },
  // 10
  {
    id: 'issuedBy',
    label: 'Issued By',
    align: 'left',
    field: 'issuedBy',
    sort: false,
    custom: false,
  },
  // 11
  {
    id: 'cancelBy',
    label: 'Cancelled By',
    align: 'left',
    field: 'cancelBy',
    sort: false,
    custom: false,
  },
  // 12
  {
    id: 'deleteQuote',
    label: 'Delete',
    align: 'left',
    field: 'deleteQuote',
    sort: false,
    custom: true,
  },
  // 13
  {
    id: 'cancelQuote',
    label: 'Cancel',
    align: 'left',
    field: 'cancelQuote',
    sort: false,
    custom: true,
  },
  // 14
  {
    id: 'rejectReason',
    label: 'Reject reason',
    align: 'left',
    field: 'rejectReason',
    sort: false,
    custom: false,
  },
  //15
  {
    id: 'currency',
    label: 'Currency',
    align: 'left',
    field: 'quoteCurrency',
    sort: false,
    custom: false,
  },
];

export const columnForProjectQuotesAdminNew = [
  {
    id: 'quoteName',
    label: 'Quote id',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date created',
    align: 'left',
    field: 'date',
    sort: false,
  },
  // 2
  {
    id: 'priceBeforeDiscount',
    label: 'Subtotal',
    align: 'left',
    field: 'price',
    sort: false,
    custom: false,
  },
  // 3
  {
    id: 'discountPercentage',
    label: 'Discount',
    align: 'left',
    field: 'quoteDiscount',
    sort: false,
    custom: false,
  },
  // 4
  {
    id: 'discountReason',
    label: 'Discount reason',
    align: 'left',
    field: '',
    sort: false,
  },
  // 5
  {
    id: 'days',
    label: 'Estimated Delivery by',
    align: 'left',
    field: 'quotedeliverydate',
    sort: false,
  },
  // 6
  {
    id: 'expiryDate',
    label: 'Quote expiry date',
    align: 'left',
    field: 'date',
    sort: false,
  },
  // 7
  {
    id: 'quoteDescription',
    label: 'Description',
    align: 'left',
    field: 'description',
    sort: false,
    custom: false,
  },
  // 8
  {
    id: 'status',
    label: 'Status',
    align: 'left',
    field: 'status',
    sort: false,
    custom: true,
  },
  // 9
  {
    id: 'finalPrice',
    label: 'Final Cost',
    align: 'left',
    field: 'quotefinalPrice',
    sort: false,
    custom: false,
  },
  // 10
  {
    id: 'pricePerUnit',
    label: 'Price per site',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  // 11
  {
    id: 'issuedBy',
    label: 'Issued By',
    align: 'left',
    field: 'issuedBy',
    sort: false,
    custom: false,
  },
  // 12
  {
    id: 'cancelBy',
    label: 'Cancelled By',
    align: 'left',
    field: 'cancelBy',
    sort: false,
    custom: false,
  },
  // 13
  {
    id: 'deleteQuote',
    label: 'Delete',
    align: 'left',
    field: 'deleteQuote',
    sort: false,
    custom: true,
  },
  // 14
  {
    id: 'cancelQuote',
    label: 'Cancel',
    align: 'left',
    field: 'cancelQuote',
    sort: false,
    custom: true,
  },
  // 15
  {
    id: 'rejectReason',
    label: 'Reject reason',
    align: 'left',
    field: 'rejectReason',
    sort: false,
    custom: false,
  },
  //16
  {
    id: 'currency',
    label: 'Currency',
    align: 'left',
    field: 'quoteCurrency',
    sort: false,
    custom: false,
  },
];

export const columnForProjectQuotesClientNew = [
  {
    id: 'quoteName',
    label: 'Quote name',
    align: 'left',
    field: 'capital',
    sort: false,
  },
  {
    id: 'dateCreated',
    label: 'Date created',
    align: 'left',
    field: 'date',
    sort: false,
  },
  // 2
  {
    id: 'priceBeforeDiscount',
    label: 'Subtotal',
    align: 'left',
    field: 'price',
    sort: false,
    custom: false,
  },
  // 3
  {
    id: 'discountPercentage',
    label: 'Discount',
    align: 'left',
    field: 'quoteDiscount',
    sort: false,
    custom: false,
  },
  // 4
  {
    id: 'discountReason',
    label: 'Discount reason',
    align: 'left',
    field: '',
    sort: false,
  },
  // 5
  {
    id: 'days',
    label: 'Estimated Delivery by',
    align: 'left',
    field: 'quotedeliverydate',
    sort: false,
  },
  // 6
  {
    id: 'expiryDate',
    label: 'Quote expiry date',
    align: 'left',
    field: 'date',
    sort: false,
  },
  // 7
  {
    id: 'quoteDescription',
    label: 'Description',
    align: 'left',
    field: 'description',
    sort: false,
    custom: false,
  },
  // 8
  {
    id: 'status',
    label: 'Action',
    align: 'left',
    field: 'action',
    sort: false,
    custom: true,
  },
  // 9
  {
    id: 'finalPrice',
    label: 'Final Cost',
    align: 'left',
    field: 'quotefinalPrice',
    sort: false,
    custom: false,
  },
  // 10
  {
    id: 'pricePerUnit',
    label: 'Price per site ',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  //11
  {
    id: 'rejectReason',
    label: 'Reject reason',
    align: 'left',
    field: 'rejectReason',
    sort: false,
    custom: false,
  },
  //12
  {
    id: 'currency',
    label: 'Currency',
    align: 'left',
    field: 'quoteCurrency',
    sort: false,
    custom: false,
  },
];

export const CsvKmlUploadInstructions = [
  'We support the following KML features: linear (lines), pinpoint coordinates, or polygons.',
  'Please ensure that you have one KML file, this file can contain multiple locations / sites, but we can not accept many KML files.',
  'Each polygon, pinpoint, or line represents a distinct location / site.',
  // "Each polygon, pinpoint, or line represents a distinct site.",
  // "Consider merging large adjacent areas into a single polygon unless separate site inspections are intended.",
  // "Only KML files are supported; KMZ files are not permitted.",
];
export const CsvKmlUploadInstructionsStep1 = [
  "Site ID: The column in your file that is the unique identifier for each site, please label it 'Site ID'.",
  "Latitude: The column in your file containing latitude coordinates for each site, please label it 'Latitude'.",
  "Longitude: The column in your file containing longitude coordinates for each site, please label it 'Longitude'.",
  "Description: The column in your file that provides a description or additional information for each site, please label it 'Description'. You can leave this column empty if you would like the detailed description of your order to be applied to all the sites you wish to survey.",
];
export const CsvKmlUploadInstructionsStep2 = [
  'Site ID: Select the column header in your file that represents the unique identifier for each site.',
  'Latitude: Choose the column header in your file containing latitude coordinates for each site.',
  'Longitude: Choose the column header in your file containing longitude coordinates for each site.',
  'Description: Select the column header in your file that provides a description or additional information for each site. You can leave it empty if you want the the detailed description of your order to be applied to all the sites.',
];
export const CsvNotes = [
  'If your CSV file contains additional columns, you can skip them if they are not relevant to our system.',
  'Ensure that each selected column contains appropriate data corresponding to the field description.',
];
export const CsvFinalNotes = [
  "Once you've mapped all the fields correctly, proceed to complete the upload process by clicking on submit.",
];
export const onBoardingText = {
  guideTour: 'Get to know our global network of 6500 drone operators',
  profileComplete: 'This will help us tailor our plans for your business',
  subPlan: 'Access all services. Starting at $3,150/mo.',
  signUp: `Get global drone data for your digital twins. Our marketplace matches your needs with ${totalPilots} + professional drone operators and their drones across ${totalCountry} countries and counting, and delivers the data seamlessly.`,
  placeOrder: 'Now you can place an order',
};

export const subPlanDiscount = {
  subDiscount: 'Save up to 20% with an annual subscription',
};
export const authBannerSubHeading = 'Access our global network of 8000+ operators in 134 countries';

export const tcLink = 'https://www.globhe.com/product-specific-terms-and-conditions-subscription';

export const dataLibBaseFilesFileType = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/webp',
  'image/tiff',
  'image/svg+xml',
  'image/x-icon',
  'image/heic',
  'image/heif',
];

export const EUCountriesWithCommonVATrule = [
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czechia',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Ireland',
  'Italy',
  'Latvia',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Netherlands (the)',
  'Poland',
  'Portugal',
  'Romania',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
];

export const MAX_FILENAME_LENGTH = 54;

export const orthoViewEnabled = [
  fileDataTypes._2dMap,
  fileDataTypes.digitalSurfaceModel,
  fileDataTypes.digitalTerrainModel,
  fileDataTypes.topographicMap,
  fileDataTypes.thermalMap,
  fileDataTypes.ndvi,
  fileDataTypes.multispectral,
  //fileDataTypes.hyperspectral,
];

export const globheInvoiceAddress = 'Globhe DRONES AB, Malmskillnadsgatan 44A c/o Epicenter 111 57, Stockholm';
export const InvoiceText = {
  firstInvoice: 'First Invoice',
  secondInvoice: 'Second Invoice',
  singleInvoice: 'Single Invoice',
};

export const quoteDataType = {
  areaSize: 'areaSize',
  imageSize: 'imageSize',
};

export const pilotInvoiceType = {
  missionInvoice: 'missionInvoice',
  projectInvoice: 'projectInvoice',
};

export const orderLocationType = {
  singleLocationOrder: 'singleLocationOrder',
  multiLocationOrder: 'multiLocationOrder',
};

export const orderLocationTypeLabel = {
  singleLocationOrder: 'Single location',
  multiLocationOrder: 'Multiple order',
};

export const singleOrderTypeLabel = {
  area: 'Area Order',
  linear: 'Linear Order',
  assets: 'Asset Order',
};

export const missionFeasibilityArr = [
  { label: 'Yes', name: 'missionFeasibilityYes' },
  { label: 'No', name: 'missionFeasibilityNo' },
];
export const ClientNextAction = {
  underReview: 'The Order is currently undergoing Globhe Review.',
  initialProject:
    "You can edit the project details, delete existing sites, or upload new sites by clicking the 'Edit' button above. Additionally, Globhe can also perfom these action. Globhe is currently looking to invite the best drone operators to bid on your Order. Please navigate to the Missons tab to view details.",
  initialProjectOrder: 'This mission is a part of a project. Please wait for Globhe to Invite Drone Operators to bid.',
  projectBiddingOngoing: 'This order is a part of a project. Bidding is currently ongoing in this order',
  projectBiddingEnded:
    'This order is a part of a project. Bidding has ended on this order. You can view the accepted bids in the Missions tab.',
  projectPilotSelected:
    'Congratulation! A Drone Operator is selected for your order. As this order is part of a project, Please wait for selection of operators on other orders as well. Then Globhe will prepare the quote for that Project.',
  declineQuote: "You have declined Globhe's proposed quote. Please wait for a new one.",
  reviewQuote:
    "A Quote for your Project is Available. Plese review it by navigating to the 'Quotes & Invoices' tab. Please note that once the Quote is Accepted, you will no longer be able to add or remove sites.",
  quoteDeleted: 'The Quote proposed has been Deleted by the Globhe. Please wait for a new Quote to be available.',
  activeProject:
    'Globhe is currently working on this Project with Drone Operators. Please Scroll down to get details about individual orders.',
  downloadProject: 'You can now download the complete project data by navigating to the Download Project tab.',
  confirmOrder: 'Your order has been accepted by Globhe. Soon Drone Operators will be invited for bidding on it.',
  biddingOngoing:
    'The Order is currently undergoing bidding by the drone operators. We will let you now the results soon.',
  biddingEnded: 'The Bidding for the order has ended. Globhe is looking for the best Drone Operator for you.',
  operatorSelected: 'A Drone Operator has been selected. Our team is preparing the quote for your order',
  quoteReady: 'Please review and accept the price quote, so we can assign an operator.',
  newQuote: 'Our team busy preparing a new quote',
  operatorAssigned: 'Drone Operator Assigned !!',
  quoteAccepted: 'Quote Accepted !!',
  operatorSubAssigned: "We've assigned a drone operator to the order.",
  flyingDateSet:
    "The drone operator will fly the drone on the above date. Please navigate to the 'Mission Planning' tab to view the details.",
  rescheduled:
    "The Mission has been rescheduled by the Drone Operator. Please navigate to the 'Mission Planning' tab to view the details.",
  dataProcessing: 'The Data is being Processed by Drone Operator!',
  dataUploading: 'Pilot has collected the drone data and will upload soon.',
  dataReview: 'Data is uploaded by the Operator. Globhe is reviewing the data.',
  dataRejected: 'There were some issues with the collected data.',
  dataRejectedByGlobhe: 'Data rejected by globhe!',
  dataAccepted: 'Please wait for Globhe Admin to Complete the order to get your Accepted Package.',
  passedCheck: `Data has Passed Globhe's Check!`,
  quickDeliveryDataReady: 'Data Submitted by Operator!',
  quickDeliveryDataRejectedByClient: 'You Rejected the Data',
  reviewData: 'You can now review the data. Once finished, press the “Approve” or “Reject” button',
  downloadData: 'You can download your data using the browser.',
  paymentOverdue: 'Payment is Overdue',
  requestedChanges: 'Changes has been requested to Globhe for the operator package. Reason: ',
  paymnentSubText:
    "You can go to 'Quotes & Invoices' tab to view and download the Invoice prepared by Globhe. If paid, then wait for Globhe Confirmation",
  operatorFeedback: 'Waiting for operator feedback',
  reviewMission: 'We are waiting for the operator to review the order again.',
  archived: 'This Order has been archived by Globhe !!',
  cancelled: 'You have Cancelled this Order!',
  rejected: 'Globhe has Rejected this Order !!',
};
export const AdminNextActions = {
  newOrder: 'A New Order has been Created by Client!',
  declineQuote:
    "The client has declined the quote. Please send a new quote to the Client by navigating to the 'Quotes & Invoices' tab.",
  confirmOrder:
    'Please review the order before confirming it. Make sure you edit this mission to give the operators all the information they need.',
  inviteOperator: 'Invite Drone Operators!',
  inviteOperatorSubText: 'Please Invite drone operators to bid on the mission.',
  skipQuote: 'Skip Quote',
  createQuote: 'Create a Quote!',
  reviewQuote: 'The Client is currently Reviewing the quote.',
  sendQuote: 'Please send a quote to the client.',
  skipQuoteDesc:
    "If you're handling the quote outside the platform and the client has already accepted the quote through another communication medium, you can skip this step.",
  quoteSent: 'Quote sent to Client!',
  uploadInvoice: 'Please upload the pre-delivery invoice.',
  flyingDateSet: 'The drone operator will fly the drone on the above date to collect the data.',
  dataProcessing: 'The Data is being Processed by Drone Operator!',
  dataUploading: 'Drone Operator has collected the drone data will upload soon.',
  qualityCheck: 'The Data is undergoing Quality Check by Client',
  reviewing: 'We are waiting for the operator to review the mission again.',
  dataRejected:
    'The client has declined the data. Please recheck the data sent to the client and perform necessary actions!',
  dataAccepted:
    "Please add the package approved by the client to Accepted Package. Also add the Client Invoice in the 'Quotes & Invoices' tab before proceeding to Complete the Mission",
  biddingEnded: 'The Bidding for the order has ended. Now please select a bid purposed by the drone operator',
  projectBiddingEnded:
    'The Bidding for this project has ended. Now please select a bids purposed by the drone operators. In case if a mission do not have an bid, then invite or remind operators and extend the bidding deadline',
  missionInReviewByPilot: 'Operator is reviewing the mission feasibility',
  requestedChanges: 'Changes has been requested to the Operator for the operator package. Reason: ',
  requestedChangesByClient: 'Changes has been requested by the Client for the operator package. Reason: ',
  uploadClientPreInvoice: 'Upload the pre-delivery client invoice in order to invite/assign a drone operator',
  assignPilots: 'The Client has Accepted the Quote. Please Wait for Drone Operator to Sign the Contract.',
  verifyData: 'The operator has uploaded data to this mission. You can now go and check the quality of the data.',
  initialProject:
    "Edit project details, delete, or upload sites using 'Edit.'Button. Please navigate to the Missions tabs to Invite the Drone Operators on Missions.",
  activeProject:
    'The Client has Accepted the Quote. You can now wait for the operators to sign the contract. If pilots are already assigned, wait for them to upload the data.',
  draftProject:
    'Your project is in draft mode. Make adjustments or add sites as needed. Once ready, submit your order below to receive a quote shortly.',
  downloadData: 'You can now download the complete project data by navigating to the Download Project tab.',
  biddingOngoing:
    'Visit the Missions tab to review bids, invite more operators, and remind those who haven’t responded.',
  quoteDeclined: 'You have Deleted the current Quote sent to the Client. Please create a new Quote for the Client.',
  initialProjectOrder:
    'This mission is a part of a project. To invite operators to bid on this mission go to the missions tab on project page by clicking on back icon.',
  projectBiddingOngoing:
    'This mission is a part of a project. Scroll down in the Mission Details tab to view the currently placed bids. To invite more drone operators to bid on this mission go to the project page by clicking on back button.',
  projectBiddingEnded:
    'This mission is a part of a project. Bidding Deadline of Project has been reached. To extend the deadline navigate to the Project by back icon. You can also select the bids proposed by the drone operators in the Mission Detials tab.',
  projectPilotSelected:
    'This mission is a part of a project. Please navigate to the project page by clicking on back Icon. You can generate a quote by first stopping the bidding if all the missions of that project have drone operators selected for them ',
};
export const PilotNextAction = {
  biddingOngoing:
    'Submit a bid for the missions in this project before the bidding deadline. Review the project details and set your price. You can update your bid at any time before the deadline. Globhe may select a pilot before the deadline, so bid promptly.',
  acceptMission:
    'Urgent Mission. On-site data collection required today, preferably in the next few hours. This Mission has a fixed price. No bidding. Please review the details. The first Operator to accept the Mission will receive the contract and can start immediately.',
  submitBid:
    'Submit a customized bid for this mission before selection. You can adjust your daily rate for this task. Review details, express interest, and set your compensation. Globhe may select a pilot before bidding ends, so bid early!',
  submitInterest:
    'Show your interest in this mission. Globhe will then select the most appropriate operator for this project',
  biddingEnded:
    'The bidding for the mission has ended. Please wait for the results. However, Globhe may extend the bidding deadline if necessary.',
  projectBiddingEnded:
    'The bidding for the project has ended. Please wait for the results. However, Globhe may extend the bidding deadline if necessary.',
  selected: 'Please wait till Globhe generates the contract for your order, then you can sign the Contract.',
  contract: 'Please sign your contract with Globhe before you can upload the data to this mission.',
  feasibility: 'Assess the feasibility of the mission',
  flyingDateSet: 'If you need to reschedule, edit the date in the pre-flight tab and select a reason.',
  feasibilitySubText: 'Review if the mission is feasible or not. If it is, select a flying date.',
  review:
    'The mission has been sent to Client for further Review. If the Client has updated the mission, please check the new details and update the mission feasibility accordingly.',
  reschedule: 'Need to reschedule mission',
  flying: 'You are all set to fly',
  uploadData: 'Time to Upload your Collected Data',
  uploadDataSubText: 'Upload each deliverable into the correct tab under "Data Upload"',
  approval: 'Data uploaded! It is now awaiting Globhe approval.',
  approvalSubText: 'Please wait for Globhe to quality check and approve the data.',
  quickDeliveryApproval: 'Data submitted! It is now awaiting client review.',
  quickDeliveryApprovalSubText: 'Please wait for the client to review and approve the data.',
  quickDeliveryRejectedByClient: 'The client has rejected your data. Please re-upload corrected files.',
  rejected:
    'Your data requires corrections. Check the details in your last submission page and submit your new data here.',
  paid: 'Yay! you got paid for this mission.',
  bankDetails:
    "Your data is approved, and an invoice has been generated. Approve it in the 'Invoice' tab to start payment processing. Ensure your bank details are filled, or the invoice won’t be generated.",
  completed: 'This dataset is now approved. You can still access it here for your records.',
  activeProject:
    'View your invoice and contract in My Resources section. Sign your contract if not done. For further details, Check individual missions under Missions Tab.',
  completedProject: 'This Project has been completed by you and Approved by Globhe.',
  archivedProject: 'This Project has been Archived by Globhe.',
  requestedChangesByAdmin: 'Changes has been requested by Globhe',
  packageHandleByAdmin:
    'Your package has been rejected by Globhe. However, our team is handling it internally. Please wait for further updates. Thank you for your patience.',
  requireEdit: 'Globhe has requested you to update your Invoice.',
  permissionApproved:
    'If the Flight Permission is approved, you can proceed to plan the mission by clicking on Plan mission button and setting the flying date.',
};
export const MissionSpecs = [
  'Image overlap (correct terminology): standard is 75% frontal, 70% lateral',
  'Spatial resolution / GSD: standard is 2 - 2.5 cm/px',
  'Drone type and model  :standard is that Globhe will select what is available, i.e. DJI Mavic or Phantom series for simple mapping, DJI Matrice series for more accurate surveys',
  'Drone sensor : standard is RGB',
  'Coordinate Reference System  (CRS): our standard and more general one for simple mapping and visualisation is WGS 84 / EPSG: 4326 / Meters',
  'Vertical accuracy: standard: up to 10 cm when GCPs are used',
  'GCPs: No',
  'Processing software: depends of operator',
];

export const advancedOptionLabel = {
  flightHeight: 'Flight height',
  frontOverlap: 'Front overlap',
  sideOverlap: 'Side overlap',
  spatialResolution: 'Spatial Resolution (GSD)',
  droneType: 'Drone type / model',
  sensors: 'Drone sensor',
  crs: 'Coordinate reference system',
  gcp: 'Ground control points',
  processingSoftware: 'Processing Software',
  verticalAccuracy: 'Vertical accuracy',
  flightSpecificationPdfUrl: 'Flight Specifications URL',
};

export const recursiveInterval = {
  day: 'day',
  month: 'month',
  year: 'year',
  week: 'week',
};

export const groupOrderStatus = {
  reviewing: 'Reviewing',
  completed: 'Completed',
  inProcess: 'In Process',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
  draft: 'Draft',
};
export const zoneCountries = {
  Zone1: [
    'Algeria',
    'Angola',
    'Benin',
    'Botswana',
    'Burkina Faso',
    'Burundi',
    'Cameroon',
    'Cape Verde',
    'Central African Republic',
    'Chad',
    'Comoros',
    'Djibouti',
    'Egypt',
    'Equatorial Guinea',
    'Eritea',
    'Eswatini',
    'Ethiopia',
    'Gabon',
    'Gambia',
    'Guinea',
    'Guinea-Bissau',
    'Ivory Coast',
    'Kenya',
    'Lesotho',
    'Liberia',
    'Libya',
    'Malawi',
    'Mali',
    'Mauritania',
    'Mauritius',
    'Morocco',
    'Mozambique',
    'Namibia',
    'Niger',
    'Republic of the Congo',
    'Rwanda',
    'Sahrawi Arab Democratic Republic',
    'Sao Tome and Principle',
    'Senegal',
    'Seychelles',
    'Sierra Leone',
    'Somalia',
    'South Sudan',
    'Sudan',
    'Tanzania',
    'Togo',
    'Tunisia',
    'Uganda',
    'Zambia',
    'Zimbabwe',
    'Congo (the Democratic Republic of the)',
    'South America',
    'Argentina',
    'Bolivia',
    'Bouvet Island',
    'Chile',
    'Colombia',
    'Ecuador',
    'Guyana',
    'Paraguay',
    'Peru',
    'Suriname',
    'Uruguay',
    'Venezuela',
    'Brazil',
    'Afganistan',
    'Bahrain',
    'Bangladesh',
    'Brunei',
    'Combodia',
    'China',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Israel',
    'Japan',
    'Jordan',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Lebanon',
    'Malaysia',
    'Maldives',
    'Mongolia',
    'Myanmar',
    'Nepal',
    'Oman',
    'Pakistan',
    'Palestine',
    'Philippines',
    'Qatar',
    'Saudi Arabia',
    'Singapore',
    'South Korea',
    'Sri Lanka',
    'Taiwan',
    'Tajikistan',
    'Thailand',
    'Timor-Leste',
    'Turkmenistan',
    'United Arab Emirates',
    'Uzebkistan',
    'Vietnam',
    'Yemen',
    'Belize',
    'Costa Rica',
    'El Salvador',
    'Guatemala',
    'Honduras',
    'Nicaragua',
    'Panama',
    'Haiti',
    'Jamaica',
    'Mexico',
    'Nueva Esparta (Venezuela)',
    'Trinidad and Tobago',
    'South Africa',
    'Nigeria',
    'Ghana',
    'Madagascar',
    'Bhutan',
    'French Guiana (France)',
    'Anguilla',
    'Antigua and Barbuda',
    'The Bahamas',
    'Barbados',
    'Cuba',
    'Dominican Republic',
    'Puerto Rico (United States)',
    'Armenia',
    'Kazakhstan',
  ],
  Zone2: [
    'Falkland Islands (United Kingdom)',
    'South Georgia and the South Sandwich Islands (United Kingdom)',
    'United Kingdom of Great Britain and Northern Ireland (the)',
    'Aruba (Kingdom of the Netherlands)',
    'Bermuda (United Kingdom)',
    'Bonaire (Kingdom of the Netherlands)',
    'British Virgin Islands (United Kingdom)',
    'Cayman Islands (United Kingdom)',
    'Clipperton Island (France)',
    'Curaçao (Kingdom of the Netherlands)',
    'Dominica',
    'Federal Dependencies of Venezuela (Venezuela)',
    'Grenada',
    'Guadeloupe (France)',
    'Martinique',
    'Montserrat (United Kingdom)',
    'Saba (Kingdom of the Netherlands)',
    'San Andrés and Providencia (Colombia)',
    'Saint Barthélemy (France)',
    'Saint Lucia',
    'Saint Martin (France)',
    'Saint Pierre and Miquelon (France)',
    'Saint Vincent and the Grenadines',
    'Sint Eustatius (Kingdom of the Netherlands)',
    'Sint Maarten (Kingdom of the Netherlands)',
    'Turks and Caicos Islands (United Kingdom)',
    'United States of America (the)',
    'United States Virgin Islands (United States)',
    'Albania',
    'Andorra',
    'Azerbaijan',
    'Belarus',
    'Bosnia and Herzegovina',
    'Bulgaria',
    'Croatia',
    'Cyprus',
    'Czechia',
    'Estonia',
    'Georgia',
    'Greece',
    'Hungary',
    'Iceland',
    'Kosovo',
    'Latvia',
    'Liechtenstein',
    'Lithuania',
    'Malta',
    'Moldova',
    'Montenegro',
    'North Macedonia',
    'Poland',
    'Portugal',
    'Romania',
    'San Marino',
    'Serbia',
    'Slovakia',
    'Slovenia',
    'Spain',
    'Turkey',
    'Greenland (Kingdom of Denmark)',
    'Canada',
    'Austria',
    'Belgium',
    'Denmark',
    'Finland',
    'France',
    'Germany',
    'Ireland',
    'Italy',
    'Luxembourg',
    'Netherlands',
    'Monaco',
    'Norway',
    'Sweden',
    'Switzerland',
    'United Kingdom',
    'Vatican City',
    'Australia',
    'New Zealand',
  ],
};

export const formIdConstant = {
  pilotSignIn: 'pilotSignIn',
  clientSignIn: 'clientSignIn',
  memberSignUp: 'memberSignup',
};

export const formTypeConstantForLogin = {
  signup: 'signup',
  signin: 'signin',
};

export const currencyList = ['USD', 'EUR'];

export const QUICK_DELIVERY_TERMS = [
  'The fixed price agreed with Globhe will be used — no adjustments will be made.',
  'Globhe aims to deliver your data as soon as possible, but no exact time can be guaranteed as on-demand data capture depends on factors such as location, flight restrictions, available operators and weather forecast.',
  'To enable faster delivery of data, the data will not be quality checked by Globhe.',
];
export const currencyConstant = {
  USD: 'US Dollar',
  EUR: 'Euro',
};
export const defaultCurrency = 'USD';
export const enterpriseClientRoles = [
  {
    label: 'Admin',
    value: 'admin',
  },
  {
    label: 'Member',
    value: 'general',
  },
];
export const typeOfDepartments = [
  'Sales',
  'Finance',
  'Product',
  'Marketing',
  'Operations',
  'Accounting',
  'GIS',
  'Analytics',
];

export const inviteErrorType = {
  existSameEnterPrise: 'existSameEnterPrise',
  existOtherEnterPrise: 'existOtherEnterPrise',
  operator: 'operator',
  unused: 'unused',
};

export const clientSignInUpTextConstants = {
  signUpTitle: 'Create a client account',
  signUpSubTitle: `Access the world's largest drone data platform,
  instantly connecting you with over ${totalPilots}+ local and vetted drone
  operators in ${totalCountry} countries ready to supply drone data.`,
};

export const enterPriseRoleType = {
  admin: 'Admin',
  general: 'Member',
};

export const enterPriseUserRole = {
  admin: 'admin',
  general: 'general',
};

export const pilotInviteType = {
  invited: 'invited',
  rejected: 'rejected',
  undoReject: 'undoReject',
  interestReceived: 'interestReceived',
  accepted: 'accepted',
};

export const contactSaleUrl = '/app/client/contact-sales';
export const contactSupportUrl = '/app/support';
export const urlPattern = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

export const otherRequirementsString = `By accepting this mission and signing the contract, you agree to deliver in accordance with Globhe’s provided guidelines.
In the event that the client issues alternative instructions unbeknownst to Globhe, you must seek confirmation from Globhe before proceeding.
Failure to do so may result in the obligation to redo the mission and deliver according to Globhe’s guidelines. You may not negotiate directly with the client. Prices are fixed in the contract. Any discussions or requests for changes must be directed to Globhe, who will handle all negotiations with the client.`;

export const packageStatusConstants = {
  approved: 'approved',
  rejected: 'rejected',
  underReview: 'underReview',
  requestedChanges: 'requestedChanges',
};

export const notClientMission = 'Group Chat is not currently available for Missions other than Client Missions.';

export const editableStatus = [
  missionStatus.pilotAssigned,
  missionStatus.flyingDateSet,
  missionStatus.rescheduled,
  missionStatus.missionNotFeasible,
  missionStatus.dataAcceptedByClient,
  missionStatus.dataProcessing,
  missionStatus.dataUploading,
  missionStatus.dataRejectedByClient,
  missionStatus.sentForReviewToClient,
  missionStatus.sentForReviewToGlobhe,
];

export const columnForDroneOperatorNetwork = [
  { id: 'operatorName', label: 'Name', align: 'left', field: 'capital', sort: false },
  { id: 'email', label: 'Email', align: 'left', field: 'normal', sort: false },
  {
    id: 'country',
    label: 'Country',
    align: 'left',
    field: 'normal',
    sort: false,
  },
  { id: 'city', label: 'City', align: 'left', field: 'normal', sort: false },
  {
    id: 'companyName',
    label: 'Company',
    align: 'left',
    field: 'normal',
    sort: false,
  },
];

export const ratings = ['0', '1', '2', '3', '4', '5'];

export const DEFAULT_REFETCH_QUERY_OPTIONS = {
  refetchOnWindowFocus: true,
  refetchOnMount: true,
};

export const QUOTE_STAGE = [
  missionStatus.pilotSelected,
  missionStatus.quoteSentToClient,
  missionStatus.quoteReissuedToClient,
  missionStatus.quoteDeclinedByClient,
  missionStatus.quoteAcceptedByClient,
];

export const CONTRACT_STAGE = [missionStatus.pilotAssigned];

export const MISSION_PLANNING_STAGE_STATUS = [
  missionStatus.missionNotFeasible,
  missionStatus.feasibleNotCompleted,
  missionStatus.flyingDateSet,
  missionStatus.rescheduled,
];

export const DATA_PROCESS_STAGE_STATUS = [
  missionStatus.dataProcessing,
  missionStatus.sentForReviewToGlobhe,
  missionStatus.pilotPackageRejected,
  missionStatus.dataRejectedByClient,
  missionStatus.sentForReviewToClient,
  missionStatus.dataAcceptedByClient,
];

export const COMPLETE_STAGE = [missionStatus.completed];

export const deletedProjectStatuses = [projectStatus.archived, projectStatus.deleted];
export const cancelledMissionStatuses = [
  missionStatus.cancelled,
  missionStatus.archive,
  missionStatus.deleted,
  missionStatus.rejected,
];

export const completeCheck = [
  { name: 'quoteAccepted', label: 'Is the quote accepted by the client?' },
  {
    name: 'contractSigned',
    label: 'Has the contract been signed by all required parties?',
  },
  {
    name: 'missionPlanned',
    label: 'Has the mission been planned with a confirmed flight date?',
  },
  {
    name: 'dataApproved',
    label: 'Has the delivered data been reviewed and approved?',
  },
  { name: 'completed', label: 'Are you sure you want to mark this mission as Complete?' },
];

export const statusExplanationMap = {
  'Total Completed': 'These missions have been successfully completed.',
  'Total Active':
    'These missions have been accepted by the client, and they are currently active with work in progress.',
  'Total Confirmed': 'These missions have been accepted by Globhe but are still in the quoting or bidding stage.',
  'Total Unconfirmed': 'Globhe has not yet decided whether to work on these missions.',
  'Total Rejected': 'These missions have been rejected by Globhe.',
  'Total Cancelled': 'These missions were cancelled by the client.',
  'Total Deleted': 'These missions were deleted.',
  'Total Archived': 'These Projects have been archived by Globhe',
  'Total Draft': 'These Projects are still in draft stage and have not been finalized by the client',
};

export const complicatedLocationCountries = [
  'Afghanistan',
  'Haiti',
  'Iran',
  'Iraq',
  'Israel',
  'North Korea',
  'Kyrgyzstan',
  'Libya',
  'Nicaragua',
  'Oman',
  'Palestine, State of',
  'Russia',
  'Syria',
  'Tajikistan',
  'Turkmenistan',
  'Ukraine',
  'Uzbekistan',
  'Yemen',
  'Algeria',
  'Azerbaijan',
  'Bhutan',
  'Burkina Faso',
  'Cameroon',
  'Central African Republic',
  'Chad',
  'Democratic Republic of the Congo',
  'Republic of the Congo',
  'Egypt',
  'Ethiopia',
  'Greenland',
  'Mali',
  'Mauritania',
  'Mozambique',
  'Myanmar',
  'Niger',
  'Saudi Arabia',
  'Somalia',
  'South Sudan',
  'Sudan',
  'Togo',
  'Tunisia',
  'United Arab Emirates',
];

export const rescheduleReasons = [
  'Rescheduled due to pending permission.',
  'Rescheduled due to weather conditions.',
  'Rescheduled due to site access issues.',
  'Other',
];

export const RATING_FIELDS = [
  { label: 'Overall Experience', key: 'overallRating' },
  { label: 'Data Uploading on Platform', key: 'fileUploading' },
  { label: 'Clarity of Work Instructions', key: 'missionInstruction' },
  { label: 'Communication & Support', key: 'communication' },
];

export const CLIENT_RATING_FIELDS = [
  { label: 'How happy are you with your overall experience for this order?', key: 'overAllExperience' },
  { label: 'How would you rate the quality of the service you received?', key: 'qualityOfService' },
  { label: 'How would you rate the quality of the data you received?', key: 'qualityOfData' },
  { label: 'Do you feel the price you paid for this order was a good value for money?', key: 'valueForMoney' },
];

export const archiveReason = [
  'Client thought quote too high',
  'Client chose another data provider/solution',
  'Client didn’t win deal with end client',
  'Client has postponed the project',
  'Project information incorrect. Order needs to be resubmitted.',
  'Globhe failed to deliver before deadline or according to requirements.',
  'Globhe test order',
  'Other',
];
export const EMPTY_STRING = '';

export const EMPTY_P_TAG = '<p></p>';

export const EMPTY_P_BR_TAG = '<p><br></p>';
export const PROJECT = 'project';

export const TWO_DAYS_IN_MS = 2 * 86400000;
export const ONE_DAY_IN_MS = 86400000;

export const COLUMNS = {
  project: [
    { id: 'projectName', label: 'Project Name', align: 'left', field: 'normal', sort: false },
    { id: 'dateCreated', label: 'Date Created', align: 'left', field: 'normal', sort: false },
    { id: 'status', label: 'Status', align: 'left', field: 'projectStatus', sort: false },
  ],
  mission: [
    { id: 'id', label: 'Mission Id', align: 'left', field: 'normal', sort: false },
    { id: 'missionName', label: 'Mission Name', align: 'left', field: 'normal', sort: false },
    { id: 'dateCreated', label: 'Date Created', align: 'left', field: 'normal', sort: false },
    { id: 'status', label: 'Status', align: 'left', field: 'status', sort: false, custom: true },
  ],
};

export const TITLES = {
  project: 'IN PROGRESS RECURRENT PROJECTS',
  mission: 'IN PROGRESS RECURRENT MISSIONS',
};

export const EMPTY_MESSAGES = {
  project: 'No created recurring projects found.',
  mission: 'No created recurring missions found.',
};

export const LOADING_TIMEOUT_MS = 1000;

export const flightPermissionStatusLabels = {
  denied: 'denied',
  pending: 'pending',
  reapplied: 'reapplied',
};
export const MAX_BID_LIMIT = 200000;

// V2 platform cutover (see src/hooks/useV1AccessMode.js and src/services/v1AccessMode.js).
export const V1_ACCESS_MODES = {
  off: 'off',
  notice: 'notice',
  enforced: 'enforced',
};
export const V1_ACCESS_CHECK_ENDPOINT = '/api/public/settings/v1-access';
export const V1_ACCESS_POLL_INTERVAL_MS = 5 * 60 * 1000;
export const V1_ACCESS_REQUEST_TIMEOUT_MS = 5000;

/** Must stay in step with V1_BYPASS_PARAM in the V2 frontend. */
export const V1_BYPASS_PARAM = 'keepV1';
export const V1_BYPASS_STORAGE_KEY = 'globhe.keepV1';

export const V1_MIGRATION_NOTICE_DISMISSED_KEY = 'globhe.v1MigrationNoticeDismissedAt';
export const V1_MIGRATION_NOTICE_DISMISS_TTL_MS = 24 * 60 * 60 * 1000;
export const V1_MIGRATION_COUNTDOWN_SECONDS = 15;
